let today = new Date();

export default [
    {
        toDos: [],
        contactsFetched: true,
        locationsFetched: true,
        locations: [
            {
                role: "location",
                contacts: [
                    {
                        tenantId: "f48f259e-37d9-4003-be97-7181858b98aa",
                        userId: "87da40f6-7074-494f-b04f-b6f779b51c8b",
                    },
                ],
                vendorCategory: "location",
                userId: "location1647368561067",
                tenantId: "f48f259e-37d9-4003-be97-7181858b98aa",
                associatedEvents: [
                    {
                        key: {
                            tenantId: "f48f259e-37d9-4003-be97-7181858b98aa",
                            userId: "event1649788277666",
                        },
                        role: "location",
                    },
                    {
                        key: {
                            tenantId: "f48f259e-37d9-4003-be97-7181858b98aa",
                            userId: "event1649788567110",
                        },
                        role: "location",
                    },
                    {
                        key: {
                            tenantId: "f48f259e-37d9-4003-be97-7181858b98aa",
                            userId: "event1649788723748",
                        },
                        role: "location",
                    },
                    {
                        key: {
                            tenantId: "f48f259e-37d9-4003-be97-7181858b98aa",
                            userId: "event1649788971974",
                        },
                        role: "location",
                    },
                    {
                        key: {
                            tenantId: "f48f259e-37d9-4003-be97-7181858b98aa",
                            userId: "event1649789298650",
                        },
                        role: "location",
                    },
                    {
                        key: {
                            tenantId: "f48f259e-37d9-4003-be97-7181858b98aa",
                            userId: "event1649789298650",
                        },
                        role: "location",
                    },
                    {
                        key: {
                            tenantId: "f48f259e-37d9-4003-be97-7181858b98aa",
                            userId: "event1649789510007",
                        },
                        role: "location",
                    },
                    {
                        key: {
                            tenantId: "f48f259e-37d9-4003-be97-7181858b98aa",
                            userId: "event1649789696173",
                        },
                        role: "location",
                    },
                    {
                        key: {
                            tenantId: "f48f259e-37d9-4003-be97-7181858b98aa",
                            userId: "event1649789901628",
                        },
                        role: "location",
                    },
                    {
                        key: {
                            tenantId: "f48f259e-37d9-4003-be97-7181858b98aa",
                            userId: "event1649863798490",
                        },
                        role: "location",
                    },
                    {
                        key: {
                            tenantId: "f48f259e-37d9-4003-be97-7181858b98aa",
                            userId: "event1649864026900",
                        },
                        role: "location",
                    },
                    {
                        key: {
                            tenantId: "f48f259e-37d9-4003-be97-7181858b98aa",
                            userId: "event1649864140838",
                        },
                        role: "location",
                    },
                    {
                        key: {
                            tenantId: "f48f259e-37d9-4003-be97-7181858b98aa",
                            userId: "event1647368940289",
                        },
                    },
                    {
                        key: {
                            tenantId: "f48f259e-37d9-4003-be97-7181858b98aa",
                            userId: "event1647368940289",
                        },
                    },
                    {
                        key: {
                            tenantId: "f48f259e-37d9-4003-be97-7181858b98aa",
                            userId: "event1647365654337",
                        },
                    },
                    {
                        key: {
                            tenantId: "f48f259e-37d9-4003-be97-7181858b98aa",
                            userId: "event1647365654337",
                        },
                    },
                    {
                        key: {
                            tenantId: "f48f259e-37d9-4003-be97-7181858b98aa",
                            userId: "event1647365654337",
                        },
                    },
                    {
                        key: {
                            tenantId: "f48f259e-37d9-4003-be97-7181858b98aa",
                            userId: "event1656024754673",
                        },
                        role: "location",
                    },
                    {
                        key: {
                            tenantId: "f48f259e-37d9-4003-be97-7181858b98aa",
                            userId: "event1656025310336",
                        },
                        role: "location",
                    },
                    {
                        key: {
                            tenantId: "f48f259e-37d9-4003-be97-7181858b98aa",
                            userId: "event1664556591573",
                        },
                        role: "location",
                    },
                    {
                        key: {
                            userId: "event1664569210019",
                        },
                        role: "location",
                    },
                    {
                        key: {
                            tenantId: "f48f259e-37d9-4003-be97-7181858b98aa",
                            userId: "event1664569326945",
                        },
                        role: "location",
                    },
                ],
                address: {
                    streetAddress1: "891 5th Avenue",
                    streetAddress2: "",
                    cityStateZip: "New York, NY,  10018",
                },
                name: "Avengers Compound",
            },
            {
                role: "location",
                vendorCategory: "location",
                userId: "location1647369358982",
                tenantId: "f48f259e-37d9-4003-be97-7181858b98aa",
                associatedEvents: [
                    "event1647368940289",
                    {
                        key: {
                            tenantId: "f48f259e-37d9-4003-be97-7181858b98aa",
                            userId: "event1647368940289",
                        },
                    },
                    {
                        key: {
                            tenantId: "f48f259e-37d9-4003-be97-7181858b98aa",
                            userId: "event1647365654337",
                        },
                    },
                    {
                        key: {
                            tenantId: "f48f259e-37d9-4003-be97-7181858b98aa",
                            userId: "event1647365654337",
                        },
                    },
                    {
                        key: {
                            tenantId: "f48f259e-37d9-4003-be97-7181858b98aa",
                            userId: "event1647365654337",
                        },
                    },
                    {
                        key: {
                            tenantId: "f48f259e-37d9-4003-be97-7181858b98aa",
                            userId: "event1647365654337",
                        },
                    },
                    {
                        key: {
                            tenantId: "f48f259e-37d9-4003-be97-7181858b98aa",
                            userId: "event1647365654337",
                        },
                    },
                ],
                address: {
                    streetAddress1: "12345 Lehigh Dr",
                    streetAddress2: "",
                    cityStateZip: "Piscataway, NJ, 08854",
                },
                name: "Camp Lehigh",
            },
        ],
        eventId: "event" + (Date.now() - 20000),
        contacts: [
            {
                phoneNumber: "1234567894",
                role: "client",
                userId: "3666df24-41b5-47b9-a157-7cdb54ce4056",
                notes: [
                    {
                        date: "2022-12-09T17:03:35.927Z",
                        body: "This is a note, Steven",
                        tenant: "f48f259e-37d9-4003-be97-7181858b98aa",
                    },
                ],
                tenantId: "f48f259e-37d9-4003-be97-7181858b98aa",
                given_name: "Steve",
                createdAt: "2022-03-15T18:36:00.846Z",
                family_name: "Rogers",
                associatedEvents: [
                    "event1647368940289",
                    {
                        key: {
                            tenantId: "f48f259e-37d9-4003-be97-7181858b98aa",
                            userId: "event1649788277666",
                        },
                        role: "client",
                    },
                ],
                username: "steve.rogers@simplecitysoftware.com",
                email: "steve.rogers@simplecitysoftware.com",
            },
            {
                phoneNumber: "1234567894",
                tenantId: "f48f259e-37d9-4003-be97-7181858b98aa",
                given_name: "Natasha",
                createdAt: "2022-03-15T18:51:48.425Z",
                family_name: "Romanoff",
                email: "natasha.romanoff@simplecitysoftware.com",
                conversations: [
                    {
                        id: "1656107697256",
                        sortKey: "f48f259e-37d9-4003-be97-7181858b98aa",
                    },
                ],
                role: "client",
                pronoun: "Ms",
                profilePicture:
                    "https://spindjappstorage140016-prod.s3.amazonaws.com/public/f48f259e-37d9-4003-be97-7181858b98aa1656113561338",
                userId: "978df7f1-893b-46ae-8764-6be7d3f5f642",
                associatedEvents: [
                    "event1647370125074",
                    {
                        key: {
                            tenantId: "f48f259e-37d9-4003-be97-7181858b98aa",
                            userId: "event1649788277666",
                        },
                        role: "client",
                    },
                    {
                        key: {
                            tenantId: "f48f259e-37d9-4003-be97-7181858b98aa",
                            userId: "event1647368940289",
                        },
                        role: "client",
                    },
                    {
                        key: {
                            tenantId: "f48f259e-37d9-4003-be97-7181858b98aa",
                            userId: "event1656092345238",
                        },
                        role: "client",
                    },
                ],
                username: "natasha.romanoff@simplecitysoftware.com",
            },
            {
                phoneNumber: "1234567894",
                vendorCategory: "Decor/Florist",
                tenantId: "f48f259e-37d9-4003-be97-7181858b98aa",
                given_name: "Rachel",
                createdAt: "2022-03-15T18:28:34.745Z",
                family_name: "Green",
                email: "rachel.green@simplecitysoftware.com",
                role: "vendor",
                pronoun: "Ms.",
                userId: "e03471c1-1a6f-4bca-944a-e9d298a79a22",
                associatedEvents: [
                    {
                        key: {
                            tenantId: "f48f259e-37d9-4003-be97-7181858b98aa",
                            userId: "event1647368940289",
                        },
                        role: "vendor",
                    },
                ],
                username: "rachel.green@simplecitysoftware.com",
            },
        ],
        contracts: [
            {
                contractBody:
                    "WITNESSETH NOW THEREFORE\n\nA {invoice-deposit-amount} non-refundable security deposit is required when booking your event. This deposit is deducted from your total event cost and will show in your invoice statement. In consideration of the payment by {client-list}, (hereafter referred to as the Purchaser(s)) of {invoice-total} as well as the various promises and the agreements set forth below, the Parties agree and intend to be legally bound as follows:<br/><br/>\n\n 1. Lauryn Cole Investments, LLC DBA {business-name}, hereafter referred to as 'The DJ Service' shall provide up to {event-length} for the Purchaser(s) at the agreed upon venue(s) ({location-list}).<br/><br/>\n\n 2. The DJ Service, referenced in Paragraph 1, shall be provided and accepted on the entered date and time of the engagement.\n<br/><br/>\n 3. The DJ Service, referenced in Paragraph 1 shall consist primarily of providing musical entertainment by means of a downloaded MP3 music format.\n<br/><br/>\n 4. The DJ Service shall, at all times, have unmitigated control of its DJ Services.\n<br/><br/>\n 5. In the event that additional hours of DJ Services are requested after the finish time this agreement is executed, and The DJ Service accepts said request, additional DJ Services will be charged at the rate of $100 per hour, payable the day of the engagement.The parties understand and agree that it may not always be possible to provide additional performance time; The DJ Service is under no obligation to accept an offer to purchase additional hours of DJ Services.\n<br/><br/>\n\nADDITIONAL TERMS AND CONDITIONS:<br/><br/>\n\n\nThe agreement of the DJ to perform is subject to proven detention by accidents, transportation issues, riots, strikes, epidemics, any random acts of God, or any other legitimate conditions beyond their control. If such issues arise, all reasonable efforts will be made by The DJ Service to make it to the event or find replacement at the agreed upon fees. Should The DJ Service be unable to procure a replacement, Purchaser shall receive a full refund. Purchaser(s) agree that The DJ Service's liability shall not be liable in any amount of damage which exceeds the performance fee(s) recited above. Further, the Purchaser(s) agree that The DJ Service shall not be liable for indirect or consequential damages arising from any breach of contract. It is understood that, in the unlikely event that The DJ Service subcontracts services for your event and any liability issues or breach of this contract occurs, the subcontractor is the responsible party. The DJ Service is not responsible for the subcontracted services provided, equipment, or performance of services. Any and all issues, court costs, attorney fees and legal damages are the responsibility of the subcontractor, not The DJ Service. The Purchaser(s) and The DJ Service agree that this contract is not subject to cancellation unless both parties have agreed to such cancellation in writing. In the event of cancellation by the Purchaser(s) within 60 days of their event date, the Purchaser(s) shall pay the DJ the amount of $300.00 as liquidated damages, plus a reasonable attorney’s fee. If the Purchaser(s) cancel the event within 30 days of the set event date, the Purchaser(s) shall pay the The DJ Service the total agreed amount set forth on the contract as liquidated damages, lose their security deposit, plus a reasonable attorney’s fee. It is further agreed that the Purchaser shall be liable for any and all injury or damage to the The DJ Service, or property of The DJ Service, while on the premises of said engagement, if damage is caused by Purchaser or guest, members of his organization, engagement invitees, employees, or any other party in attendance, whether invited or not. It is understood that if this is a Rain or Shine event; The DJ Service‘s compensation is in no way affected by inclement weather. For outdoor performances, Purchaser shall provide overhead shelter for setup area. The DJ reserves the right, in good faith, to stop or cancel the performance should the weather pose a potential danger to him, the equipment, or audience. every effort will be made to continue the performance. However, safety is paramount in all decisions. The DJ’s compensation will not be affected by such cancellation.In the event of circumstances deemed to present a threat or implied threat of injury or harm The DJ Service staff or any equipment in  The DJ Service possession, The DJ Service reserves the right to cease performance. If the Purchaser is able to resolve the threatening situation in a reasonable amount of time (maximum of 15 minutes), The DJ Service shall resume performance in accordance with the original terms of this agreement. Purchaser shall be responsible for payment in full, regardless of whether the situation is resolved or whether  The DJ Service resumes performance. In order to prevent equipment damage or liability arising from accidental injury to any individual attending this performance,  The DJ Servicereserves the right to deny any guest access to the sound system, music recordings, or other equipment. Purchaser shall provide  The DJ Service with safe and appropriate working conditions. This includes a 10-foot by 10-foot area for setup, space for setting up speakers and lighting stands. The DJ Service requires a minimum of one 15-20-amp circuit outlet from a reliable power source within 25 feet (along the wall) of the set-up area. This circuit must be free of all other connected loads. Any delay in the performance or damage to DJ’s equipment due to improper power is the responsibility of the purchaser. Two circuits are preferred, where possible. Additional outlets on separate circuits for lighting (if contracted for) are required. Purchaser shall provide crowd control if warranted; and furnishing directions to place of engagement. Purchaser is responsible for paying any charges imposed by the venue. These charges may include, but are not limited to, parking and use of electric power. A written event/music planner or music request list must be received from the Purchaser and forwarded to The DJ Service not less than 1 month prior to the date of the engagement for it to be included in The DJ Service programming outline. The DJ Service will attempt to play Purchaser’s and Purchaser’s guests’ music requests, conditioned upon availability. In the event of non-payment,  The DJ Service retains the right to attempt collection through the courts. Purchaser agrees to be held responsible for all court costs, legal fees, and collection costs incurred by  The DJ Service. Purchaser shall be charged $30 for each returned check. It is agreed that Missouri law shall control all aspects of this Agreement. Purchasers agree to make all necessary arrangements to provide the DJ with access to the event venue not less than 2 hours before the engagement and 1 hour after the engagement for setup and takedown.  The DJ Service also requests ramp or elevator access between the parking/service entrance and the setup area. If Purchaser or venue requires  The DJ Service to complete setup more than 2 hours before the start time, or to postpone takedown more than 1 hour after the end time indicated, the additional time will be charged at the rate of $100.00 per hour.\n\n\nSPECIAL PROVISIONS AND SERVICES REQUESTED\n\n\nBy executing this contract as Purchaser, the person executing said contract, either individually, or as an agent or representative, represents and warrants that he or she is eighteen (18) years of age, and further, if executing said contract as agent or representative, that he or she has the authority to enter into this agreement and should he or she not have such authority, he or she personally accepts and assumes full responsibility and liability under the terms of this contract. This document, together with any attachments initialed by the parties, shall constitute THE ENTIRE AGREEMENT of the parties. If any part of this contract is illegal or unenforceable, the remaining provisions of this contract will remain valid and enforceable as to both parties. Again, this document contains the entire agreement between the parties and no statement, promises, or inducements made by any party hereto, or agent or representative or either party hereto, which are not contained in this written contract, shall be valid or binding. This contract shall not be enlarged, modified, or altered except in writing by both parties and endorsed hereon. The laws of the State of Missouri shall govern this agreement. In the event that legal proceedings are initiated by either party, it is agreed that proper venue shall be in St. Charles County. Purchaser(s) agree to indemnify, defend, assume liability for and hold The DJ Company harmless from any claims, damages, losses and expenses by or to any person, regardless of the basis, which pertains directly or indirectly to The DJ Company’s performance. In the event that a civil action arises in an effort to enforce any provision of this agreement, the losing party shall pay the attorney’s fee and court costs of the prevailing party. Purchaser(s) may not transfer or assign this contract to another party without the prior written consent of The DJ Company . THE PARTIES acknowledge that they have read the above Agreement in its entirety, understand all of its terms and conditions, have had an opportunity to review the same with legal counsel, and agree to abide by the terms of this agreement of his/her own free will and consent.",
                signerUUID: "3485aeba-48c2-4aee-be1e-1f7217cd4e21",
                admin: {},
                contractName: "Standard DJ Contract",
                id: "contract1642442940375",
                signerDate: "2022-05-04T22:06:34.903Z",
                signerName: "Michelle Braswell",
                status: "signed",
            },
            {
                contractBody:
                    "Signer First Name: {given_name}\nSigner Last Name: {family_name}\nEvent Start Time: {event-start-time}\nEvent End Time: {event-end-time}\nEvent Length: {event-length}\nEvent Date: {event-date}\nEvent Title: {event-title}\nInvoice Total: {invoice-total}\nInvoice Subtotal: {invoice-subtotal}\nInvoice Adjustments: {invoice-adjustments}\nInvoice Final Payment Due: {invoice-final-payment-due}\nInvoice Deposit Amount: {invoice-deposit-amount}\nClient List: {client-list}\nLocation List: {location-list}\nBusiness Name: {business-name}",
                contractName: "Merge Tag Test",
                id: "contract1649954176561",
            },
        ],
        data: {
            date: new Date(today.getFullYear(), today.getMonth(), today.getDate() + 3, 18, 0),
            startTime: new Date(today.getFullYear(), today.getMonth(), today.getDate() + 3, 18, 0),
            endTime: new Date(today.getFullYear(), today.getMonth(), today.getDate() + 3, 21, 0),
        },
        userId: "event" + (Date.now() - 20000),
        tenantId: "f48f259e-37d9-4003-be97-7181858b98aa",
        forms: [
            {
                name: "Music Preferences",
                description: "Give me your preferences for music for the day! ",
                id: "form1642369072870",
                fields: [
                    {
                        name: "Music Preferences",
                        fields: [
                            {
                                options: [],
                                inputTitle: "Favorite Genres",
                                inputType: "text",
                                placeholder: "Rock, Hip-Hop, Raffi",
                            },
                        ],
                        inputQuantity: "1",
                    },
                ],
            },
            {
                name: "Grand Entrance Members:",
                description:
                    "Enter all of the members of the grand entrance as they'll walk in!",
                id: "form1642440335065",
                fields: [
                    {
                        name: "Person(s):",
                        duplicable: true,
                        inputQuantity: "1",
                        fields: [
                            {
                                options: [],
                                inputTitle: "Name(s):",
                                inputType: "text",
                                placeholder: "John Smith and Mary Smith",
                            },
                        ],
                    },
                ],
            },
            {
                name: "My Questions",
                fields: [
                    {
                        name: "Questions",
                        duplicable: false,
                        inputQuantity: "1",
                        fields: [
                            {
                                options: [
                                    {
                                        optionValue: "Yes",
                                    },
                                    {
                                        optionValue: "No",
                                    },
                                ],
                                inputTitle: "Can I Take Requests?",
                                inputType: "select",
                                optionQuantity: "2",
                            },
                        ],
                    },
                    {
                        name: "Name",
                        duplicable: false,
                        inputQuantity: "2",
                        fields: [
                            {
                                options: [],
                                inputTitle:
                                    "Text Area With a really long title for steve ekkjlkjlkn",
                                inputType: "textarea",
                                placeholder: "kjhgfd",
                            },
                            {
                                options: [],
                                inputTitle: "Also Text Area",
                                inputType: "textarea",
                                placeholder: "luyhjkl",
                            },
                        ],
                    },
                ],
                id: "form1643924159717",
            },
            {
                name: "Ceremony",
                description: "Playlist for wedding ceremony",
                id: "form1642440310328",
                fields: [
                    {
                        name: "Bride Entrance",
                        duplicable: true,
                        fields: [
                            {
                                options: [],
                                inputTitle: "Song Title",
                                inputType: "text",
                                placeholder: "Title",
                            },
                            {
                                options: [],
                                inputTitle: "Song Artist",
                                inputType: "text",
                                placeholder: "Artist",
                            },
                            {
                                options: [],
                                inputTitle: "Notes",
                                inputType: "text",
                                placeholder: "Notes",
                            },
                        ],
                        libraryEnabled: true,
                    },
                    {
                        name: "Processional",
                        duplicable: true,
                        fields: [
                            {
                                options: [],
                                inputTitle: "Song Title",
                                inputType: "text",
                                placeholder: "Title",
                            },
                            {
                                options: [],
                                inputTitle: "Song Artist",
                                inputType: "text",
                                placeholder: "Artist",
                            },
                            {
                                options: [],
                                inputTitle: "Notes",
                                inputType: "text",
                                placeholder: "Notes",
                            },
                        ],
                        libraryEnabled: true,
                    },
                    {
                        name: "Interlude",
                        duplicable: false,
                        fields: [
                            {
                                options: [],
                                inputTitle: "Song Title",
                                inputType: "text",
                                placeholder: "Title",
                            },
                            {
                                options: [],
                                inputTitle: "Song Artist",
                                inputType: "text",
                                placeholder: "Artist",
                            },
                            {
                                options: [],
                                inputTitle: "Notes",
                                inputType: "text",
                                placeholder: "Notes",
                            },
                        ],
                        libraryEnabled: true,
                    },
                    {
                        name: "Recessional",
                        duplicable: false,
                        fields: [
                            {
                                options: [],
                                inputTitle: "Song Title",
                                inputType: "text",
                                placeholder: "Title",
                            },
                            {
                                options: [],
                                inputTitle: "Song Artist",
                                inputType: "text",
                                placeholder: "Artist",
                            },
                            {
                                options: [],
                                inputTitle: "Notes",
                                inputType: "text",
                                placeholder: "Notes",
                            },
                        ],
                        libraryEnabled: true,
                    },
                    {
                        name: "Custom Song",
                        duplicable: true,
                        fields: [
                            {
                                options: [],
                                inputTitle: "Song Title",
                                inputType: "text",
                                placeholder: "Title",
                            },
                            {
                                options: [],
                                inputTitle: "Song Artist",
                                inputType: "text",
                                placeholder: "Artist",
                            },
                            {
                                options: [],
                                inputTitle: "Notes",
                                inputType: "text",
                                placeholder: "Notes",
                            },
                        ],
                        libraryEnabled: true,
                    },
                    {
                        name: "Groom Entrance",
                        duplicable: true,
                        fields: [
                            {
                                options: [],
                                inputTitle: "Song Title:",
                                inputType: "text",
                                placeholder: "Title",
                            },
                            {
                                options: [],
                                inputTitle: "Song Artist:",
                                inputType: "text",
                                placeholder: "Artist",
                            },
                            {
                                options: [],
                                inputTitle: "Notes:",
                                inputType: "text",
                                placeholder: "Notes:",
                            },
                        ],
                        libraryEnabled: true,
                    },
                ],
            },
            {
                name: "Wedding Reception",
                description:
                    "The big celebration! This is the form for the wedding reception.",
                id: "form1642435090229",
                fields: [
                    {
                        name: "Grand Entrance:",
                        duplicable: true,
                        libraryMatch: {
                            Artist: "Jagged Edge featuring Nelly",
                            "Track Count": "5",
                            "Track Type": "File",
                            "Disc Number": "1",
                            "Bit Rate": "256",
                            Size: "8293882",
                            "Disc Count": "1",
                            Album: "Where the Party At - EP",
                            Purchased: "",
                            "Date Modified": "2020-09-26T15:19:41Z",
                            Name: "Where the Party At (feat. Nelly) [LP Mix featuring Nelly]",
                            "Album Artist": "Jagged Edge",
                            "Sample Rate": "44100",
                            Kind: "Purchased AAC audio file",
                            Normalization: "4191",
                            "Sort Album": "Where the Party At - EP",
                            Composer:
                                "Nelly, Jermaine Dupri, Brandon Casey, Bryan-Michael Cox & Brian Casey",
                            "Persistent ID": "18243CFC0FBC0D9B",
                            "Track ID": "12289",
                            "Date Added": "2021-08-18T03:59:43Z",
                            "Sort Artist": "Jagged Edge featuring Nelly",
                            "File Folder Count": "5",
                            "Total Time": "234066",
                            "Library Folder Count": "1",
                            "Track Number": "1",
                            Year: "2001",
                            Genre: "R&B/Soul",
                            "Release Date": "2001-05-14T07:00:00Z",
                            "Sort Name":
                                "Where the Party At (feat. Nelly) [LP Mix featuring Nelly]",
                            Location:
                                "file:///Volumes/Song%20Backup%20Storage/iTunes/iTunes%20Media/Music/Jagged%20Edge/Where%20the%20Party%20At%20-%20EP/01%20Where%20the%20Party%20At%20(feat.%20Nelly)%20%5BLP%20Mix%20featuring%20Nelly%5D.m4a",
                        },
                        fields: [
                            {
                                options: [],
                                inputTitle: "Song Title:",
                                inputType: "text",
                                placeholder: "Title",
                                value:
                                    "Where the Party At (feat. Nelly) [LP Mix featuring Nelly]",
                            },
                            {
                                options: [],
                                inputTitle: "Song Artist:",
                                inputType: "text",
                                placeholder: "Artist",
                                value: "Jagged Edge featuring Nelly",
                            },
                            {
                                options: [],
                                inputTitle: "Notes:",
                                inputType: "text",
                                placeholder: "Notes:",
                            },
                        ],
                        libraryEnabled: true,
                    },
                    {
                        name: "First Dance",
                        duplicable: false,
                        fields: [
                            {
                                options: [],
                                inputTitle: "Song Title:",
                                inputType: "text",
                                placeholder: "Title",
                            },
                            {
                                options: [],
                                inputTitle: "Song Artist:",
                                inputType: "text",
                                placeholder: "Artist",
                            },
                            {
                                options: [],
                                inputTitle: "Notes:",
                                inputType: "text",
                                placeholder: "Notes:",
                            },
                        ],
                        libraryEnabled: true,
                    },
                    {
                        name: "Bride and Parent Dance:",
                        duplicable: true,
                        fields: [
                            {
                                options: [],
                                inputTitle: "Song Title:",
                                inputType: "text",
                                placeholder: "Title",
                            },
                            {
                                options: [],
                                inputTitle: "Song Artist:",
                                inputType: "text",
                                placeholder: "Artist",
                            },
                            {
                                options: [],
                                inputTitle: "Relation and Name:",
                                inputType: "text",
                                placeholder: "Relation and Name",
                            },
                        ],
                        libraryEnabled: true,
                    },
                    {
                        name: "Groom and Parent Dance:",
                        duplicable: true,
                        fields: [
                            {
                                options: [],
                                inputTitle: "Song Title:",
                                inputType: "text",
                                placeholder: "Title",
                            },
                            {
                                options: [],
                                inputTitle: "Song Artist:",
                                inputType: "text",
                                placeholder: "Artist",
                            },
                            {
                                options: [],
                                inputTitle: "Relation and Name:",
                                inputType: "text",
                                placeholder: "Relation and Name",
                            },
                        ],
                        libraryEnabled: true,
                    },
                    {
                        name: "Bouquet Toss:",
                        duplicable: false,
                        fields: [
                            {
                                options: [],
                                inputTitle: "Song Title:",
                                inputType: "text",
                                placeholder: "Title",
                            },
                            {
                                options: [],
                                inputTitle: "Song Artist:",
                                inputType: "text",
                                placeholder: "Artist",
                            },
                            {
                                options: [],
                                inputTitle: "Notes:",
                                inputType: "text",
                                placeholder: "Notes:",
                            },
                        ],
                        libraryEnabled: true,
                    },
                    {
                        name: "Garter Toss:",
                        duplicable: false,
                        fields: [
                            {
                                options: [],
                                inputTitle: "Song Title:",
                                inputType: "text",
                                placeholder: "Title",
                            },
                            {
                                options: [],
                                inputTitle: "Song Artist:",
                                inputType: "text",
                                placeholder: "Artist",
                            },
                            {
                                options: [],
                                inputTitle: "Notes:",
                                inputType: "text",
                                placeholder: "Notes:",
                            },
                        ],
                        libraryEnabled: true,
                    },
                    {
                        name: "Cake Cutting:",
                        duplicable: false,
                        fields: [
                            {
                                options: [],
                                inputTitle: "Song Title:",
                                inputType: "text",
                                placeholder: "Title",
                            },
                            {
                                options: [],
                                inputTitle: "Song Artist:",
                                inputType: "text",
                                placeholder: "Artist",
                            },
                            {
                                options: [],
                                inputTitle: "Notes:",
                                inputType: "text",
                                placeholder: "Notes:",
                            },
                        ],
                        libraryEnabled: true,
                    },
                    {
                        name: "Custom Song:",
                        duplicable: true,
                        fields: [
                            {
                                options: [],
                                inputTitle: "Song Title:",
                                inputType: "text",
                                placeholder: "Title",
                            },
                            {
                                options: [],
                                inputTitle: "Song Artist:",
                                inputType: "text",
                                placeholder: "Artist",
                            },
                            {
                                options: [],
                                inputTitle: "Notes:",
                                inputType: "text",
                                placeholder: "Notes:",
                            },
                        ],
                        libraryEnabled: true,
                    },
                ],
            },
            {
                name: "Song Requests",
                description: "Give me your must plays!",
                id: "form1642378126707",
                fields: [
                    {
                        name: "Song:",
                        duplicable: true,
                        fields: [
                            {
                                options: [],
                                inputTitle: "Song Title:",
                                inputType: "text",
                                placeholder: "Title",
                            },
                            {
                                options: [],
                                inputTitle: "Song Artist:",
                                inputType: "text",
                                placeholder: "Artist",
                            },
                            {
                                options: [],
                                inputTitle: "Notes:",
                                inputType: "text",
                                placeholder: "Notes:",
                            },
                        ],
                        libraryEnabled: true,
                    },
                ],
            },
            {
                name: "Do Not Play",
                description: "Give me all the songs you HATE!",
                id: "form1642378681111",
                fields: [
                    {
                        name: "Song:",
                        duplicable: true,
                        fields: [
                            {
                                options: [],
                                inputTitle: "Song Title:",
                                inputType: "text",
                                placeholder: "Title",
                            },
                            {
                                options: [],
                                inputTitle: "Song Artist:",
                                inputType: "text",
                                placeholder: "Artist",
                            },
                            {
                                options: [],
                                inputTitle: "Notes:",
                                inputType: "text",
                                placeholder: "Notes:",
                            },
                        ],
                        libraryEnabled: true,
                    },
                ],
            },
        ],
        invoice: {
            adjustments: [],
            payments: [],
            products: [
                {
                    employeesRequired: 1,
                    priceOption: "Hourly",
                    equipmentNeeded: [],
                    name: "Wedding DJ",
                    photo:
                        "https://spindjappstorage140016-prod.s3.amazonaws.com/public/7e9b6fe0-0b16-4076-8171-a399992d876b1642443008952",
                    id: "service1642440375825",
                    contracts: ["contract1642442940375"],
                    type: "Service",
                    pricing: {
                        addHourly: 10000,
                        baseTime: 4,
                        baseRate: 150000,
                    },
                    forms: [
                        "form1642369072870",
                        "form1642378126707",
                        "form1642378681111",
                        "form1642440310328",
                        "form1642440335065",
                        "form1642435090229",
                    ],
                },
            ],
        },
        title: "Steven's Party",
    },
    {
        toDos: [],
        contactsFetched: true,
        locationsFetched: true,
        locations: [
            {
                role: "location",
                vendorCategory: "location",
                userId: "location1647369804285",
                tenantId: "f48f259e-37d9-4003-be97-7181858b98aa",
                associatedEvents: [
                    "event1647369651738",
                    "event1648139729075",
                    {
                        key: {
                            tenantId: "f48f259e-37d9-4003-be97-7181858b98aa",
                            userId: "event1648092418637",
                        },
                    },
                    {
                        key: {
                            tenantId: "f48f259e-37d9-4003-be97-7181858b98aa",
                            userId: "event1647368940289",
                        },
                    },
                    {
                        key: {
                            tenantId: "f48f259e-37d9-4003-be97-7181858b98aa",
                            userId: "event1656092345238",
                        },
                        role: "location",
                    },
                    {
                        tenantId: "f48f259e-37d9-4003-be97-7181858b98aa",
                        userId: "event1647369651738",
                    },
                    {
                        tenantId: "f48f259e-37d9-4003-be97-7181858b98aa",
                        userId: "event1647369651738",
                    },
                    {
                        tenantId: "f48f259e-37d9-4003-be97-7181858b98aa",
                        userId: "event1647369651738",
                    },
                    {
                        tenantId: "f48f259e-37d9-4003-be97-7181858b98aa",
                        userId: "event1647369651738",
                    },
                    {
                        tenantId: "f48f259e-37d9-4003-be97-7181858b98aa",
                        userId: "event1647369651738",
                    },
                    {
                        tenantId: "f48f259e-37d9-4003-be97-7181858b98aa",
                        userId: "event1647369651738",
                    },
                    {
                        tenantId: "f48f259e-37d9-4003-be97-7181858b98aa",
                        userId: "event1647369651738",
                    },
                ],
                address: {
                    streetAddress1: "12345 Anywhere Rd",
                    cityStateZip: "Anywhere, MO, 12345",
                },
                name: "Barton's Barn",
            },
        ],
        eventId: "event1647369651738",
        contacts: [
            {
                phoneNumber: "1234567894",
                tenants: ["7e9b6fe0-0b16-4076-8171-a399992d876b"],
                vendorCategory: "Decor/Florist",
                tenantId: "f48f259e-37d9-4003-be97-7181858b98aa",
                given_name: "Peter",
                createdAt: "2022-03-15T18:15:38.906Z",
                family_name: "Parker",
                email: "peter.parker@simplecitysoftware.com",
                conversations: [
                    {
                        id: "1656116593540",
                        sortKey: "f48f259e-37d9-4003-be97-7181858b98aa",
                    },
                ],
                role: "vendor",
                pronoun: "Mr.",
                profilePicture:
                    "https://spindjappstorage140016-prod.s3.amazonaws.com/public/f48f259e-37d9-4003-be97-7181858b98aa1656116885967",
                userId: "de8abc34-2c29-4aef-ad71-26187c82fe11",
                associatedEvents: [
                    "event1647369651738",
                    {
                        key: {
                            tenantId: "f48f259e-37d9-4003-be97-7181858b98aa",
                            userId: "event1648165291492",
                        },
                        role: "vendor",
                    },
                    {
                        key: {
                            tenantId: "7e9b6fe0-0b16-4076-8171-a399992d876b",
                            userId: "event1643075534547",
                        },
                        role: "vendor",
                    },
                    {
                        key: {
                            tenantId: "f48f259e-37d9-4003-be97-7181858b98aa",
                            userId: "event1647365654337",
                        },
                        role: "vendor",
                    },
                    {
                        key: {
                            tenantId: "f48f259e-37d9-4003-be97-7181858b98aa",
                            userId: "event1649788567110",
                        },
                        role: "vendor",
                    },
                ],
                username: "peter.parker@simplecitysoftware.com",
            },
            {
                phoneNumber: "8529637410",
                tenants: ["7e9b6fe0-0b16-4076-8171-a399992d876b"],
                tenantId: "f48f259e-37d9-4003-be97-7181858b98aa",
                given_name: "David",
                createdAt: "2022-03-15T18:10:49.941Z",
                family_name: "Rose",
                email: "david.rose@simplecitysoftware.com",
                conversations: [
                    {
                        id: "1654283307410",
                        sortKey: "f48f259e-37d9-4003-be97-7181858b98aa",
                    },
                ],
                role: "employee",
                pronoun: "Mr.",
                profilePicture:
                    "https://spindjappstorage140016-prod.s3.amazonaws.com/public/f48f259e-37d9-4003-be97-7181858b98aa1656116210127",
                userId: "41e7998a-deda-4ec5-8968-09976708aa6a",
                associatedEvents: [
                    "event1647369651738",
                    {
                        key: {
                            tenantId: "f48f259e-37d9-4003-be97-7181858b98aa",
                            userId: "event1647369651738",
                        },
                        role: "employee",
                    },
                    {
                        key: {
                            tenantId: "f48f259e-37d9-4003-be97-7181858b98aa",
                            userId: "event1648165291492",
                        },
                        role: "employee",
                    },
                    {
                        key: {
                            tenantId: "7e9b6fe0-0b16-4076-8171-a399992d876b",
                            userId: "event1643075534547",
                        },
                        role: "employee",
                    },
                    {
                        key: {
                            tenantId: "f48f259e-37d9-4003-be97-7181858b98aa",
                            userId: "event1647365654337",
                        },
                        role: "employee",
                    },
                    {
                        key: {
                            tenantId: "f48f259e-37d9-4003-be97-7181858b98aa",
                            userId: "event1671849029874",
                        },
                        role: "client",
                    },
                ],
                username: "david.rose@simplecitysoftware.com",
            },
            {
                phoneNumber: "1234567894",
                tenantId: "f48f259e-37d9-4003-be97-7181858b98aa",
                given_name: "Tony",
                createdAt: "2022-03-15T18:22:41.622Z",
                family_name: "Stark",
                email: "tony.stark@simplecitysoftware.com",
                conversations: [
                    {
                        id: "1655489927039",
                        sortKey: "f48f259e-37d9-4003-be97-7181858b98aa",
                    },
                ],
                role: "client",
                pronoun: "Mr.",
                profilePicture:
                    "https://spindjappstorage140016-prod.s3.amazonaws.com/public/f48f259e-37d9-4003-be97-7181858b98aa1656115623113",
                userId: "87da40f6-7074-494f-b04f-b6f779b51c8b",
                associatedEvents: [
                    {
                        key: {
                            tenantId: "f48f259e-37d9-4003-be97-7181858b98aa",
                            userId: "event1648165291492",
                        },
                        role: "client",
                    },
                    {
                        key: {
                            tenantId: "f48f259e-37d9-4003-be97-7181858b98aa",
                            userId: "event1649788567110",
                        },
                        role: "client",
                    },
                    {
                        key: {
                            tenantId: "f48f259e-37d9-4003-be97-7181858b98aa",
                            userId: "event1649788723748",
                        },
                        role: "client",
                    },
                    {
                        key: {
                            tenantId: "f48f259e-37d9-4003-be97-7181858b98aa",
                            userId: "event1649788971974",
                        },
                        role: "client",
                    },
                    {
                        key: {
                            tenantId: "f48f259e-37d9-4003-be97-7181858b98aa",
                            userId: "event1649789298650",
                        },
                        role: "client",
                    },
                    {
                        key: {
                            tenantId: "f48f259e-37d9-4003-be97-7181858b98aa",
                            userId: "event1649789298650",
                        },
                        role: "client",
                    },
                    {
                        key: {
                            tenantId: "f48f259e-37d9-4003-be97-7181858b98aa",
                            userId: "event1649789510007",
                        },
                        role: "client",
                    },
                    {
                        key: {
                            tenantId: "f48f259e-37d9-4003-be97-7181858b98aa",
                            userId: "event1649789696173",
                        },
                        role: "client",
                    },
                    {
                        key: {
                            tenantId: "f48f259e-37d9-4003-be97-7181858b98aa",
                            userId: "event1649789901628",
                        },
                        role: "client",
                    },
                    {
                        key: {
                            tenantId: "f48f259e-37d9-4003-be97-7181858b98aa",
                            userId: "event1649863798490",
                        },
                        role: "client",
                    },
                    {
                        key: {
                            tenantId: "f48f259e-37d9-4003-be97-7181858b98aa",
                            userId: "event1649864026900",
                        },
                        role: "client",
                    },
                    {
                        key: {
                            tenantId: "f48f259e-37d9-4003-be97-7181858b98aa",
                            userId: "event1649864140838",
                        },
                        role: "client",
                    },
                    {
                        key: {
                            tenantId: "f48f259e-37d9-4003-be97-7181858b98aa",
                            userId: "event1647365654337",
                        },
                        role: "client",
                    },
                    {
                        key: {
                            tenantId: "f48f259e-37d9-4003-be97-7181858b98aa",
                            userId: "event1664556591573",
                        },
                        role: "client",
                    },
                    {
                        key: {
                            tenantId: "f48f259e-37d9-4003-be97-7181858b98aa",
                            userId: "event1647369651738",
                        },
                        role: "client",
                    },
                    {
                        key: {
                            tenantId: "f48f259e-37d9-4003-be97-7181858b98aa",
                            userId: "event1649788277666",
                        },
                        role: "client",
                    },
                ],
                username: "tony.stark@simplecitysoftware.com",
            },
            {
                phoneNumber: "6362124414",
                tenants: ["f48f259e-37d9-4003-be97-7181858b98aa"],
                role: "client",
                userId: "bd0631a4-b0f2-4d88-8034-81b758b84ac8",
                tenantId: "f48f259e-37d9-4003-be97-7181858b98aa",
                given_name: "Deandra",
                createdAt: "2022-10-04T22:11:42.467Z",
                family_name: "Reynold",
                associatedEvents: [
                    {
                        key: {
                            tenantId: "f48f259e-37d9-4003-be97-7181858b98aa",
                            userId: "event1664921500977",
                        },
                        role: "client",
                    },
                    {
                        key: {
                            tenantId: "f48f259e-37d9-4003-be97-7181858b98aa",
                            userId: "event1664923381026",
                        },
                        role: "client",
                    },
                    {
                        key: {
                            tenantId: "f48f259e-37d9-4003-be97-7181858b98aa",
                            userId: "event1647369651738",
                        },
                        role: "client",
                    },
                ],
                username: "dee.reynolds@simplecitysoftware.com",
                email: "dee.reynolds@simplecitysoftware.com",
            },
            null,
        ],
        contracts: [
            {
                contractBody:
                    " WITNESSETH NOW THEREFORE\n\nA {invoice-deposit-amount} non-refundable security deposit is required when booking your event. This deposit is deducted from your total event cost and will show in your invoice statement. In consideration of the payment by {client-list}, (hereafter referred to as the Purchaser(s)) of {invoice-total} as well as the various promises and the agreements set forth below, the Parties agree and intend to be legally bound as follows:<br/><br/>\n\n 1. Lauryn Cole Investments, LLC DBA {business-name}, hereafter referred to as 'The DJ Service' shall provide up to {event-length} for the Purchaser(s) at the agreed upon venue(s) ({location-list}).<br/><br/>\n\n 2. The DJ Service, referenced in Paragraph 1, shall be provided and accepted on the entered date and time of the engagement.\n<br/><br/>\n 3. The DJ Service, referenced in Paragraph 1 shall consist primarily of providing musical entertainment by means of a downloaded MP3 music format.\n<br/><br/>\n 4. The DJ Service shall, at all times, have unmitigated control of its DJ Services.\n<br/><br/>\n 5. In the event that additional hours of DJ Services are requested after the finish time this agreement is executed, and The DJ Service accepts said request, additional DJ Services will be charged at the rate of $100 per hour, payable the day of the engagement.The parties understand and agree that it may not always be possible to provide additional performance time; The DJ Service is under no obligation to accept an offer to purchase additional hours of DJ Services.\n<br/><br/>\n\nADDITIONAL TERMS AND CONDITIONS:<br/><br/>\n\n\nThe agreement of the DJ to perform is subject to proven detention by accidents, transportation issues, riots, strikes, epidemics, any random acts of God, or any other legitimate conditions beyond their control. If such issues arise, all reasonable efforts will be made by The DJ Service to make it to the event or find replacement at the agreed upon fees. Should The DJ Service be unable to procure a replacement, Purchaser shall receive a full refund. Purchaser(s) agree that The DJ Service's liability shall not be liable in any amount of damage which exceeds the performance fee(s) recited above. Further, the Purchaser(s) agree that The DJ Service shall not be liable for indirect or consequential damages arising from any breach of contract. It is understood that, in the unlikely event that The DJ Service subcontracts services for your event and any liability issues or breach of this contract occurs, the subcontractor is the responsible party. The DJ Service is not responsible for the subcontracted services provided, equipment, or performance of services. Any and all issues, court costs, attorney fees and legal damages are the responsibility of the subcontractor, not The DJ Service. The Purchaser(s) and The DJ Service agree that this contract is not subject to cancellation unless both parties have agreed to such cancellation in writing. In the event of cancellation by the Purchaser(s) within 60 days of their event date, the Purchaser(s) shall pay the DJ the amount of $300.00 as liquidated damages, plus a reasonable attorney’s fee. If the Purchaser(s) cancel the event within 30 days of the set event date, the Purchaser(s) shall pay the The DJ Service the total agreed amount set forth on the contract as liquidated damages, lose their security deposit, plus a reasonable attorney’s fee. It is further agreed that the Purchaser shall be liable for any and all injury or damage to the The DJ Service, or property of The DJ Service, while on the premises of said engagement, if damage is caused by Purchaser or guest, members of his organization, engagement invitees, employees, or any other party in attendance, whether invited or not. It is understood that if this is a Rain or Shine event; The DJ Service‘s compensation is in no way affected by inclement weather. For outdoor performances, Purchaser shall provide overhead shelter for setup area. The DJ reserves the right, in good faith, to stop or cancel the performance should the weather pose a potential danger to him, the equipment, or audience. every effort will be made to continue the performance. However, safety is paramount in all decisions. The DJ’s compensation will not be affected by such cancellation.In the event of circumstances deemed to present a threat or implied threat of injury or harm The DJ Service staff or any equipment in  The DJ Service possession, The DJ Service reserves the right to cease performance. If the Purchaser is able to resolve the threatening situation in a reasonable amount of time (maximum of 15 minutes), The DJ Service shall resume performance in accordance with the original terms of this agreement. Purchaser shall be responsible for payment in full, regardless of whether the situation is resolved or whether  The DJ Service resumes performance. In order to prevent equipment damage or liability arising from accidental injury to any individual attending this performance,  The DJ Servicereserves the right to deny any guest access to the sound system, music recordings, or other equipment. Purchaser shall provide  The DJ Service with safe and appropriate working conditions. This includes a 10-foot by 10-foot area for setup, space for setting up speakers and lighting stands. The DJ Service requires a minimum of one 15-20-amp circuit outlet from a reliable power source within 25 feet (along the wall) of the set-up area. This circuit must be free of all other connected loads. Any delay in the performance or damage to DJ’s equipment due to improper power is the responsibility of the purchaser. Two circuits are preferred, where possible. Additional outlets on separate circuits for lighting (if contracted for) are required. Purchaser shall provide crowd control if warranted; and furnishing directions to place of engagement. Purchaser is responsible for paying any charges imposed by the venue. These charges may include, but are not limited to, parking and use of electric power. A written event/music planner or music request list must be received from the Purchaser and forwarded to The DJ Service not less than 1 month prior to the date of the engagement for it to be included in The DJ Service programming outline. The DJ Service will attempt to play Purchaser’s and Purchaser’s guests’ music requests, conditioned upon availability. In the event of non-payment,  The DJ Service retains the right to attempt collection through the courts. Purchaser agrees to be held responsible for all court costs, legal fees, and collection costs incurred by  The DJ Service. Purchaser shall be charged $30 for each returned check. It is agreed that Missouri law shall control all aspects of this Agreement. Purchasers agree to make all necessary arrangements to provide the DJ with access to the event venue not less than 2 hours before the engagement and 1 hour after the engagement for setup and takedown.  The DJ Service also requests ramp or elevator access between the parking/service entrance and the setup area. If Purchaser or venue requires  The DJ Service to complete setup more than 2 hours before the start time, or to postpone takedown more than 1 hour after the end time indicated, the additional time will be charged at the rate of $100.00 per hour.\n\n\nSPECIAL PROVISIONS AND SERVICES REQUESTED\n\n\nBy executing this contract as Purchaser, the person executing said contract, either individually, or as an agent or representative, represents and warrants that he or she is eighteen (18) years of age, and further, if executing said contract as agent or representative, that he or she has the authority to enter into this agreement and should he or she not have such authority, he or she personally accepts and assumes full responsibility and liability under the terms of this contract. This document, together with any attachments initialed by the parties, shall constitute THE ENTIRE AGREEMENT of the parties. If any part of this contract is illegal or unenforceable, the remaining provisions of this contract will remain valid and enforceable as to both parties. Again, this document contains the entire agreement between the parties and no statement, promises, or inducements made by any party hereto, or agent or representative or either party hereto, which are not contained in this written contract, shall be valid or binding. This contract shall not be enlarged, modified, or altered except in writing by both parties and endorsed hereon. The laws of the State of Missouri shall govern this agreement. In the event that legal proceedings are initiated by either party, it is agreed that proper venue shall be in St. Charles County. Purchaser(s) agree to indemnify, defend, assume liability for and hold The DJ Company harmless from any claims, damages, losses and expenses by or to any person, regardless of the basis, which pertains directly or indirectly to The DJ Company’s performance. In the event that a civil action arises in an effort to enforce any provision of this agreement, the losing party shall pay the attorney’s fee and court costs of the prevailing party. Purchaser(s) may not transfer or assign this contract to another party without the prior written consent of The DJ Company . THE PARTIES acknowledge that they have read the above Agreement in its entirety, understand all of its terms and conditions, have had an opportunity to review the same with legal counsel, and agree to abide by the terms of this agreement of his/her own free will and consent.",
                signerUUID: "b351c34f-3217-49a3-83d7-b5134ac73b7c",
                admin: {},
                contractName: "Standard DJ Contract",
                id: "contract1642442940375",
                signerDate: "2022-03-18T18:34:05.592Z",
                signerName: "Bruce Banner",
                status: "signed",
            },
        ],
        data: {
            date: new Date(today.getFullYear(), today.getMonth() + 1, today.getDate() + 15, 12, 30),
            startTime: new Date(today.getFullYear(), today.getMonth() + 1, today.getDate() + 15, 12, 0),
            endTime: new Date(today.getFullYear(), today.getMonth() + 1, today.getDate() + 15, 20, 0),
        },
        userId: "event1647369651738",
        tenantId: "f48f259e-37d9-4003-be97-7181858b98aa",
        forms: [
            {
                name: "Music Preferences",
                description: "Give me your preferences for music for the day! ",
                id: "form1642369072870",
                fields: [
                    {
                        name: "Music Preferences",
                        fields: [
                            {
                                options: [],
                                inputTitle: "Favorite Genres",
                                inputType: "text",
                                placeholder: "Rock, Hip-Hop, Raffi",
                            },
                        ],
                        inputQuantity: "1",
                    },
                ],
            },
            {
                name: "Song Requests",
                description: "Give me your must plays!",
                id: "form1642378126707",
                fields: [
                    {
                        name: "Song:",
                        fields: [
                            {
                                options: [],
                                inputTitle: "Song Title:",
                                inputType: "text",
                                placeholder: "Title",
                            },
                            {
                                options: [],
                                inputTitle: "Song Artist:",
                                inputType: "text",
                                placeholder: "Artist",
                            },
                            {
                                options: [],
                                inputTitle: "Notes:",
                                inputType: "text",
                                placeholder: "Notes:",
                            },
                        ],
                        duplicable: true,
                    },
                ],
            },
            {
                name: "Do Not Play",
                description: "Give me all the songs you HATE!",
                id: "form1642378681111",
                fields: [
                    {
                        name: "Song:",
                        fields: [
                            {
                                options: [],
                                inputTitle: "Song Title:",
                                inputType: "text",
                                placeholder: "Title",
                            },
                            {
                                options: [],
                                inputTitle: "Song Artist:",
                                inputType: "text",
                                placeholder: "Artist",
                            },
                            {
                                options: [],
                                inputTitle: "Notes:",
                                inputType: "text",
                                placeholder: "Notes:",
                            },
                        ],
                        duplicable: true,
                    },
                ],
            },
        ],
        invoice: {
            adjustments: [
                {
                    name: "Friends and Family",
                    amount: 0.25,
                    type: "percentage",
                    display: "25%",
                },
                {
                    name: "$200 Off",
                    amount: 20000,
                    type: "dollar",
                    display: "$200.00",
                },
            ],
            payments: [
                {
                    name: null,
                    amount: 0,
                },
            ],
            products: [
                {
                    employeesRequired: 1,
                    priceOption: "Hourly",
                    equipmentNeeded: [],
                    name: "Weekday Charity DJ",
                    id: "service1644173191009",
                    contracts: ["contract1642442940375"],
                    type: "Service",
                    pricing: {
                        addHourly: 10000,
                        baseTime: 4,
                        baseRate: 55000,
                    },
                    forms: [
                        "form1642369072870",
                        "form1642378126707",
                        "form1642378681111",
                    ],
                },
                {
                    employeesRequired: 1,
                    priceOption: "Hourly",
                    equipmentNeeded: [],
                    name: "Wedding DJ",
                    photo:
                        "https://spindjappstorage140016-prod.s3.amazonaws.com/public/7e9b6fe0-0b16-4076-8171-a399992d876b1642443008952",
                    id: "service1642440375825",
                    contracts: ["contract1642442940375"],
                    type: "Service",
                    pricing: {
                        addHourly: 10000,
                        baseTime: 4,
                        baseRate: 150000,
                    },
                    forms: [
                        "form1642369072870",
                        "form1642378126707",
                        "form1642378681111",
                        "form1642440310328",
                        "form1642440335065",
                        "form1642435090229",
                    ],
                },
                {
                    name: "Uplighting",
                    id: "addOn1643080302220",
                    priceOption: "Unit",
                    units: 20,
                    type: "Add-On",
                    pricing: {
                        minUnits: 12,
                        unitRate: 3000,
                        units: 12,
                    },
                },
            ],
        },
        title: "Bruce Banner's Remission Celebration",
    },
    {
        toDos: [],
        contactsFetched: true,
        locationsFetched: true,
        locations: [
            {
                role: "location",
                vendorCategory: "location",
                userId: "location1647370307888",
                tenantId: "f48f259e-37d9-4003-be97-7181858b98aa",
                associatedEvents: [
                    "event1647370125074",
                    {
                        key: {
                            tenantId: "f48f259e-37d9-4003-be97-7181858b98aa",
                            userId: "event1647368940289",
                        },
                    },
                    {
                        key: {
                            tenantId: "f48f259e-37d9-4003-be97-7181858b98aa",
                            userId: "event1647368940289",
                        },
                    },
                ],
                address: {
                    streetAddress1: "Raboche-Krest'yanskaya Ulitsa, 18, ",
                    cityStateZip: "Volgograd, Volgograd Oblast, Russia, 400074",
                },
                name: "Sky Room",
            },
        ],
        eventId: "event1647370125074",
        contacts: [
            {
                phoneNumber: "1234567894",
                tenantId: "f48f259e-37d9-4003-be97-7181858b98aa",
                given_name: "Natasha",
                createdAt: "2022-03-15T18:51:48.425Z",
                family_name: "Romanoff",
                email: "natasha.romanoff@simplecitysoftware.com",
                conversations: [
                    {
                        id: "1656107697256",
                        sortKey: "f48f259e-37d9-4003-be97-7181858b98aa",
                    },
                ],
                role: "client",
                pronoun: "Ms",
                profilePicture:
                    "https://spindjappstorage140016-prod.s3.amazonaws.com/public/f48f259e-37d9-4003-be97-7181858b98aa1656113561338",
                userId: "978df7f1-893b-46ae-8764-6be7d3f5f642",
                associatedEvents: [
                    "event1647370125074",
                    {
                        key: {
                            tenantId: "f48f259e-37d9-4003-be97-7181858b98aa",
                            userId: "event1649788277666",
                        },
                        role: "client",
                    },
                    {
                        key: {
                            tenantId: "f48f259e-37d9-4003-be97-7181858b98aa",
                            userId: "event1647368940289",
                        },
                        role: "client",
                    },
                    {
                        key: {
                            tenantId: "f48f259e-37d9-4003-be97-7181858b98aa",
                            userId: "event1656092345238",
                        },
                        role: "client",
                    },
                ],
                username: "natasha.romanoff@simplecitysoftware.com",
            },
        ],
        contracts: [
            {
                contractBody:
                    " WITNESSETH NOW THEREFORE\n\nA {invoice-deposit-amount} non-refundable security deposit is required when booking your event. This deposit is deducted from your total event cost and will show in your invoice statement. In consideration of the payment by {client-list}, (hereafter referred to as the Purchaser(s)) of {invoice-total} as well as the various promises and the agreements set forth below, the Parties agree and intend to be legally bound as follows:<br/><br/>\n\n 1. Lauryn Cole Investments, LLC DBA {business-name}, hereafter referred to as 'The DJ Service' shall provide up to {event-length} for the Purchaser(s) at the agreed upon venue(s) ({location-list}).<br/><br/>\n\n 2. The DJ Service, referenced in Paragraph 1, shall be provided and accepted on the entered date and time of the engagement.\n<br/><br/>\n 3. The DJ Service, referenced in Paragraph 1 shall consist primarily of providing musical entertainment by means of a downloaded MP3 music format.\n<br/><br/>\n 4. The DJ Service shall, at all times, have unmitigated control of its DJ Services.\n<br/><br/>\n 5. In the event that additional hours of DJ Services are requested after the finish time this agreement is executed, and The DJ Service accepts said request, additional DJ Services will be charged at the rate of $100 per hour, payable the day of the engagement.The parties understand and agree that it may not always be possible to provide additional performance time; The DJ Service is under no obligation to accept an offer to purchase additional hours of DJ Services.\n<br/><br/>\n\nADDITIONAL TERMS AND CONDITIONS:<br/><br/>\n\n\nThe agreement of the DJ to perform is subject to proven detention by accidents, transportation issues, riots, strikes, epidemics, any random acts of God, or any other legitimate conditions beyond their control. If such issues arise, all reasonable efforts will be made by The DJ Service to make it to the event or find replacement at the agreed upon fees. Should The DJ Service be unable to procure a replacement, Purchaser shall receive a full refund. Purchaser(s) agree that The DJ Service's liability shall not be liable in any amount of damage which exceeds the performance fee(s) recited above. Further, the Purchaser(s) agree that The DJ Service shall not be liable for indirect or consequential damages arising from any breach of contract. It is understood that, in the unlikely event that The DJ Service subcontracts services for your event and any liability issues or breach of this contract occurs, the subcontractor is the responsible party. The DJ Service is not responsible for the subcontracted services provided, equipment, or performance of services. Any and all issues, court costs, attorney fees and legal damages are the responsibility of the subcontractor, not The DJ Service. The Purchaser(s) and The DJ Service agree that this contract is not subject to cancellation unless both parties have agreed to such cancellation in writing. In the event of cancellation by the Purchaser(s) within 60 days of their event date, the Purchaser(s) shall pay the DJ the amount of $300.00 as liquidated damages, plus a reasonable attorney’s fee. If the Purchaser(s) cancel the event within 30 days of the set event date, the Purchaser(s) shall pay the The DJ Service the total agreed amount set forth on the contract as liquidated damages, lose their security deposit, plus a reasonable attorney’s fee. It is further agreed that the Purchaser shall be liable for any and all injury or damage to the The DJ Service, or property of The DJ Service, while on the premises of said engagement, if damage is caused by Purchaser or guest, members of his organization, engagement invitees, employees, or any other party in attendance, whether invited or not. It is understood that if this is a Rain or Shine event; The DJ Service‘s compensation is in no way affected by inclement weather. For outdoor performances, Purchaser shall provide overhead shelter for setup area. The DJ reserves the right, in good faith, to stop or cancel the performance should the weather pose a potential danger to him, the equipment, or audience. every effort will be made to continue the performance. However, safety is paramount in all decisions. The DJ’s compensation will not be affected by such cancellation.In the event of circumstances deemed to present a threat or implied threat of injury or harm The DJ Service staff or any equipment in  The DJ Service possession, The DJ Service reserves the right to cease performance. If the Purchaser is able to resolve the threatening situation in a reasonable amount of time (maximum of 15 minutes), The DJ Service shall resume performance in accordance with the original terms of this agreement. Purchaser shall be responsible for payment in full, regardless of whether the situation is resolved or whether  The DJ Service resumes performance. In order to prevent equipment damage or liability arising from accidental injury to any individual attending this performance,  The DJ Servicereserves the right to deny any guest access to the sound system, music recordings, or other equipment. Purchaser shall provide  The DJ Service with safe and appropriate working conditions. This includes a 10-foot by 10-foot area for setup, space for setting up speakers and lighting stands. The DJ Service requires a minimum of one 15-20-amp circuit outlet from a reliable power source within 25 feet (along the wall) of the set-up area. This circuit must be free of all other connected loads. Any delay in the performance or damage to DJ’s equipment due to improper power is the responsibility of the purchaser. Two circuits are preferred, where possible. Additional outlets on separate circuits for lighting (if contracted for) are required. Purchaser shall provide crowd control if warranted; and furnishing directions to place of engagement. Purchaser is responsible for paying any charges imposed by the venue. These charges may include, but are not limited to, parking and use of electric power. A written event/music planner or music request list must be received from the Purchaser and forwarded to The DJ Service not less than 1 month prior to the date of the engagement for it to be included in The DJ Service programming outline. The DJ Service will attempt to play Purchaser’s and Purchaser’s guests’ music requests, conditioned upon availability. In the event of non-payment,  The DJ Service retains the right to attempt collection through the courts. Purchaser agrees to be held responsible for all court costs, legal fees, and collection costs incurred by  The DJ Service. Purchaser shall be charged $30 for each returned check. It is agreed that Missouri law shall control all aspects of this Agreement. Purchasers agree to make all necessary arrangements to provide the DJ with access to the event venue not less than 2 hours before the engagement and 1 hour after the engagement for setup and takedown.  The DJ Service also requests ramp or elevator access between the parking/service entrance and the setup area. If Purchaser or venue requires  The DJ Service to complete setup more than 2 hours before the start time, or to postpone takedown more than 1 hour after the end time indicated, the additional time will be charged at the rate of $100.00 per hour.\n\n\nSPECIAL PROVISIONS AND SERVICES REQUESTED\n\n\nBy executing this contract as Purchaser, the person executing said contract, either individually, or as an agent or representative, represents and warrants that he or she is eighteen (18) years of age, and further, if executing said contract as agent or representative, that he or she has the authority to enter into this agreement and should he or she not have such authority, he or she personally accepts and assumes full responsibility and liability under the terms of this contract. This document, together with any attachments initialed by the parties, shall constitute THE ENTIRE AGREEMENT of the parties. If any part of this contract is illegal or unenforceable, the remaining provisions of this contract will remain valid and enforceable as to both parties. Again, this document contains the entire agreement between the parties and no statement, promises, or inducements made by any party hereto, or agent or representative or either party hereto, which are not contained in this written contract, shall be valid or binding. This contract shall not be enlarged, modified, or altered except in writing by both parties and endorsed hereon. The laws of the State of Missouri shall govern this agreement. In the event that legal proceedings are initiated by either party, it is agreed that proper venue shall be in St. Charles County. Purchaser(s) agree to indemnify, defend, assume liability for and hold The DJ Company harmless from any claims, damages, losses and expenses by or to any person, regardless of the basis, which pertains directly or indirectly to The DJ Company’s performance. In the event that a civil action arises in an effort to enforce any provision of this agreement, the losing party shall pay the attorney’s fee and court costs of the prevailing party. Purchaser(s) may not transfer or assign this contract to another party without the prior written consent of The DJ Company . THE PARTIES acknowledge that they have read the above Agreement in its entirety, understand all of its terms and conditions, have had an opportunity to review the same with legal counsel, and agree to abide by the terms of this agreement of his/her own free will and consent.",
                signerUUID: "f48f259e-37d9-4003-be97-7181858b98aa",
                admin: {
                    signerUUID: "f48f259e-37d9-4003-be97-7181858b98aa",
                    signerDate: "2022-03-18T17:40:28.738Z",
                    signerName: "Cole Coleman",
                    status: "signed",
                },
                contractName: "Standard DJ Contract",
                id: "contract1642442940375",
                signerDate: "2022-03-18T17:37:34.951Z",
                signerName: "Marked By Admin",
                status: "signed",
            },
            {
                admin: {
                    signerUUID: "f48f259e-37d9-4003-be97-7181858b98aa",
                    signerDate: "2022-03-19T15:30:27.265Z",
                    signerName: "Cole Coleman",
                    status: "signed",
                },
                contractName: "Just another contract",
                id: "contract1647617501362",
                contractBody: "<b>WAZZUP, MUTHAFUGGA</b>",
            },
        ],
        data: {
            date: new Date(today.getFullYear(), today.getMonth() + 4, today.getDate() + 11, 14, 0),
            startTime: new Date(today.getFullYear(), today.getMonth() + 4, today.getDate() + 11, 14, 0),
            endTime: new Date(today.getFullYear(), today.getMonth() + 4, today.getDate() + 11, 21, 30),
        },
        userId: "event1647370125074",
        tenantId: "f48f259e-37d9-4003-be97-7181858b98aa",
        forms: [
            {
                name: "Music Preferences",
                description: "Give me your preferences for music for the day! ",
                id: "form1642369072870",
                fields: [
                    {
                        name: "Music Preferences",
                        fields: [
                            {
                                options: [],
                                inputTitle: "Favorite Genres",
                                inputType: "text",
                                placeholder: "Rock, Hip-Hop, Raffi",
                            },
                        ],
                        inputQuantity: "1",
                    },
                ],
            },
            {
                name: "Song Requests",
                description: "Give me your must plays!",
                id: "form1642378126707",
                fields: [
                    {
                        name: "Song:",
                        fields: [
                            {
                                options: [],
                                inputTitle: "Song Title:",
                                inputType: "text",
                                placeholder: "Title",
                            },
                            {
                                options: [],
                                inputTitle: "Song Artist:",
                                inputType: "text",
                                placeholder: "Artist",
                            },
                            {
                                options: [],
                                inputTitle: "Notes:",
                                inputType: "text",
                                placeholder: "Notes:",
                            },
                        ],
                        duplicable: true,
                    },
                ],
            },
            {
                name: "Do Not Play",
                description: "Give me all the songs you HATE!",
                id: "form1642378681111",
                fields: [
                    {
                        name: "Song:",
                        fields: [
                            {
                                options: [],
                                inputTitle: "Song Title:",
                                inputType: "text",
                                placeholder: "Title",
                            },
                            {
                                options: [],
                                inputTitle: "Song Artist:",
                                inputType: "text",
                                placeholder: "Artist",
                            },
                            {
                                options: [],
                                inputTitle: "Notes:",
                                inputType: "text",
                                placeholder: "Notes:",
                            },
                        ],
                        duplicable: true,
                    },
                ],
            },
        ],
        invoice: {
            adjustments: [
                {
                    name: "Friends and Family",
                    amount: 0.25,
                    type: "percentage",
                    display: "25%",
                },
            ],
            payments: [],
            products: [
                {
                    employeesRequired: 1,
                    priceOption: "Hourly",
                    equipmentNeeded: [],
                    name: "Weekend Party DJ",
                    id: "service1645816493474",
                    contracts: ["contract1642442940375"],
                    type: "Service",
                    pricing: {
                        addHourly: 10000,
                        baseTime: 4,
                        baseRate: 140000,
                    },
                    forms: [
                        "form1642369072870",
                        "form1642378126707",
                        "form1642378681111",
                    ],
                },
            ],
        },
        title: "Natasha's Homecoming Welcome",
    },
    {
        toDos: [],
        contactsFetched: true,
        locationsFetched: true,
        locations: [
            {
                role: "location",
                contacts: [
                    {
                        tenantId: "f48f259e-37d9-4003-be97-7181858b98aa",
                        userId: "87da40f6-7074-494f-b04f-b6f779b51c8b",
                    },
                ],
                vendorCategory: "location",
                userId: "location1647368561067",
                tenantId: "f48f259e-37d9-4003-be97-7181858b98aa",
                associatedEvents: [
                    {
                        key: {
                            tenantId: "f48f259e-37d9-4003-be97-7181858b98aa",
                            userId: "event1649788277666",
                        },
                        role: "location",
                    },
                    {
                        key: {
                            tenantId: "f48f259e-37d9-4003-be97-7181858b98aa",
                            userId: "event1649788567110",
                        },
                        role: "location",
                    },
                    {
                        key: {
                            tenantId: "f48f259e-37d9-4003-be97-7181858b98aa",
                            userId: "event1649788723748",
                        },
                        role: "location",
                    },
                    {
                        key: {
                            tenantId: "f48f259e-37d9-4003-be97-7181858b98aa",
                            userId: "event1649788971974",
                        },
                        role: "location",
                    },
                    {
                        key: {
                            tenantId: "f48f259e-37d9-4003-be97-7181858b98aa",
                            userId: "event1649789298650",
                        },
                        role: "location",
                    },
                    {
                        key: {
                            tenantId: "f48f259e-37d9-4003-be97-7181858b98aa",
                            userId: "event1649789298650",
                        },
                        role: "location",
                    },
                    {
                        key: {
                            tenantId: "f48f259e-37d9-4003-be97-7181858b98aa",
                            userId: "event1649789510007",
                        },
                        role: "location",
                    },
                    {
                        key: {
                            tenantId: "f48f259e-37d9-4003-be97-7181858b98aa",
                            userId: "event1649789696173",
                        },
                        role: "location",
                    },
                    {
                        key: {
                            tenantId: "f48f259e-37d9-4003-be97-7181858b98aa",
                            userId: "event1649789901628",
                        },
                        role: "location",
                    },
                    {
                        key: {
                            tenantId: "f48f259e-37d9-4003-be97-7181858b98aa",
                            userId: "event1649863798490",
                        },
                        role: "location",
                    },
                    {
                        key: {
                            tenantId: "f48f259e-37d9-4003-be97-7181858b98aa",
                            userId: "event1649864026900",
                        },
                        role: "location",
                    },
                    {
                        key: {
                            tenantId: "f48f259e-37d9-4003-be97-7181858b98aa",
                            userId: "event1649864140838",
                        },
                        role: "location",
                    },
                    {
                        key: {
                            tenantId: "f48f259e-37d9-4003-be97-7181858b98aa",
                            userId: "event1647368940289",
                        },
                    },
                    {
                        key: {
                            tenantId: "f48f259e-37d9-4003-be97-7181858b98aa",
                            userId: "event1647368940289",
                        },
                    },
                    {
                        key: {
                            tenantId: "f48f259e-37d9-4003-be97-7181858b98aa",
                            userId: "event1647365654337",
                        },
                    },
                    {
                        key: {
                            tenantId: "f48f259e-37d9-4003-be97-7181858b98aa",
                            userId: "event1647365654337",
                        },
                    },
                    {
                        key: {
                            tenantId: "f48f259e-37d9-4003-be97-7181858b98aa",
                            userId: "event1647365654337",
                        },
                    },
                    {
                        key: {
                            tenantId: "f48f259e-37d9-4003-be97-7181858b98aa",
                            userId: "event1656024754673",
                        },
                        role: "location",
                    },
                    {
                        key: {
                            tenantId: "f48f259e-37d9-4003-be97-7181858b98aa",
                            userId: "event1656025310336",
                        },
                        role: "location",
                    },
                    {
                        key: {
                            tenantId: "f48f259e-37d9-4003-be97-7181858b98aa",
                            userId: "event1664556591573",
                        },
                        role: "location",
                    },
                    {
                        key: {
                            userId: "event1664569210019",
                        },
                        role: "location",
                    },
                    {
                        key: {
                            tenantId: "f48f259e-37d9-4003-be97-7181858b98aa",
                            userId: "event1664569326945",
                        },
                        role: "location",
                    },
                ],
                address: {
                    streetAddress1: "891 5th Avenue",
                    streetAddress2: "",
                    cityStateZip: "New York, NY,  10018",
                },
                name: "Avengers Compound",
            },
        ],
        contacts: [
            {
                phoneNumber: "1234567894",
                tenantId: "f48f259e-37d9-4003-be97-7181858b98aa",
                given_name: "Tony",
                createdAt: "2022-03-15T18:22:41.622Z",
                family_name: "Stark",
                email: "tony.stark@simplecitysoftware.com",
                conversations: [
                    {
                        id: "1655489927039",
                        sortKey: "f48f259e-37d9-4003-be97-7181858b98aa",
                    },
                ],
                role: "client",
                pronoun: "Mr.",
                profilePicture:
                    "https://spindjappstorage140016-prod.s3.amazonaws.com/public/f48f259e-37d9-4003-be97-7181858b98aa1656115623113",
                userId: "87da40f6-7074-494f-b04f-b6f779b51c8b",
                associatedEvents: [
                    {
                        key: {
                            tenantId: "f48f259e-37d9-4003-be97-7181858b98aa",
                            userId: "event1648165291492",
                        },
                        role: "client",
                    },
                    {
                        key: {
                            tenantId: "f48f259e-37d9-4003-be97-7181858b98aa",
                            userId: "event1649788567110",
                        },
                        role: "client",
                    },
                    {
                        key: {
                            tenantId: "f48f259e-37d9-4003-be97-7181858b98aa",
                            userId: "event1649788723748",
                        },
                        role: "client",
                    },
                    {
                        key: {
                            tenantId: "f48f259e-37d9-4003-be97-7181858b98aa",
                            userId: "event1649788971974",
                        },
                        role: "client",
                    },
                    {
                        key: {
                            tenantId: "f48f259e-37d9-4003-be97-7181858b98aa",
                            userId: "event1649789298650",
                        },
                        role: "client",
                    },
                    {
                        key: {
                            tenantId: "f48f259e-37d9-4003-be97-7181858b98aa",
                            userId: "event1649789298650",
                        },
                        role: "client",
                    },
                    {
                        key: {
                            tenantId: "f48f259e-37d9-4003-be97-7181858b98aa",
                            userId: "event1649789510007",
                        },
                        role: "client",
                    },
                    {
                        key: {
                            tenantId: "f48f259e-37d9-4003-be97-7181858b98aa",
                            userId: "event1649789696173",
                        },
                        role: "client",
                    },
                    {
                        key: {
                            tenantId: "f48f259e-37d9-4003-be97-7181858b98aa",
                            userId: "event1649789901628",
                        },
                        role: "client",
                    },
                    {
                        key: {
                            tenantId: "f48f259e-37d9-4003-be97-7181858b98aa",
                            userId: "event1649863798490",
                        },
                        role: "client",
                    },
                    {
                        key: {
                            tenantId: "f48f259e-37d9-4003-be97-7181858b98aa",
                            userId: "event1649864026900",
                        },
                        role: "client",
                    },
                    {
                        key: {
                            tenantId: "f48f259e-37d9-4003-be97-7181858b98aa",
                            userId: "event1649864140838",
                        },
                        role: "client",
                    },
                    {
                        key: {
                            tenantId: "f48f259e-37d9-4003-be97-7181858b98aa",
                            userId: "event1647365654337",
                        },
                        role: "client",
                    },
                    {
                        key: {
                            tenantId: "f48f259e-37d9-4003-be97-7181858b98aa",
                            userId: "event1664556591573",
                        },
                        role: "client",
                    },
                    {
                        key: {
                            tenantId: "f48f259e-37d9-4003-be97-7181858b98aa",
                            userId: "event1647369651738",
                        },
                        role: "client",
                    },
                    {
                        key: {
                            tenantId: "f48f259e-37d9-4003-be97-7181858b98aa",
                            userId: "event1649788277666",
                        },
                        role: "client",
                    },
                ],
                username: "tony.stark@simplecitysoftware.com",
            },
            {
                phoneNumber: "8529637410",
                tenants: ["7e9b6fe0-0b16-4076-8171-a399992d876b"],
                tenantId: "f48f259e-37d9-4003-be97-7181858b98aa",
                given_name: "David",
                createdAt: "2022-03-15T18:10:49.941Z",
                family_name: "Rose",
                email: "david.rose@simplecitysoftware.com",
                conversations: [
                    {
                        id: "1654283307410",
                        sortKey: "f48f259e-37d9-4003-be97-7181858b98aa",
                    },
                ],
                role: "employee",
                pronoun: "Mr.",
                profilePicture:
                    "https://spindjappstorage140016-prod.s3.amazonaws.com/public/f48f259e-37d9-4003-be97-7181858b98aa1656116210127",
                userId: "41e7998a-deda-4ec5-8968-09976708aa6a",
                associatedEvents: [
                    "event1647369651738",
                    {
                        key: {
                            tenantId: "f48f259e-37d9-4003-be97-7181858b98aa",
                            userId: "event1647369651738",
                        },
                        role: "employee",
                    },
                    {
                        key: {
                            tenantId: "f48f259e-37d9-4003-be97-7181858b98aa",
                            userId: "event1648165291492",
                        },
                        role: "employee",
                    },
                    {
                        key: {
                            tenantId: "7e9b6fe0-0b16-4076-8171-a399992d876b",
                            userId: "event1643075534547",
                        },
                        role: "employee",
                    },
                    {
                        key: {
                            tenantId: "f48f259e-37d9-4003-be97-7181858b98aa",
                            userId: "event1647365654337",
                        },
                        role: "employee",
                    },
                    {
                        key: {
                            tenantId: "f48f259e-37d9-4003-be97-7181858b98aa",
                            userId: "event1671849029874",
                        },
                        role: "client",
                    },
                ],
                username: "david.rose@simplecitysoftware.com",
            },
            {
                phoneNumber: "1234567894",
                tenants: ["7e9b6fe0-0b16-4076-8171-a399992d876b"],
                tenantId: "f48f259e-37d9-4003-be97-7181858b98aa",
                given_name: "Moira",
                createdAt: "2022-03-15T18:12:53.684Z",
                family_name: "Rose",
                businessName: null,
                email: "moira.rose@simplecitysoftware.com",
                conversations: [
                    {
                        id: "1654283369013",
                        sortKey: "f48f259e-37d9-4003-be97-7181858b98aa",
                    },
                ],
                role: "organizer",
                pronoun: null,
                userId: "8ded0046-2a00-4178-9804-3b20121091cd",
                associatedEvents: [
                    "event1647369651738",
                    {
                        key: {
                            tenantId: "f48f259e-37d9-4003-be97-7181858b98aa",
                            userId: "event1648165291492",
                        },
                        role: "organizer",
                    },
                    {
                        key: {
                            tenantId: "7e9b6fe0-0b16-4076-8171-a399992d876b",
                            userId: "event1643075534547",
                        },
                        role: "organizer",
                    },
                    {
                        key: {
                            tenantId: "f48f259e-37d9-4003-be97-7181858b98aa",
                            userId: "event1647365654337",
                        },
                        role: "organizer",
                    },
                ],
                username: "moira.rose@simplecitysoftware.com",
            },
            {
                phoneNumber: "1234567894",
                tenants: ["7e9b6fe0-0b16-4076-8171-a399992d876b"],
                vendorCategory: "Decor/Florist",
                tenantId: "f48f259e-37d9-4003-be97-7181858b98aa",
                given_name: "Peter",
                createdAt: "2022-03-15T18:15:38.906Z",
                family_name: "Parker",
                email: "peter.parker@simplecitysoftware.com",
                conversations: [
                    {
                        id: "1656116593540",
                        sortKey: "f48f259e-37d9-4003-be97-7181858b98aa",
                    },
                ],
                role: "vendor",
                pronoun: "Mr.",
                profilePicture:
                    "https://spindjappstorage140016-prod.s3.amazonaws.com/public/f48f259e-37d9-4003-be97-7181858b98aa1656116885967",
                userId: "de8abc34-2c29-4aef-ad71-26187c82fe11",
                associatedEvents: [
                    "event1647369651738",
                    {
                        key: {
                            tenantId: "f48f259e-37d9-4003-be97-7181858b98aa",
                            userId: "event1648165291492",
                        },
                        role: "vendor",
                    },
                    {
                        key: {
                            tenantId: "7e9b6fe0-0b16-4076-8171-a399992d876b",
                            userId: "event1643075534547",
                        },
                        role: "vendor",
                    },
                    {
                        key: {
                            tenantId: "f48f259e-37d9-4003-be97-7181858b98aa",
                            userId: "event1647365654337",
                        },
                        role: "vendor",
                    },
                    {
                        key: {
                            tenantId: "f48f259e-37d9-4003-be97-7181858b98aa",
                            userId: "event1649788567110",
                        },
                        role: "vendor",
                    },
                ],
                username: "peter.parker@simplecitysoftware.com",
            },
        ],
        contracts: [
            {
                contractBody:
                    " WITNESSETH NOW THEREFORE\n\nA {invoice-deposit-amount} non-refundable security deposit is required when booking your event. This deposit is deducted from your total event cost and will show in your invoice statement. In consideration of the payment by {client-list}, (hereafter referred to as the Purchaser(s)) of {invoice-total} as well as the various promises and the agreements set forth below, the Parties agree and intend to be legally bound as follows:<br/><br/>\n\n 1. Lauryn Cole Investments, LLC DBA {business-name}, hereafter referred to as 'The DJ Service' shall provide up to {event-length} for the Purchaser(s) at the agreed upon venue(s) ({location-list}).<br/><br/>\n\n 2. The DJ Service, referenced in Paragraph 1, shall be provided and accepted on the entered date and time of the engagement.\n<br/><br/>\n 3. The DJ Service, referenced in Paragraph 1 shall consist primarily of providing musical entertainment by means of a downloaded MP3 music format.\n<br/><br/>\n 4. The DJ Service shall, at all times, have unmitigated control of its DJ Services.\n<br/><br/>\n 5. In the event that additional hours of DJ Services are requested after the finish time this agreement is executed, and The DJ Service accepts said request, additional DJ Services will be charged at the rate of $100 per hour, payable the day of the engagement.The parties understand and agree that it may not always be possible to provide additional performance time; The DJ Service is under no obligation to accept an offer to purchase additional hours of DJ Services.\n<br/><br/>\n\nADDITIONAL TERMS AND CONDITIONS:<br/><br/>\n\n\nThe agreement of the DJ to perform is subject to proven detention by accidents, transportation issues, riots, strikes, epidemics, any random acts of God, or any other legitimate conditions beyond their control. If such issues arise, all reasonable efforts will be made by The DJ Service to make it to the event or find replacement at the agreed upon fees. Should The DJ Service be unable to procure a replacement, Purchaser shall receive a full refund. Purchaser(s) agree that The DJ Service's liability shall not be liable in any amount of damage which exceeds the performance fee(s) recited above. Further, the Purchaser(s) agree that The DJ Service shall not be liable for indirect or consequential damages arising from any breach of contract. It is understood that, in the unlikely event that The DJ Service subcontracts services for your event and any liability issues or breach of this contract occurs, the subcontractor is the responsible party. The DJ Service is not responsible for the subcontracted services provided, equipment, or performance of services. Any and all issues, court costs, attorney fees and legal damages are the responsibility of the subcontractor, not The DJ Service. The Purchaser(s) and The DJ Service agree that this contract is not subject to cancellation unless both parties have agreed to such cancellation in writing. In the event of cancellation by the Purchaser(s) within 60 days of their event date, the Purchaser(s) shall pay the DJ the amount of $300.00 as liquidated damages, plus a reasonable attorney’s fee. If the Purchaser(s) cancel the event within 30 days of the set event date, the Purchaser(s) shall pay the The DJ Service the total agreed amount set forth on the contract as liquidated damages, lose their security deposit, plus a reasonable attorney’s fee. It is further agreed that the Purchaser shall be liable for any and all injury or damage to the The DJ Service, or property of The DJ Service, while on the premises of said engagement, if damage is caused by Purchaser or guest, members of his organization, engagement invitees, employees, or any other party in attendance, whether invited or not. It is understood that if this is a Rain or Shine event; The DJ Service‘s compensation is in no way affected by inclement weather. For outdoor performances, Purchaser shall provide overhead shelter for setup area. The DJ reserves the right, in good faith, to stop or cancel the performance should the weather pose a potential danger to him, the equipment, or audience. every effort will be made to continue the performance. However, safety is paramount in all decisions. The DJ’s compensation will not be affected by such cancellation.In the event of circumstances deemed to present a threat or implied threat of injury or harm The DJ Service staff or any equipment in  The DJ Service possession, The DJ Service reserves the right to cease performance. If the Purchaser is able to resolve the threatening situation in a reasonable amount of time (maximum of 15 minutes), The DJ Service shall resume performance in accordance with the original terms of this agreement. Purchaser shall be responsible for payment in full, regardless of whether the situation is resolved or whether  The DJ Service resumes performance. In order to prevent equipment damage or liability arising from accidental injury to any individual attending this performance,  The DJ Servicereserves the right to deny any guest access to the sound system, music recordings, or other equipment. Purchaser shall provide  The DJ Service with safe and appropriate working conditions. This includes a 10-foot by 10-foot area for setup, space for setting up speakers and lighting stands. The DJ Service requires a minimum of one 15-20-amp circuit outlet from a reliable power source within 25 feet (along the wall) of the set-up area. This circuit must be free of all other connected loads. Any delay in the performance or damage to DJ’s equipment due to improper power is the responsibility of the purchaser. Two circuits are preferred, where possible. Additional outlets on separate circuits for lighting (if contracted for) are required. Purchaser shall provide crowd control if warranted; and furnishing directions to place of engagement. Purchaser is responsible for paying any charges imposed by the venue. These charges may include, but are not limited to, parking and use of electric power. A written event/music planner or music request list must be received from the Purchaser and forwarded to The DJ Service not less than 1 month prior to the date of the engagement for it to be included in The DJ Service programming outline. The DJ Service will attempt to play Purchaser’s and Purchaser’s guests’ music requests, conditioned upon availability. In the event of non-payment,  The DJ Service retains the right to attempt collection through the courts. Purchaser agrees to be held responsible for all court costs, legal fees, and collection costs incurred by  The DJ Service. Purchaser shall be charged $30 for each returned check. It is agreed that Missouri law shall control all aspects of this Agreement. Purchasers agree to make all necessary arrangements to provide the DJ with access to the event venue not less than 2 hours before the engagement and 1 hour after the engagement for setup and takedown.  The DJ Service also requests ramp or elevator access between the parking/service entrance and the setup area. If Purchaser or venue requires  The DJ Service to complete setup more than 2 hours before the start time, or to postpone takedown more than 1 hour after the end time indicated, the additional time will be charged at the rate of $100.00 per hour.\n\n\nSPECIAL PROVISIONS AND SERVICES REQUESTED\n\n\nBy executing this contract as Purchaser, the person executing said contract, either individually, or as an agent or representative, represents and warrants that he or she is eighteen (18) years of age, and further, if executing said contract as agent or representative, that he or she has the authority to enter into this agreement and should he or she not have such authority, he or she personally accepts and assumes full responsibility and liability under the terms of this contract. This document, together with any attachments initialed by the parties, shall constitute THE ENTIRE AGREEMENT of the parties. If any part of this contract is illegal or unenforceable, the remaining provisions of this contract will remain valid and enforceable as to both parties. Again, this document contains the entire agreement between the parties and no statement, promises, or inducements made by any party hereto, or agent or representative or either party hereto, which are not contained in this written contract, shall be valid or binding. This contract shall not be enlarged, modified, or altered except in writing by both parties and endorsed hereon. The laws of the State of Missouri shall govern this agreement. In the event that legal proceedings are initiated by either party, it is agreed that proper venue shall be in St. Charles County. Purchaser(s) agree to indemnify, defend, assume liability for and hold The DJ Company harmless from any claims, damages, losses and expenses by or to any person, regardless of the basis, which pertains directly or indirectly to The DJ Company’s performance. In the event that a civil action arises in an effort to enforce any provision of this agreement, the losing party shall pay the attorney’s fee and court costs of the prevailing party. Purchaser(s) may not transfer or assign this contract to another party without the prior written consent of The DJ Company . THE PARTIES acknowledge that they have read the above Agreement in its entirety, understand all of its terms and conditions, have had an opportunity to review the same with legal counsel, and agree to abide by the terms of this agreement of his/her own free will and consent.",
                signerUUID: "87da40f6-7074-494f-b04f-b6f779b51c8b",
                admin: {},
                contractName: "Standard DJ Contract",
                id: "contract1642442940375",
                signerDate: "2022-04-22T22:07:21.438Z",
                signerName: "Tony Stark",
                status: "signed",
            },
        ],
        data: {
            date: new Date(today.getFullYear(), today.getMonth() + 6, today.getDate() + 5, 12, 0),
            startTime: new Date(today.getFullYear(), today.getMonth() + 6, today.getDate() + 5, 12, 0),
            endTime: new Date(today.getFullYear(), today.getMonth() + 6, today.getDate() + 5, 17, 30),
        },
        userId: "event1648165291492",
        tenantId: "f48f259e-37d9-4003-be97-7181858b98aa",
        forms: [
            {
                name: "Music Preferences",
                description: "Give me your preferences for music for the day! ",
                id: "form1642369072870",
                fields: [
                    {
                        name: "Music Preferences",
                        fields: [
                            {
                                options: [],
                                inputTitle: "Favorite Genres",
                                inputType: "text",
                                placeholder: "Rock, Hip-Hop, Raffi",
                            },
                        ],
                        inputQuantity: "1",
                    },
                ],
            },
            {
                name: "Song Requests",
                description: "Give me your must plays!",
                id: "form1642378126707",
                fields: [
                    {
                        name: "Song:",
                        fields: [
                            {
                                options: [],
                                inputTitle: "Song Title:",
                                inputType: "text",
                                placeholder: "Title",
                            },
                            {
                                options: [],
                                inputTitle: "Song Artist:",
                                inputType: "text",
                                placeholder: "Artist",
                            },
                            {
                                options: [],
                                inputTitle: "Notes:",
                                inputType: "text",
                                placeholder: "Notes:",
                            },
                        ],
                        duplicable: true,
                    },
                ],
            },
            {
                name: "Do Not Play",
                description: "Give me all the songs you HATE!",
                id: "form1642378681111",
                fields: [
                    {
                        name: "Song:",
                        fields: [
                            {
                                options: [],
                                inputTitle: "Song Title:",
                                inputType: "text",
                                placeholder: "Title",
                            },
                            {
                                options: [],
                                inputTitle: "Song Artist:",
                                inputType: "text",
                                placeholder: "Artist",
                            },
                            {
                                options: [],
                                inputTitle: "Notes:",
                                inputType: "text",
                                placeholder: "Notes:",
                            },
                        ],
                        duplicable: true,
                    },
                ],
            },
            {
                name: "Ceremony:",
                description: "Playlist for wedding ceremony",
                id: "form1642440310328",
                fields: [
                    {
                        name: "Groom Entrance",
                        fields: [
                            {
                                options: [],
                                inputTitle: "Song Title:",
                                inputType: "text",
                                placeholder: "Title",
                            },
                            {
                                options: [],
                                inputTitle: "Song Artist:",
                                inputType: "text",
                                placeholder: "Artist",
                            },
                            {
                                options: [],
                                inputTitle: "Notes:",
                                inputType: "text",
                                placeholder: "Notes:",
                            },
                        ],
                        duplicable: true,
                    },
                    {
                        name: "Processional",
                        fields: [
                            {
                                options: [],
                                inputTitle: "Song Title",
                                inputType: "text",
                                placeholder: "Title",
                            },
                            {
                                options: [],
                                inputTitle: "Song Artist",
                                inputType: "text",
                                placeholder: "Artist",
                            },
                            {
                                options: [],
                                inputTitle: "Notes",
                                inputType: "text",
                                placeholder: "Notes",
                            },
                        ],
                        duplicable: true,
                    },
                    {
                        name: "Bride Entrance",
                        fields: [
                            {
                                options: [],
                                inputTitle: "Song Title",
                                inputType: "text",
                                placeholder: "Title",
                            },
                            {
                                options: [],
                                inputTitle: "Song Artist",
                                inputType: "text",
                                placeholder: "Artist",
                            },
                            {
                                options: [],
                                inputTitle: "Notes",
                                inputType: "text",
                                placeholder: "Notes",
                            },
                        ],
                        duplicable: true,
                    },
                    {
                        name: "Interlude",
                        fields: [
                            {
                                options: [],
                                inputTitle: "Song Title",
                                inputType: "text",
                                placeholder: "Title",
                            },
                            {
                                options: [],
                                inputTitle: "Song Artist",
                                inputType: "text",
                                placeholder: "Artist",
                            },
                            {
                                options: [],
                                inputTitle: "Notes",
                                inputType: "text",
                                placeholder: "Notes",
                            },
                        ],
                    },
                    {
                        name: "Recessional",
                        fields: [
                            {
                                options: [],
                                inputTitle: "Song Title",
                                inputType: "text",
                                placeholder: "Title",
                            },
                            {
                                options: [],
                                inputTitle: "Song Artist",
                                inputType: "text",
                                placeholder: "Artist",
                            },
                            {
                                options: [],
                                inputTitle: "Notes",
                                inputType: "text",
                                placeholder: "Notes",
                            },
                        ],
                    },
                    {
                        name: "Custom Song",
                        fields: [
                            {
                                options: [],
                                inputTitle: "Song Title",
                                inputType: "text",
                                placeholder: "Title",
                            },
                            {
                                options: [],
                                inputTitle: "Song Artist",
                                inputType: "text",
                                placeholder: "Artist",
                            },
                            {
                                options: [],
                                inputTitle: "Notes",
                                inputType: "text",
                                placeholder: "Notes",
                            },
                        ],
                        duplicable: true,
                    },
                ],
            },
            {
                name: "Grand Entrance Members:",
                description:
                    "Enter all of the members of the grand entrance as they'll walk in!",
                id: "form1642440335065",
                fields: [
                    {
                        name: "Person(s):",
                        duplicable: true,
                        inputQuantity: "1",
                        fields: [
                            {
                                options: [],
                                inputTitle: "Name(s):",
                                inputType: "text",
                                placeholder: "John Smith and Mary Smith",
                            },
                        ],
                    },
                ],
            },
            {
                name: "Wedding Reception:",
                description:
                    "The big celebration! This is the form for the wedding reception.",
                id: "form1642435090229",
                fields: [
                    {
                        name: "Grand Entrance:",
                        fields: [
                            {
                                options: [],
                                inputTitle: "Song Title:",
                                inputType: "text",
                                placeholder: "Title",
                            },
                            {
                                options: [],
                                inputTitle: "Song Artist:",
                                inputType: "text",
                                placeholder: "Artist",
                            },
                            {
                                options: [],
                                inputTitle: "Notes:",
                                inputType: "text",
                                placeholder: "Notes:",
                            },
                        ],
                        duplicable: true,
                    },
                    {
                        name: "Bride and Parent Dance:",
                        fields: [
                            {
                                options: [],
                                inputTitle: "Song Title:",
                                inputType: "text",
                                placeholder: "Title",
                            },
                            {
                                options: [],
                                inputTitle: "Song Artist:",
                                inputType: "text",
                                placeholder: "Artist",
                            },
                            {
                                options: [],
                                inputTitle: "Relation and Name:",
                                inputType: "text",
                                placeholder: "Relation and Name",
                            },
                        ],
                        duplicable: true,
                    },
                    {
                        name: "Groom and Parent Dance:",
                        fields: [
                            {
                                options: [],
                                inputTitle: "Song Title:",
                                inputType: "text",
                                placeholder: "Title",
                            },
                            {
                                options: [],
                                inputTitle: "Song Artist:",
                                inputType: "text",
                                placeholder: "Artist",
                            },
                            {
                                options: [],
                                inputTitle: "Relation and Name:",
                                inputType: "text",
                                placeholder: "Relation and Name",
                            },
                        ],
                        duplicable: true,
                    },
                    {
                        name: "Bouquet Toss:",
                        fields: [
                            {
                                options: [],
                                inputTitle: "Song Title:",
                                inputType: "text",
                                placeholder: "Title",
                            },
                            {
                                options: [],
                                inputTitle: "Song Artist:",
                                inputType: "text",
                                placeholder: "Artist",
                            },
                            {
                                options: [],
                                inputTitle: "Notes:",
                                inputType: "text",
                                placeholder: "Notes:",
                            },
                        ],
                    },
                    {
                        name: "Garter Toss:",
                        fields: [
                            {
                                options: [],
                                inputTitle: "Song Title:",
                                inputType: "text",
                                placeholder: "Title",
                            },
                            {
                                options: [],
                                inputTitle: "Song Artist:",
                                inputType: "text",
                                placeholder: "Artist",
                            },
                            {
                                options: [],
                                inputTitle: "Notes:",
                                inputType: "text",
                                placeholder: "Notes:",
                            },
                        ],
                    },
                    {
                        name: "Cake Cutting:",
                        fields: [
                            {
                                options: [],
                                inputTitle: "Song Title:",
                                inputType: "text",
                                placeholder: "Title",
                            },
                            {
                                options: [],
                                inputTitle: "Song Artist:",
                                inputType: "text",
                                placeholder: "Artist",
                            },
                            {
                                options: [],
                                inputTitle: "Notes:",
                                inputType: "text",
                                placeholder: "Notes:",
                            },
                        ],
                    },
                    {
                        name: "Custom Song:",
                        fields: [
                            {
                                options: [],
                                inputTitle: "Song Title:",
                                inputType: "text",
                                placeholder: "Title",
                            },
                            {
                                options: [],
                                inputTitle: "Song Artist:",
                                inputType: "text",
                                placeholder: "Artist",
                            },
                            {
                                options: [],
                                inputTitle: "Notes:",
                                inputType: "text",
                                placeholder: "Notes:",
                            },
                        ],
                        duplicable: true,
                    },
                ],
            },
        ],
        invoice: {
            adjustments: [],
            payments: [],
            products: [
                {
                    employeesRequired: 1,
                    priceOption: "Hourly",
                    equipmentNeeded: [],
                    name: "Wedding DJ",
                    photo:
                        "https://spindjappstorage140016-prod.s3.amazonaws.com/public/7e9b6fe0-0b16-4076-8171-a399992d876b1642443008952",
                    id: "service1642440375825",
                    contracts: ["contract1642442940375"],
                    type: "Service",
                    pricing: {
                        addHourly: 10000,
                        baseTime: 4,
                        baseRate: 150000,
                    },
                    forms: [
                        "form1642369072870",
                        "form1642378126707",
                        "form1642378681111",
                        "form1642440310328",
                        "form1642440335065",
                        "form1642435090229",
                    ],
                },
            ],
        },
        title: "Cool Event",
    },
    {
        toDos: [],
        contactsFetched: true,
        locationsFetched: true,
        locations: [
            {
                role: "location",
                contacts: [
                    {
                        tenantId: "f48f259e-37d9-4003-be97-7181858b98aa",
                        userId: "87da40f6-7074-494f-b04f-b6f779b51c8b",
                    },
                ],
                vendorCategory: "location",
                userId: "location1647368561067",
                tenantId: "f48f259e-37d9-4003-be97-7181858b98aa",
                associatedEvents: [
                    {
                        key: {
                            tenantId: "f48f259e-37d9-4003-be97-7181858b98aa",
                            userId: "event1649788277666",
                        },
                        role: "location",
                    },
                    {
                        key: {
                            tenantId: "f48f259e-37d9-4003-be97-7181858b98aa",
                            userId: "event1649788567110",
                        },
                        role: "location",
                    },
                    {
                        key: {
                            tenantId: "f48f259e-37d9-4003-be97-7181858b98aa",
                            userId: "event1649788723748",
                        },
                        role: "location",
                    },
                    {
                        key: {
                            tenantId: "f48f259e-37d9-4003-be97-7181858b98aa",
                            userId: "event1649788971974",
                        },
                        role: "location",
                    },
                    {
                        key: {
                            tenantId: "f48f259e-37d9-4003-be97-7181858b98aa",
                            userId: "event1649789298650",
                        },
                        role: "location",
                    },
                    {
                        key: {
                            tenantId: "f48f259e-37d9-4003-be97-7181858b98aa",
                            userId: "event1649789298650",
                        },
                        role: "location",
                    },
                    {
                        key: {
                            tenantId: "f48f259e-37d9-4003-be97-7181858b98aa",
                            userId: "event1649789510007",
                        },
                        role: "location",
                    },
                    {
                        key: {
                            tenantId: "f48f259e-37d9-4003-be97-7181858b98aa",
                            userId: "event1649789696173",
                        },
                        role: "location",
                    },
                    {
                        key: {
                            tenantId: "f48f259e-37d9-4003-be97-7181858b98aa",
                            userId: "event1649789901628",
                        },
                        role: "location",
                    },
                    {
                        key: {
                            tenantId: "f48f259e-37d9-4003-be97-7181858b98aa",
                            userId: "event1649863798490",
                        },
                        role: "location",
                    },
                    {
                        key: {
                            tenantId: "f48f259e-37d9-4003-be97-7181858b98aa",
                            userId: "event1649864026900",
                        },
                        role: "location",
                    },
                    {
                        key: {
                            tenantId: "f48f259e-37d9-4003-be97-7181858b98aa",
                            userId: "event1649864140838",
                        },
                        role: "location",
                    },
                    {
                        key: {
                            tenantId: "f48f259e-37d9-4003-be97-7181858b98aa",
                            userId: "event1647368940289",
                        },
                    },
                    {
                        key: {
                            tenantId: "f48f259e-37d9-4003-be97-7181858b98aa",
                            userId: "event1647368940289",
                        },
                    },
                    {
                        key: {
                            tenantId: "f48f259e-37d9-4003-be97-7181858b98aa",
                            userId: "event1647365654337",
                        },
                    },
                    {
                        key: {
                            tenantId: "f48f259e-37d9-4003-be97-7181858b98aa",
                            userId: "event1647365654337",
                        },
                    },
                    {
                        key: {
                            tenantId: "f48f259e-37d9-4003-be97-7181858b98aa",
                            userId: "event1647365654337",
                        },
                    },
                    {
                        key: {
                            tenantId: "f48f259e-37d9-4003-be97-7181858b98aa",
                            userId: "event1656024754673",
                        },
                        role: "location",
                    },
                    {
                        key: {
                            tenantId: "f48f259e-37d9-4003-be97-7181858b98aa",
                            userId: "event1656025310336",
                        },
                        role: "location",
                    },
                    {
                        key: {
                            tenantId: "f48f259e-37d9-4003-be97-7181858b98aa",
                            userId: "event1664556591573",
                        },
                        role: "location",
                    },
                    {
                        key: {
                            userId: "event1664569210019",
                        },
                        role: "location",
                    },
                    {
                        key: {
                            tenantId: "f48f259e-37d9-4003-be97-7181858b98aa",
                            userId: "event1664569326945",
                        },
                        role: "location",
                    },
                ],
                address: {
                    streetAddress1: "891 5th Avenue",
                    streetAddress2: "",
                    cityStateZip: "New York, NY,  10018",
                },
                name: "Avengers Compound",
            },
            {
                SubRegion: "Jefferson",
                Label: "8721 Commercial Blvd, Pevely, MO 63070-2108, United States",
                api_version: "9-28-2022",
                Country: "USA",
                Street: "Commercial Blvd",
                Interpolated: false,
                Region: "Missouri",
                tenantId: "f48f259e-37d9-4003-be97-7181858b98aa",
                source: "search",
                PostalCode: "63070-2108",
                role: "location",
                Geometry: {
                    Point: [-90.39495, 38.28936],
                },
                TimeZone: {
                    Name: "America/Chicago",
                    Offset: -21600,
                },
                userId: "location1671691584201",
                associatedEvents: [
                    {
                        key: {
                            tenantId: "f48f259e-37d9-4003-be97-7181858b98aa",
                            userId: "event1649788277666",
                        },
                    },
                ],
                AddressNumber: "8721",
                Municipality: "Pevely",
                Name: "TBC Venue",
            },
        ],
        contacts: [
            {
                phoneNumber: "1234567894",
                role: "client",
                userId: "3666df24-41b5-47b9-a157-7cdb54ce4056",
                notes: [
                    {
                        date: "2022-12-09T17:03:35.927Z",
                        body: "This is a note, Steven",
                        tenant: "f48f259e-37d9-4003-be97-7181858b98aa",
                    },
                ],
                tenantId: "f48f259e-37d9-4003-be97-7181858b98aa",
                given_name: "Steve",
                createdAt: "2022-03-15T18:36:00.846Z",
                family_name: "Rogers",
                associatedEvents: [
                    "event1647368940289",
                    {
                        key: {
                            tenantId: "f48f259e-37d9-4003-be97-7181858b98aa",
                            userId: "event1649788277666",
                        },
                        role: "client",
                    },
                ],
                username: "steve.rogers@simplecitysoftware.com",
                email: "steve.rogers@simplecitysoftware.com",
            },
            {
                phoneNumber: "1234567890",
                tenants: [
                    "7e9b6fe0-0b16-4076-8171-a399992d876b",
                    "12d988e1-ebec-45a6-8bd6-c091e42da627",
                    "f48f259e-37d9-4003-be97-7181858b98aa",
                    "f48f259e-37d9-4003-be97-7181858b98aa",
                    "f48f259e-37d9-4003-be97-7181858b98aa",
                    "f48f259e-37d9-4003-be97-7181858b98aa",
                    "f48f259e-37d9-4003-be97-7181858b98aa",
                    "f48f259e-37d9-4003-be97-7181858b98aa",
                ],
                tenantId: "f48f259e-37d9-4003-be97-7181858b98aa",
                given_name: "Bruce",
                createdAt: "2022-03-15T18:43:25.671Z",
                family_name: "Banner",
                email: "bruce.banner@simplecitysoftware.com",
                conversations: [
                    {
                        id: "1654284404134",
                        sortKey: "b351c34f-3217-49a3-83d7-b5134ac73b7c",
                    },
                    {
                        id: "1654284487446",
                        sortKey: "b351c34f-3217-49a3-83d7-b5134ac73b7c",
                    },
                    {
                        id: "1654284489127",
                        sortKey: "b351c34f-3217-49a3-83d7-b5134ac73b7c",
                    },
                ],
                role: "client",
                userId: "b351c34f-3217-49a3-83d7-b5134ac73b7c",
                associatedEvents: [
                    {
                        key: {
                            tenantId: "7e9b6fe0-0b16-4076-8171-a399992d876b",
                            userId: "event1643075534547",
                        },
                        role: "client",
                    },
                    {
                        key: {
                            tenantId: "f48f259e-37d9-4003-be97-7181858b98aa",
                            userId: "event1649788277666",
                        },
                        role: "client",
                    },
                    {
                        key: {
                            tenantId: "f48f259e-37d9-4003-be97-7181858b98aa",
                            userId: "event1647365654337",
                        },
                        role: "client",
                    },
                    {
                        key: {
                            tenantId: "7e9b6fe0-0b16-4076-8171-a399992d876b",
                            userId: "event1644173564641",
                        },
                        role: "client",
                    },
                    {
                        key: {
                            tenantId: "f48f259e-37d9-4003-be97-7181858b98aa",
                            userId: "event1671221108013",
                        },
                        role: "client",
                    },
                    {
                        key: {
                            tenantId: "f48f259e-37d9-4003-be97-7181858b98aa",
                            userId: "event1672948593961",
                        },
                        role: "client",
                    },
                    {
                        key: {
                            tenantId: "f48f259e-37d9-4003-be97-7181858b98aa",
                            userId: "event1672949309557",
                        },
                        role: "client",
                    },
                    {
                        key: {
                            tenantId: "f48f259e-37d9-4003-be97-7181858b98aa",
                            userId: "event1672949400312",
                        },
                        role: "client",
                    },
                    {
                        key: {
                            tenantId: "f48f259e-37d9-4003-be97-7181858b98aa",
                            userId: "event1672949557461",
                        },
                        role: "client",
                    },
                    {
                        key: {
                            tenantId: "f48f259e-37d9-4003-be97-7181858b98aa",
                            userId: "event1672949746795",
                        },
                        role: "client",
                    },
                    {
                        key: {
                            tenantId: "f48f259e-37d9-4003-be97-7181858b98aa",
                            userId: "event1672950892190",
                        },
                        role: "client",
                    },
                    {
                        key: {
                            tenantId: "f48f259e-37d9-4003-be97-7181858b98aa",
                            userId: "event1672951295571",
                        },
                        role: "client",
                    },
                    {
                        key: {
                            tenantId: "f48f259e-37d9-4003-be97-7181858b98aa",
                            userId: "event1673026067382",
                        },
                        role: "client",
                    },
                ],
                username: "bruce.banner@simplecitysoftware.com",
            },
            {
                phoneNumber: "1234567894",
                tenantId: "f48f259e-37d9-4003-be97-7181858b98aa",
                given_name: "Natasha",
                createdAt: "2022-03-15T18:51:48.425Z",
                family_name: "Romanoff",
                email: "natasha.romanoff@simplecitysoftware.com",
                conversations: [
                    {
                        id: "1656107697256",
                        sortKey: "f48f259e-37d9-4003-be97-7181858b98aa",
                    },
                ],
                role: "client",
                pronoun: "Ms",
                profilePicture:
                    "https://spindjappstorage140016-prod.s3.amazonaws.com/public/f48f259e-37d9-4003-be97-7181858b98aa1656113561338",
                userId: "978df7f1-893b-46ae-8764-6be7d3f5f642",
                associatedEvents: [
                    "event1647370125074",
                    {
                        key: {
                            tenantId: "f48f259e-37d9-4003-be97-7181858b98aa",
                            userId: "event1649788277666",
                        },
                        role: "client",
                    },
                    {
                        key: {
                            tenantId: "f48f259e-37d9-4003-be97-7181858b98aa",
                            userId: "event1647368940289",
                        },
                        role: "client",
                    },
                    {
                        key: {
                            tenantId: "f48f259e-37d9-4003-be97-7181858b98aa",
                            userId: "event1656092345238",
                        },
                        role: "client",
                    },
                ],
                username: "natasha.romanoff@simplecitysoftware.com",
            },
            {
                phoneNumber: "1234567894",
                role: "employee",
                pronoun: "Mr.",
                userId: "c768b3b1-e1ad-4677-9366-235ca0152317",
                tenantId: "f48f259e-37d9-4003-be97-7181858b98aa",
                given_name: "Clint",
                createdAt: "2022-03-15T18:10:25.370Z",
                family_name: "Barton",
                associatedEvents: [
                    {
                        key: {
                            tenantId: "f48f259e-37d9-4003-be97-7181858b98aa",
                            userId: "event1649788277666",
                        },
                        role: "employee",
                    },
                ],
                username: "clint.barton@simplecitysoftware.com",
                email: "clint.barton@simplecitysoftware.com",
            },
            {
                phoneNumber: "1234567894",
                role: "employee",
                pronoun: null,
                userId: "df5be583-c78f-4afb-906f-49f63916fd32",
                tenantId: "f48f259e-37d9-4003-be97-7181858b98aa",
                given_name: "Thor",
                createdAt: "2022-03-15T18:23:52.713Z",
                family_name: "Odinson",
                associatedEvents: [
                    {
                        key: {
                            tenantId: "f48f259e-37d9-4003-be97-7181858b98aa",
                            userId: "event1649788277666",
                        },
                        role: "employee",
                    },
                ],
                username: "thor.odinson@simplecitysoftware.com",
                email: "thor.odinson@simplecitysoftware.com",
            },
            {
                phoneNumber: "1234567894",
                tenantId: "f48f259e-37d9-4003-be97-7181858b98aa",
                given_name: "Tony",
                createdAt: "2022-03-15T18:22:41.622Z",
                family_name: "Stark",
                email: "tony.stark@simplecitysoftware.com",
                conversations: [
                    {
                        id: "1655489927039",
                        sortKey: "f48f259e-37d9-4003-be97-7181858b98aa",
                    },
                ],
                role: "client",
                pronoun: "Mr.",
                profilePicture:
                    "https://spindjappstorage140016-prod.s3.amazonaws.com/public/f48f259e-37d9-4003-be97-7181858b98aa1656115623113",
                userId: "87da40f6-7074-494f-b04f-b6f779b51c8b",
                associatedEvents: [
                    {
                        key: {
                            tenantId: "f48f259e-37d9-4003-be97-7181858b98aa",
                            userId: "event1648165291492",
                        },
                        role: "client",
                    },
                    {
                        key: {
                            tenantId: "f48f259e-37d9-4003-be97-7181858b98aa",
                            userId: "event1649788567110",
                        },
                        role: "client",
                    },
                    {
                        key: {
                            tenantId: "f48f259e-37d9-4003-be97-7181858b98aa",
                            userId: "event1649788723748",
                        },
                        role: "client",
                    },
                    {
                        key: {
                            tenantId: "f48f259e-37d9-4003-be97-7181858b98aa",
                            userId: "event1649788971974",
                        },
                        role: "client",
                    },
                    {
                        key: {
                            tenantId: "f48f259e-37d9-4003-be97-7181858b98aa",
                            userId: "event1649789298650",
                        },
                        role: "client",
                    },
                    {
                        key: {
                            tenantId: "f48f259e-37d9-4003-be97-7181858b98aa",
                            userId: "event1649789298650",
                        },
                        role: "client",
                    },
                    {
                        key: {
                            tenantId: "f48f259e-37d9-4003-be97-7181858b98aa",
                            userId: "event1649789510007",
                        },
                        role: "client",
                    },
                    {
                        key: {
                            tenantId: "f48f259e-37d9-4003-be97-7181858b98aa",
                            userId: "event1649789696173",
                        },
                        role: "client",
                    },
                    {
                        key: {
                            tenantId: "f48f259e-37d9-4003-be97-7181858b98aa",
                            userId: "event1649789901628",
                        },
                        role: "client",
                    },
                    {
                        key: {
                            tenantId: "f48f259e-37d9-4003-be97-7181858b98aa",
                            userId: "event1649863798490",
                        },
                        role: "client",
                    },
                    {
                        key: {
                            tenantId: "f48f259e-37d9-4003-be97-7181858b98aa",
                            userId: "event1649864026900",
                        },
                        role: "client",
                    },
                    {
                        key: {
                            tenantId: "f48f259e-37d9-4003-be97-7181858b98aa",
                            userId: "event1649864140838",
                        },
                        role: "client",
                    },
                    {
                        key: {
                            tenantId: "f48f259e-37d9-4003-be97-7181858b98aa",
                            userId: "event1647365654337",
                        },
                        role: "client",
                    },
                    {
                        key: {
                            tenantId: "f48f259e-37d9-4003-be97-7181858b98aa",
                            userId: "event1664556591573",
                        },
                        role: "client",
                    },
                    {
                        key: {
                            tenantId: "f48f259e-37d9-4003-be97-7181858b98aa",
                            userId: "event1647369651738",
                        },
                        role: "client",
                    },
                    {
                        key: {
                            tenantId: "f48f259e-37d9-4003-be97-7181858b98aa",
                            userId: "event1649788277666",
                        },
                        role: "client",
                    },
                ],
                username: "tony.stark@simplecitysoftware.com",
            },
        ],
        contracts: [
            {
                signerUUID: null,
                id: "contract1642442940375",
                signerDate: null,
                signerName: null,
                status: "pending",
            },
        ],
        data: {
            date: new Date(today.getFullYear(), today.getMonth() + 6, today.getDate() + 6, 13, 0),
            startTime: new Date(today.getFullYear(), today.getMonth() + 6, today.getDate() + 6, 13, 0),
            endTime: new Date(today.getFullYear(), today.getMonth() + 6, today.getDate() + 6, 19, 30),
        },
        userId: "event1649788277666",
        notes: [],
        tenantId: "f48f259e-37d9-4003-be97-7181858b98aa",
        forms: [
            {
                name: "Ceremony",
                description: "Playlist for wedding ceremony",
                id: "form1642440310328",
                fields: [
                    {
                        name: "Bride Entrance",
                        duplicable: true,
                        fields: [
                            {
                                options: [],
                                inputTitle: "Song Title",
                                inputType: "text",
                                placeholder: "Title",
                                value: "Derpe Der",
                            },
                            {
                                options: [],
                                inputTitle: "Song Artist",
                                inputType: "text",
                                placeholder: "Artist",
                                value: "This is a really long one",
                            },
                            {
                                options: [],
                                inputTitle: "Notes",
                                inputType: "text",
                                placeholder: "Notes",
                            },
                        ],
                        libraryEnabled: true,
                    },
                    {
                        name: "Processional",
                        duplicable: true,
                        fields: [
                            {
                                options: [],
                                inputTitle: "Song Title",
                                inputType: "text",
                                placeholder: "Title",
                                value:
                                    "This is a really long one, i would like to see it wrap around if it could not be a total dick to me this time.",
                            },
                            {
                                options: [],
                                inputTitle: "Song Artist",
                                inputType: "text",
                                placeholder: "Artist",
                            },
                            {
                                options: [],
                                inputTitle: "Notes",
                                inputType: "text",
                                placeholder: "Notes",
                            },
                        ],
                        libraryEnabled: true,
                    },
                    {
                        name: "Interlude",
                        duplicable: false,
                        libraryMatch: {
                            Artist: "Blackberry Smoke",
                            "Track Count": "12",
                            "Track Type": "File",
                            "Disc Number": "1",
                            "Bit Rate": "256",
                            Size: "7920358",
                            "Disc Count": "1",
                            Album: "Little Piece of Dixie",
                            Purchased: "",
                            "Date Modified": "2022-04-25T23:41:54Z",
                            Name: "Good One Comin' on",
                            "Album Artist": "Blackberry Smoke",
                            "Sample Rate": "44100",
                            Kind: "Purchased AAC audio file",
                            Normalization: "5985",
                            "Sort Album": "Little Piece of Dixie",
                            "Persistent ID": "C37C9F6AE0FFBBED",
                            "Track ID": "12178",
                            "Date Added": "2021-08-18T03:59:43Z",
                            "Sort Artist": "Blackberry Smoke",
                            "File Folder Count": "5",
                            "Total Time": "220786",
                            "Library Folder Count": "1",
                            "Track Number": "1",
                            Year: "2009",
                            Genre: "Country",
                            "Release Date": "2009-09-29T12:00:00Z",
                            "Sort Name": "Good One Comin' on",
                            Location:
                                "file:///Volumes/Song%20Backup%20Storage/iTunes/iTunes%20Media/Music/Blackberry%20Smoke/Little%20Piece%20of%20Dixie/01%20Good%20One%20Comin'%20on.m4a",
                        },
                        fields: [
                            {
                                options: [],
                                inputTitle: "Song Title",
                                inputType: "text",
                                placeholder: "Title",
                                value: "Good One Comin' on",
                            },
                            {
                                options: [],
                                inputTitle: "Song Artist",
                                inputType: "text",
                                placeholder: "Artist",
                                value: "Blackberry Smoke",
                            },
                            {
                                options: [],
                                inputTitle: "Notes",
                                inputType: "text",
                                placeholder: "Notes",
                            },
                        ],
                        libraryEnabled: true,
                    },
                    {
                        name: "Recessional",
                        duplicable: false,
                        fields: [
                            {
                                options: [],
                                inputTitle: "Song Title",
                                inputType: "text",
                                placeholder: "Title",
                            },
                            {
                                options: [],
                                inputTitle: "Song Artist",
                                inputType: "text",
                                placeholder: "Artist",
                            },
                            {
                                options: [],
                                inputTitle: "Notes",
                                inputType: "text",
                                placeholder: "Notes",
                            },
                        ],
                        libraryEnabled: true,
                    },
                    {
                        name: "Custom Song",
                        duplicable: true,
                        fields: [
                            {
                                options: [],
                                inputTitle: "Song Title",
                                inputType: "text",
                                placeholder: "Title",
                            },
                            {
                                options: [],
                                inputTitle: "Song Artist",
                                inputType: "text",
                                placeholder: "Artist",
                            },
                            {
                                options: [],
                                inputTitle: "Notes",
                                inputType: "text",
                                placeholder: "Notes",
                            },
                        ],
                        libraryEnabled: true,
                    },
                    {
                        name: "Groom Entrance",
                        duplicable: true,
                        fields: [
                            {
                                options: [],
                                inputTitle: "Song Title:",
                                inputType: "text",
                                placeholder: "Title",
                            },
                            {
                                options: [],
                                inputTitle: "Song Artist:",
                                inputType: "text",
                                placeholder: "Artist",
                            },
                            {
                                options: [],
                                inputTitle: "Notes:",
                                inputType: "text",
                                placeholder: "Notes:",
                            },
                        ],
                        libraryEnabled: true,
                    },
                ],
            },
            {
                name: "Wedding Reception",
                description:
                    "The big celebration! This is the form for the wedding reception.",
                id: "form1642435090229",
                fields: [
                    {
                        name: "Grand Entrance:",
                        duplicable: true,
                        fields: [
                            {
                                options: [],
                                inputTitle: "Song Title:",
                                inputType: "text",
                                placeholder: "Title",
                            },
                            {
                                options: [],
                                inputTitle: "Song Artist:",
                                inputType: "text",
                                placeholder: "Artist",
                            },
                            {
                                options: [],
                                inputTitle: "Notes:",
                                inputType: "text",
                                placeholder: "Notes:",
                            },
                        ],
                        libraryEnabled: true,
                    },
                    {
                        name: "First Dance",
                        duplicable: false,
                        fields: [
                            {
                                options: [],
                                inputTitle: "Song Title:",
                                inputType: "text",
                                placeholder: "Title",
                            },
                            {
                                options: [],
                                inputTitle: "Song Artist:",
                                inputType: "text",
                                placeholder: "Artist",
                            },
                            {
                                options: [],
                                inputTitle: "Notes:",
                                inputType: "text",
                                placeholder: "Notes:",
                            },
                        ],
                        libraryEnabled: true,
                    },
                    {
                        name: "Bride and Parent Dance:",
                        duplicable: true,
                        fields: [
                            {
                                options: [],
                                inputTitle: "Song Title:",
                                inputType: "text",
                                placeholder: "Title",
                            },
                            {
                                options: [],
                                inputTitle: "Song Artist:",
                                inputType: "text",
                                placeholder: "Artist",
                            },
                            {
                                options: [],
                                inputTitle: "Relation and Name:",
                                inputType: "text",
                                placeholder: "Relation and Name",
                            },
                        ],
                        libraryEnabled: true,
                    },
                    {
                        name: "Groom and Parent Dance:",
                        duplicable: true,
                        fields: [
                            {
                                options: [],
                                inputTitle: "Song Title:",
                                inputType: "text",
                                placeholder: "Title",
                            },
                            {
                                options: [],
                                inputTitle: "Song Artist:",
                                inputType: "text",
                                placeholder: "Artist",
                            },
                            {
                                options: [],
                                inputTitle: "Relation and Name:",
                                inputType: "text",
                                placeholder: "Relation and Name",
                            },
                        ],
                        libraryEnabled: true,
                    },
                    {
                        name: "Bouquet Toss:",
                        duplicable: false,
                        fields: [
                            {
                                options: [],
                                inputTitle: "Song Title:",
                                inputType: "text",
                                placeholder: "Title",
                            },
                            {
                                options: [],
                                inputTitle: "Song Artist:",
                                inputType: "text",
                                placeholder: "Artist",
                            },
                            {
                                options: [],
                                inputTitle: "Notes:",
                                inputType: "text",
                                placeholder: "Notes:",
                            },
                        ],
                        libraryEnabled: true,
                    },
                    {
                        name: "Garter Toss:",
                        duplicable: false,
                        fields: [
                            {
                                options: [],
                                inputTitle: "Song Title:",
                                inputType: "text",
                                placeholder: "Title",
                            },
                            {
                                options: [],
                                inputTitle: "Song Artist:",
                                inputType: "text",
                                placeholder: "Artist",
                            },
                            {
                                options: [],
                                inputTitle: "Notes:",
                                inputType: "text",
                                placeholder: "Notes:",
                            },
                        ],
                        libraryEnabled: true,
                    },
                    {
                        name: "Cake Cutting:",
                        duplicable: false,
                        fields: [
                            {
                                options: [],
                                inputTitle: "Song Title:",
                                inputType: "text",
                                placeholder: "Title",
                            },
                            {
                                options: [],
                                inputTitle: "Song Artist:",
                                inputType: "text",
                                placeholder: "Artist",
                            },
                            {
                                options: [],
                                inputTitle: "Notes:",
                                inputType: "text",
                                placeholder: "Notes:",
                            },
                        ],
                        libraryEnabled: true,
                    },
                    {
                        name: "Custom Song:",
                        duplicable: true,
                        fields: [
                            {
                                options: [],
                                inputTitle: "Song Title:",
                                inputType: "text",
                                placeholder: "Title",
                            },
                            {
                                options: [],
                                inputTitle: "Song Artist:",
                                inputType: "text",
                                placeholder: "Artist",
                            },
                            {
                                options: [],
                                inputTitle: "Notes:",
                                inputType: "text",
                                placeholder: "Notes:",
                            },
                        ],
                        libraryEnabled: true,
                    },
                ],
            },
        ],
        invoice: {
            adjustments: [],
            payments: [
                {
                    name: "100",
                    amount: 10000,
                },
                {
                    name: "ch_3LF4gwQwaGPb3gXM1hka5KFc",
                    amount: 25000,
                },
                {
                    name: "ch_3LF4iTQwaGPb3gXM17GtwGif",
                    amount: 25000,
                },
                {
                    name: "ch_3LF4lMQwaGPb3gXM1o5XUl25",
                    amount: 25000,
                },
                {
                    name: "ch_3LF4mgQwaGPb3gXM0qK5JuQr",
                    amount: 25000,
                },
                {
                    name: "ch_3LF5BxQwaGPb3gXM0FaiEjWT",
                    amount: 10000,
                },
                {
                    name: "ch_3LF5KxQwaGPb3gXM1fFC7iiF",
                    amount: 2000,
                },
                {
                    name: "ch_3LFUmQQwaGPb3gXM1bar4sX2",
                    amount: 2250,
                },
                {
                    name: "ch_3LFUpWQwaGPb3gXM1urDwf2s",
                    amount: 1969,
                },
                {
                    name: "ch_3LFV9xQwaGPb3gXM0NA5SL2S",
                    amount: 1723,
                },
                {
                    name: "ch_3LFVBBQwaGPb3gXM09tMWiwO",
                    amount: 1507,
                },
                {
                    name: "ch_3LFkmKQwaGPb3gXM1byDScgC",
                    amount: 551,
                },
            ],
            products: [
                {
                    serviceIds: ["Wedding DJ"],
                    priceOption: "Hourly",
                    name: "The Big Package",
                    id: "package1642649930027",
                    contracts: ["contract1642442940375"],
                    type: "Package",
                    pricing: {
                        addHourly: 10000,
                        baseTime: 5,
                        baseRate: 140000,
                    },
                    forms: [
                        "form1642369072870",
                        "form1642378126707",
                        "form1642378681111",
                        "form1642440310328",
                        "form1642440335065",
                        "form1642435090229",
                    ],
                },
                {
                    employeesRequired: 1,
                    priceOption: "Hourly",
                    equipmentNeeded: [],
                    name: "Weekend Charity DJ",
                    id: "service1644173077057",
                    contracts: ["contract1642442940375"],
                    type: "Service",
                    forms: [
                        "form1642369072870",
                        "form1642378126707",
                        "form1642378681111",
                    ],
                    pricing: {
                        addHourly: 10000,
                        baseTime: 4,
                        baseRate: 100000,
                    },
                },
                {
                    employeesRequired: 1,
                    priceOption: "Hourly",
                    equipmentNeeded: [],
                    name: "Weekday Charity DJ",
                    id: "service1644173191009",
                    contracts: ["contract1642442940375"],
                    type: "Service",
                    forms: [
                        "form1642369072870",
                        "form1642378126707",
                        "form1642378681111",
                    ],
                    pricing: {
                        addHourly: 10000,
                        baseTime: 4,
                        baseRate: 55000,
                    },
                },
                {
                    employeesRequired: 1,
                    priceOption: "Hourly",
                    equipmentNeeded: [],
                    name: "Weekend Party DJ",
                    id: "service1645816493474",
                    contracts: ["contract1642442940375"],
                    type: "Service",
                    forms: [
                        "form1642369072870",
                        "form1642378126707",
                        "form1642378681111",
                    ],
                    pricing: {
                        addHourly: 10000,
                        baseTime: 4,
                        baseRate: 140000,
                    },
                },
                {
                    name: "Uplighting",
                    priceOption: "Unit",
                    id: "addOn1657129946636",
                    type: "Add-On",
                    pricing: {
                        minUnits: 35,
                        unitRate: 2000,
                        units: "45",
                    },
                    selected: true,
                },
                {
                    employeesRequired: 1,
                    priceOption: "Flat",
                    equipmentNeeded: [],
                    name: "Officiant",
                    id: "service1646869172429",
                    contracts: [],
                    type: "Service",
                    pricing: {
                        addHourly: 0,
                        baseRate: 35000,
                    },
                    forms: [],
                },
            ],
        },
        title: "The Avengies Awards",
    },
    {
        toDos: [],
        contactsFetched: true,
        locationsFetched: true,
        locations: [
            {
                role: "location",
                contacts: [
                    {
                        tenantId: "f48f259e-37d9-4003-be97-7181858b98aa",
                        userId: "87da40f6-7074-494f-b04f-b6f779b51c8b",
                    },
                ],
                vendorCategory: "location",
                userId: "location1647368561067",
                tenantId: "f48f259e-37d9-4003-be97-7181858b98aa",
                associatedEvents: [
                    {
                        key: {
                            tenantId: "f48f259e-37d9-4003-be97-7181858b98aa",
                            userId: "event1649788277666",
                        },
                        role: "location",
                    },
                    {
                        key: {
                            tenantId: "f48f259e-37d9-4003-be97-7181858b98aa",
                            userId: "event1649788567110",
                        },
                        role: "location",
                    },
                    {
                        key: {
                            tenantId: "f48f259e-37d9-4003-be97-7181858b98aa",
                            userId: "event1649788723748",
                        },
                        role: "location",
                    },
                    {
                        key: {
                            tenantId: "f48f259e-37d9-4003-be97-7181858b98aa",
                            userId: "event1649788971974",
                        },
                        role: "location",
                    },
                    {
                        key: {
                            tenantId: "f48f259e-37d9-4003-be97-7181858b98aa",
                            userId: "event1649789298650",
                        },
                        role: "location",
                    },
                    {
                        key: {
                            tenantId: "f48f259e-37d9-4003-be97-7181858b98aa",
                            userId: "event1649789298650",
                        },
                        role: "location",
                    },
                    {
                        key: {
                            tenantId: "f48f259e-37d9-4003-be97-7181858b98aa",
                            userId: "event1649789510007",
                        },
                        role: "location",
                    },
                    {
                        key: {
                            tenantId: "f48f259e-37d9-4003-be97-7181858b98aa",
                            userId: "event1649789696173",
                        },
                        role: "location",
                    },
                    {
                        key: {
                            tenantId: "f48f259e-37d9-4003-be97-7181858b98aa",
                            userId: "event1649789901628",
                        },
                        role: "location",
                    },
                    {
                        key: {
                            tenantId: "f48f259e-37d9-4003-be97-7181858b98aa",
                            userId: "event1649863798490",
                        },
                        role: "location",
                    },
                    {
                        key: {
                            tenantId: "f48f259e-37d9-4003-be97-7181858b98aa",
                            userId: "event1649864026900",
                        },
                        role: "location",
                    },
                    {
                        key: {
                            tenantId: "f48f259e-37d9-4003-be97-7181858b98aa",
                            userId: "event1649864140838",
                        },
                        role: "location",
                    },
                    {
                        key: {
                            tenantId: "f48f259e-37d9-4003-be97-7181858b98aa",
                            userId: "event1647368940289",
                        },
                    },
                    {
                        key: {
                            tenantId: "f48f259e-37d9-4003-be97-7181858b98aa",
                            userId: "event1647368940289",
                        },
                    },
                    {
                        key: {
                            tenantId: "f48f259e-37d9-4003-be97-7181858b98aa",
                            userId: "event1647365654337",
                        },
                    },
                    {
                        key: {
                            tenantId: "f48f259e-37d9-4003-be97-7181858b98aa",
                            userId: "event1647365654337",
                        },
                    },
                    {
                        key: {
                            tenantId: "f48f259e-37d9-4003-be97-7181858b98aa",
                            userId: "event1647365654337",
                        },
                    },
                    {
                        key: {
                            tenantId: "f48f259e-37d9-4003-be97-7181858b98aa",
                            userId: "event1656024754673",
                        },
                        role: "location",
                    },
                    {
                        key: {
                            tenantId: "f48f259e-37d9-4003-be97-7181858b98aa",
                            userId: "event1656025310336",
                        },
                        role: "location",
                    },
                    {
                        key: {
                            tenantId: "f48f259e-37d9-4003-be97-7181858b98aa",
                            userId: "event1664556591573",
                        },
                        role: "location",
                    },
                    {
                        key: {
                            userId: "event1664569210019",
                        },
                        role: "location",
                    },
                    {
                        key: {
                            tenantId: "f48f259e-37d9-4003-be97-7181858b98aa",
                            userId: "event1664569326945",
                        },
                        role: "location",
                    },
                ],
                address: {
                    streetAddress1: "891 5th Avenue",
                    streetAddress2: "",
                    cityStateZip: "New York, NY,  10018",
                },
                name: "Avengers Compound",
            },
        ],
        contacts: [
            {
                phoneNumber: "1234567894",
                tenantId: "f48f259e-37d9-4003-be97-7181858b98aa",
                given_name: "Tony",
                createdAt: "2022-03-15T18:22:41.622Z",
                family_name: "Stark",
                email: "tony.stark@simplecitysoftware.com",
                conversations: [
                    {
                        id: "1655489927039",
                        sortKey: "f48f259e-37d9-4003-be97-7181858b98aa",
                    },
                ],
                role: "client",
                pronoun: "Mr.",
                profilePicture:
                    "https://spindjappstorage140016-prod.s3.amazonaws.com/public/f48f259e-37d9-4003-be97-7181858b98aa1656115623113",
                userId: "87da40f6-7074-494f-b04f-b6f779b51c8b",
                associatedEvents: [
                    {
                        key: {
                            tenantId: "f48f259e-37d9-4003-be97-7181858b98aa",
                            userId: "event1648165291492",
                        },
                        role: "client",
                    },
                    {
                        key: {
                            tenantId: "f48f259e-37d9-4003-be97-7181858b98aa",
                            userId: "event1649788567110",
                        },
                        role: "client",
                    },
                    {
                        key: {
                            tenantId: "f48f259e-37d9-4003-be97-7181858b98aa",
                            userId: "event1649788723748",
                        },
                        role: "client",
                    },
                    {
                        key: {
                            tenantId: "f48f259e-37d9-4003-be97-7181858b98aa",
                            userId: "event1649788971974",
                        },
                        role: "client",
                    },
                    {
                        key: {
                            tenantId: "f48f259e-37d9-4003-be97-7181858b98aa",
                            userId: "event1649789298650",
                        },
                        role: "client",
                    },
                    {
                        key: {
                            tenantId: "f48f259e-37d9-4003-be97-7181858b98aa",
                            userId: "event1649789298650",
                        },
                        role: "client",
                    },
                    {
                        key: {
                            tenantId: "f48f259e-37d9-4003-be97-7181858b98aa",
                            userId: "event1649789510007",
                        },
                        role: "client",
                    },
                    {
                        key: {
                            tenantId: "f48f259e-37d9-4003-be97-7181858b98aa",
                            userId: "event1649789696173",
                        },
                        role: "client",
                    },
                    {
                        key: {
                            tenantId: "f48f259e-37d9-4003-be97-7181858b98aa",
                            userId: "event1649789901628",
                        },
                        role: "client",
                    },
                    {
                        key: {
                            tenantId: "f48f259e-37d9-4003-be97-7181858b98aa",
                            userId: "event1649863798490",
                        },
                        role: "client",
                    },
                    {
                        key: {
                            tenantId: "f48f259e-37d9-4003-be97-7181858b98aa",
                            userId: "event1649864026900",
                        },
                        role: "client",
                    },
                    {
                        key: {
                            tenantId: "f48f259e-37d9-4003-be97-7181858b98aa",
                            userId: "event1649864140838",
                        },
                        role: "client",
                    },
                    {
                        key: {
                            tenantId: "f48f259e-37d9-4003-be97-7181858b98aa",
                            userId: "event1647365654337",
                        },
                        role: "client",
                    },
                    {
                        key: {
                            tenantId: "f48f259e-37d9-4003-be97-7181858b98aa",
                            userId: "event1664556591573",
                        },
                        role: "client",
                    },
                    {
                        key: {
                            tenantId: "f48f259e-37d9-4003-be97-7181858b98aa",
                            userId: "event1647369651738",
                        },
                        role: "client",
                    },
                    {
                        key: {
                            tenantId: "f48f259e-37d9-4003-be97-7181858b98aa",
                            userId: "event1649788277666",
                        },
                        role: "client",
                    },
                ],
                username: "tony.stark@simplecitysoftware.com",
            },
            {
                phoneNumber: "1234567894",
                tenants: ["7e9b6fe0-0b16-4076-8171-a399992d876b"],
                vendorCategory: "Decor/Florist",
                tenantId: "f48f259e-37d9-4003-be97-7181858b98aa",
                given_name: "Peter",
                createdAt: "2022-03-15T18:15:38.906Z",
                family_name: "Parker",
                email: "peter.parker@simplecitysoftware.com",
                conversations: [
                    {
                        id: "1656116593540",
                        sortKey: "f48f259e-37d9-4003-be97-7181858b98aa",
                    },
                ],
                role: "vendor",
                pronoun: "Mr.",
                profilePicture:
                    "https://spindjappstorage140016-prod.s3.amazonaws.com/public/f48f259e-37d9-4003-be97-7181858b98aa1656116885967",
                userId: "de8abc34-2c29-4aef-ad71-26187c82fe11",
                associatedEvents: [
                    "event1647369651738",
                    {
                        key: {
                            tenantId: "f48f259e-37d9-4003-be97-7181858b98aa",
                            userId: "event1648165291492",
                        },
                        role: "vendor",
                    },
                    {
                        key: {
                            tenantId: "7e9b6fe0-0b16-4076-8171-a399992d876b",
                            userId: "event1643075534547",
                        },
                        role: "vendor",
                    },
                    {
                        key: {
                            tenantId: "f48f259e-37d9-4003-be97-7181858b98aa",
                            userId: "event1647365654337",
                        },
                        role: "vendor",
                    },
                    {
                        key: {
                            tenantId: "f48f259e-37d9-4003-be97-7181858b98aa",
                            userId: "event1649788567110",
                        },
                        role: "vendor",
                    },
                ],
                username: "peter.parker@simplecitysoftware.com",
            },
        ],
        contracts: [
            {
                contractBody:
                    " WITNESSETH NOW THEREFORE\n\nA {invoice-deposit-amount} non-refundable security deposit is required when booking your event. This deposit is deducted from your total event cost and will show in your invoice statement. In consideration of the payment by {client-list}, (hereafter referred to as the Purchaser(s)) of {invoice-total} as well as the various promises and the agreements set forth below, the Parties agree and intend to be legally bound as follows:<br/><br/>\n\n 1. Lauryn Cole Investments, LLC DBA {business-name}, hereafter referred to as 'The DJ Service' shall provide up to {event-length} for the Purchaser(s) at the agreed upon venue(s) ({location-list}).<br/><br/>\n\n 2. The DJ Service, referenced in Paragraph 1, shall be provided and accepted on the entered date and time of the engagement.\n<br/><br/>\n 3. The DJ Service, referenced in Paragraph 1 shall consist primarily of providing musical entertainment by means of a downloaded MP3 music format.\n<br/><br/>\n 4. The DJ Service shall, at all times, have unmitigated control of its DJ Services.\n<br/><br/>\n 5. In the event that additional hours of DJ Services are requested after the finish time this agreement is executed, and The DJ Service accepts said request, additional DJ Services will be charged at the rate of $100 per hour, payable the day of the engagement.The parties understand and agree that it may not always be possible to provide additional performance time; The DJ Service is under no obligation to accept an offer to purchase additional hours of DJ Services.\n<br/><br/>\n\nADDITIONAL TERMS AND CONDITIONS:<br/><br/>\n\n\nThe agreement of the DJ to perform is subject to proven detention by accidents, transportation issues, riots, strikes, epidemics, any random acts of God, or any other legitimate conditions beyond their control. If such issues arise, all reasonable efforts will be made by The DJ Service to make it to the event or find replacement at the agreed upon fees. Should The DJ Service be unable to procure a replacement, Purchaser shall receive a full refund. Purchaser(s) agree that The DJ Service's liability shall not be liable in any amount of damage which exceeds the performance fee(s) recited above. Further, the Purchaser(s) agree that The DJ Service shall not be liable for indirect or consequential damages arising from any breach of contract. It is understood that, in the unlikely event that The DJ Service subcontracts services for your event and any liability issues or breach of this contract occurs, the subcontractor is the responsible party. The DJ Service is not responsible for the subcontracted services provided, equipment, or performance of services. Any and all issues, court costs, attorney fees and legal damages are the responsibility of the subcontractor, not The DJ Service. The Purchaser(s) and The DJ Service agree that this contract is not subject to cancellation unless both parties have agreed to such cancellation in writing. In the event of cancellation by the Purchaser(s) within 60 days of their event date, the Purchaser(s) shall pay the DJ the amount of $300.00 as liquidated damages, plus a reasonable attorney’s fee. If the Purchaser(s) cancel the event within 30 days of the set event date, the Purchaser(s) shall pay the The DJ Service the total agreed amount set forth on the contract as liquidated damages, lose their security deposit, plus a reasonable attorney’s fee. It is further agreed that the Purchaser shall be liable for any and all injury or damage to the The DJ Service, or property of The DJ Service, while on the premises of said engagement, if damage is caused by Purchaser or guest, members of his organization, engagement invitees, employees, or any other party in attendance, whether invited or not. It is understood that if this is a Rain or Shine event; The DJ Service‘s compensation is in no way affected by inclement weather. For outdoor performances, Purchaser shall provide overhead shelter for setup area. The DJ reserves the right, in good faith, to stop or cancel the performance should the weather pose a potential danger to him, the equipment, or audience. every effort will be made to continue the performance. However, safety is paramount in all decisions. The DJ’s compensation will not be affected by such cancellation.In the event of circumstances deemed to present a threat or implied threat of injury or harm The DJ Service staff or any equipment in  The DJ Service possession, The DJ Service reserves the right to cease performance. If the Purchaser is able to resolve the threatening situation in a reasonable amount of time (maximum of 15 minutes), The DJ Service shall resume performance in accordance with the original terms of this agreement. Purchaser shall be responsible for payment in full, regardless of whether the situation is resolved or whether  The DJ Service resumes performance. In order to prevent equipment damage or liability arising from accidental injury to any individual attending this performance,  The DJ Servicereserves the right to deny any guest access to the sound system, music recordings, or other equipment. Purchaser shall provide  The DJ Service with safe and appropriate working conditions. This includes a 10-foot by 10-foot area for setup, space for setting up speakers and lighting stands. The DJ Service requires a minimum of one 15-20-amp circuit outlet from a reliable power source within 25 feet (along the wall) of the set-up area. This circuit must be free of all other connected loads. Any delay in the performance or damage to DJ’s equipment due to improper power is the responsibility of the purchaser. Two circuits are preferred, where possible. Additional outlets on separate circuits for lighting (if contracted for) are required. Purchaser shall provide crowd control if warranted; and furnishing directions to place of engagement. Purchaser is responsible for paying any charges imposed by the venue. These charges may include, but are not limited to, parking and use of electric power. A written event/music planner or music request list must be received from the Purchaser and forwarded to The DJ Service not less than 1 month prior to the date of the engagement for it to be included in The DJ Service programming outline. The DJ Service will attempt to play Purchaser’s and Purchaser’s guests’ music requests, conditioned upon availability. In the event of non-payment,  The DJ Service retains the right to attempt collection through the courts. Purchaser agrees to be held responsible for all court costs, legal fees, and collection costs incurred by  The DJ Service. Purchaser shall be charged $30 for each returned check. It is agreed that Missouri law shall control all aspects of this Agreement. Purchasers agree to make all necessary arrangements to provide the DJ with access to the event venue not less than 2 hours before the engagement and 1 hour after the engagement for setup and takedown.  The DJ Service also requests ramp or elevator access between the parking/service entrance and the setup area. If Purchaser or venue requires  The DJ Service to complete setup more than 2 hours before the start time, or to postpone takedown more than 1 hour after the end time indicated, the additional time will be charged at the rate of $100.00 per hour.\n\n\nSPECIAL PROVISIONS AND SERVICES REQUESTED\n\n\nBy executing this contract as Purchaser, the person executing said contract, either individually, or as an agent or representative, represents and warrants that he or she is eighteen (18) years of age, and further, if executing said contract as agent or representative, that he or she has the authority to enter into this agreement and should he or she not have such authority, he or she personally accepts and assumes full responsibility and liability under the terms of this contract. This document, together with any attachments initialed by the parties, shall constitute THE ENTIRE AGREEMENT of the parties. If any part of this contract is illegal or unenforceable, the remaining provisions of this contract will remain valid and enforceable as to both parties. Again, this document contains the entire agreement between the parties and no statement, promises, or inducements made by any party hereto, or agent or representative or either party hereto, which are not contained in this written contract, shall be valid or binding. This contract shall not be enlarged, modified, or altered except in writing by both parties and endorsed hereon. The laws of the State of Missouri shall govern this agreement. In the event that legal proceedings are initiated by either party, it is agreed that proper venue shall be in St. Charles County. Purchaser(s) agree to indemnify, defend, assume liability for and hold The DJ Company harmless from any claims, damages, losses and expenses by or to any person, regardless of the basis, which pertains directly or indirectly to The DJ Company’s performance. In the event that a civil action arises in an effort to enforce any provision of this agreement, the losing party shall pay the attorney’s fee and court costs of the prevailing party. Purchaser(s) may not transfer or assign this contract to another party without the prior written consent of The DJ Company . THE PARTIES acknowledge that they have read the above Agreement in its entirety, understand all of its terms and conditions, have had an opportunity to review the same with legal counsel, and agree to abide by the terms of this agreement of his/her own free will and consent.",
                signerUUID: "87da40f6-7074-494f-b04f-b6f779b51c8b",
                admin: {},
                contractName: "Standard DJ Contract",
                id: "contract1642442940375",
                signerDate: "2022-04-22T21:09:38.297Z",
                signerName: "Tony Stark",
                status: "signed",
            },
        ],
        data: {
            date: new Date(today.getFullYear(), today.getMonth() + 6, today.getDate() + 5, 14, 0),
            startTime: new Date(today.getFullYear(), today.getMonth() + 6, today.getDate() + 5, 14, 0),
            endTime: new Date(today.getFullYear(), today.getMonth() + 6, today.getDate() + 5, 21, 15),
        },
        userId: "event1649788567110",
        tenantId: "f48f259e-37d9-4003-be97-7181858b98aa",
        forms: [
            {
                name: "Music Preferences",
                description: "Give me your preferences for music for the day! ",
                id: "form1642369072870",
                fields: [
                    {
                        fields: [
                            {
                                options: [],
                                inputTitle: "Favorite Genres",
                                inputType: "text",
                                placeholder: "Rock, Hip-Hop, Raffi",
                            },
                        ],
                        name: "Music Preferences",
                        inputQuantity: "1",
                    },
                ],
            },
            {
                name: "Song Requests",
                description: "Give me your must plays!",
                id: "form1642378126707",
                fields: [
                    {
                        duplicable: true,
                        name: "Song:",
                        fields: [
                            {
                                options: [],
                                inputTitle: "Song Title:",
                                inputType: "text",
                                placeholder: "Title",
                            },
                            {
                                options: [],
                                inputTitle: "Song Artist:",
                                inputType: "text",
                                placeholder: "Artist",
                            },
                            {
                                options: [],
                                inputTitle: "Notes:",
                                inputType: "text",
                                placeholder: "Notes:",
                            },
                        ],
                        libraryEnabled: true,
                    },
                ],
            },
            {
                name: "Wedding Reception",
                description:
                    "The big celebration! This is the form for the wedding reception.",
                id: "form1642435090229",
                fields: [
                    {
                        duplicable: true,
                        name: "Grand Entrance:",
                        fields: [
                            {
                                options: [],
                                inputTitle: "Song Title:",
                                inputType: "text",
                                placeholder: "Title",
                            },
                            {
                                options: [],
                                inputTitle: "Song Artist:",
                                inputType: "text",
                                placeholder: "Artist",
                            },
                            {
                                options: [],
                                inputTitle: "Notes:",
                                inputType: "text",
                                placeholder: "Notes:",
                            },
                        ],
                        libraryEnabled: true,
                    },
                    {
                        duplicable: false,
                        name: "First Dance",
                        fields: [
                            {
                                options: [],
                                inputTitle: "Song Title:",
                                inputType: "text",
                                placeholder: "Title",
                            },
                            {
                                options: [],
                                inputTitle: "Song Artist:",
                                inputType: "text",
                                placeholder: "Artist",
                            },
                            {
                                options: [],
                                inputTitle: "Notes:",
                                inputType: "text",
                                placeholder: "Notes:",
                            },
                        ],
                        libraryEnabled: true,
                    },
                    {
                        duplicable: true,
                        name: "Bride and Parent Dance:",
                        fields: [
                            {
                                options: [],
                                inputTitle: "Song Title:",
                                inputType: "text",
                                placeholder: "Title",
                            },
                            {
                                options: [],
                                inputTitle: "Song Artist:",
                                inputType: "text",
                                placeholder: "Artist",
                            },
                            {
                                options: [],
                                inputTitle: "Relation and Name:",
                                inputType: "text",
                                placeholder: "Relation and Name",
                            },
                        ],
                        libraryEnabled: true,
                    },
                    {
                        duplicable: true,
                        name: "Groom and Parent Dance:",
                        fields: [
                            {
                                options: [],
                                inputTitle: "Song Title:",
                                inputType: "text",
                                placeholder: "Title",
                            },
                            {
                                options: [],
                                inputTitle: "Song Artist:",
                                inputType: "text",
                                placeholder: "Artist",
                            },
                            {
                                options: [],
                                inputTitle: "Relation and Name:",
                                inputType: "text",
                                placeholder: "Relation and Name",
                            },
                        ],
                        libraryEnabled: true,
                    },
                    {
                        duplicable: false,
                        name: "Bouquet Toss:",
                        fields: [
                            {
                                options: [],
                                inputTitle: "Song Title:",
                                inputType: "text",
                                placeholder: "Title",
                            },
                            {
                                options: [],
                                inputTitle: "Song Artist:",
                                inputType: "text",
                                placeholder: "Artist",
                            },
                            {
                                options: [],
                                inputTitle: "Notes:",
                                inputType: "text",
                                placeholder: "Notes:",
                            },
                        ],
                        libraryEnabled: true,
                    },
                    {
                        duplicable: false,
                        name: "Garter Toss:",
                        fields: [
                            {
                                options: [],
                                inputTitle: "Song Title:",
                                inputType: "text",
                                placeholder: "Title",
                            },
                            {
                                options: [],
                                inputTitle: "Song Artist:",
                                inputType: "text",
                                placeholder: "Artist",
                            },
                            {
                                options: [],
                                inputTitle: "Notes:",
                                inputType: "text",
                                placeholder: "Notes:",
                            },
                        ],
                        libraryEnabled: true,
                    },
                    {
                        duplicable: false,
                        name: "Cake Cutting:",
                        fields: [
                            {
                                options: [],
                                inputTitle: "Song Title:",
                                inputType: "text",
                                placeholder: "Title",
                            },
                            {
                                options: [],
                                inputTitle: "Song Artist:",
                                inputType: "text",
                                placeholder: "Artist",
                            },
                            {
                                options: [],
                                inputTitle: "Notes:",
                                inputType: "text",
                                placeholder: "Notes:",
                            },
                        ],
                        libraryEnabled: true,
                    },
                    {
                        duplicable: true,
                        name: "Custom Song:",
                        fields: [
                            {
                                options: [],
                                inputTitle: "Song Title:",
                                inputType: "text",
                                placeholder: "Title",
                            },
                            {
                                options: [],
                                inputTitle: "Song Artist:",
                                inputType: "text",
                                placeholder: "Artist",
                            },
                            {
                                options: [],
                                inputTitle: "Notes:",
                                inputType: "text",
                                placeholder: "Notes:",
                            },
                        ],
                        libraryEnabled: true,
                    },
                ],
            },
            {
                fields: [
                    {
                        duplicable: false,
                        name: "Questions",
                        inputQuantity: "1",
                        fields: [
                            {
                                options: [
                                    {
                                        optionValue: "Yes",
                                    },
                                    {
                                        optionValue: "No",
                                    },
                                ],
                                inputTitle: "Can I Take Requests?",
                                inputType: "select",
                                optionQuantity: "2",
                            },
                        ],
                    },
                    {
                        duplicable: false,
                        name: "Name",
                        inputQuantity: "2",
                        fields: [
                            {
                                options: [],
                                inputTitle:
                                    "Text Area With a really long title for steve ekkjlkjlkn",
                                inputType: "textarea",
                                placeholder: "kjhgfd",
                            },
                            {
                                options: [],
                                inputTitle: "Also Text Area",
                                inputType: "textarea",
                                placeholder: "luyhjkl",
                            },
                        ],
                    },
                ],
                name: "My Questions",
                id: "form1643924159717",
            },
            {
                name: "Do Not Play",
                description: "Give me all the songs you HATE!",
                id: "form1642378681111",
                fields: [
                    {
                        duplicable: true,
                        name: "Song:",
                        fields: [
                            {
                                options: [],
                                inputTitle: "Song Title:",
                                inputType: "text",
                                placeholder: "Title",
                            },
                            {
                                options: [],
                                inputTitle: "Song Artist:",
                                inputType: "text",
                                placeholder: "Artist",
                            },
                            {
                                options: [],
                                inputTitle: "Notes:",
                                inputType: "text",
                                placeholder: "Notes:",
                            },
                        ],
                        libraryEnabled: true,
                    },
                ],
            },
            {
                name: "Ceremony",
                description: "Playlist for wedding ceremony",
                id: "form1642440310328",
                fields: [
                    {
                        duplicable: true,
                        name: "Bride Entrance",
                        fields: [
                            {
                                options: [],
                                inputTitle: "Song Title",
                                inputType: "text",
                                placeholder: "Title",
                            },
                            {
                                options: [],
                                inputTitle: "Song Artist",
                                inputType: "text",
                                placeholder: "Artist",
                            },
                            {
                                options: [],
                                inputTitle: "Notes",
                                inputType: "text",
                                placeholder: "Notes",
                            },
                        ],
                        libraryEnabled: true,
                    },
                    {
                        duplicable: true,
                        name: "Processional",
                        fields: [
                            {
                                options: [],
                                inputTitle: "Song Title",
                                inputType: "text",
                                placeholder: "Title",
                            },
                            {
                                options: [],
                                inputTitle: "Song Artist",
                                inputType: "text",
                                placeholder: "Artist",
                            },
                            {
                                options: [],
                                inputTitle: "Notes",
                                inputType: "text",
                                placeholder: "Notes",
                            },
                        ],
                        libraryEnabled: true,
                    },
                    {
                        duplicable: false,
                        name: "Interlude",
                        fields: [
                            {
                                options: [],
                                inputTitle: "Song Title",
                                inputType: "text",
                                placeholder: "Title",
                            },
                            {
                                options: [],
                                inputTitle: "Song Artist",
                                inputType: "text",
                                placeholder: "Artist",
                            },
                            {
                                options: [],
                                inputTitle: "Notes",
                                inputType: "text",
                                placeholder: "Notes",
                            },
                        ],
                        libraryEnabled: true,
                    },
                    {
                        duplicable: false,
                        name: "Recessional",
                        fields: [
                            {
                                options: [],
                                inputTitle: "Song Title",
                                inputType: "text",
                                placeholder: "Title",
                            },
                            {
                                options: [],
                                inputTitle: "Song Artist",
                                inputType: "text",
                                placeholder: "Artist",
                            },
                            {
                                options: [],
                                inputTitle: "Notes",
                                inputType: "text",
                                placeholder: "Notes",
                            },
                        ],
                        libraryEnabled: true,
                    },
                    {
                        duplicable: true,
                        name: "Custom Song",
                        fields: [
                            {
                                options: [],
                                inputTitle: "Song Title",
                                inputType: "text",
                                placeholder: "Title",
                            },
                            {
                                options: [],
                                inputTitle: "Song Artist",
                                inputType: "text",
                                placeholder: "Artist",
                            },
                            {
                                options: [],
                                inputTitle: "Notes",
                                inputType: "text",
                                placeholder: "Notes",
                            },
                        ],
                        libraryEnabled: true,
                    },
                    {
                        duplicable: true,
                        name: "Groom Entrance",
                        fields: [
                            {
                                options: [],
                                inputTitle: "Song Title:",
                                inputType: "text",
                                placeholder: "Title",
                            },
                            {
                                options: [],
                                inputTitle: "Song Artist:",
                                inputType: "text",
                                placeholder: "Artist",
                            },
                            {
                                options: [],
                                inputTitle: "Notes:",
                                inputType: "text",
                                placeholder: "Notes:",
                            },
                        ],
                        libraryEnabled: true,
                    },
                ],
            },
            {
                name: "Grand Entrance Members",
                description:
                    "Enter all of the members of the grand entrance as they'll walk in!",
                id: "form1642440335065",
                fields: [
                    {
                        duplicable: true,
                        name: "Person(s):",
                        inputQuantity: "1",
                        fields: [
                            {
                                options: [],
                                inputTitle: "Name(s):",
                                inputType: "text",
                                placeholder: "John Smith and Mary Smith",
                            },
                        ],
                    },
                ],
            },
        ],
        invoice: {
            adjustments: [],
            payments: [
                {
                    name: "check",
                    amount: 10000,
                },
            ],
            products: [
                {
                    employeesRequired: 1,
                    priceOption: "Hourly",
                    equipmentNeeded: [],
                    name: "Wedding DJ",
                    photo:
                        "https://spindjappstorage140016-prod.s3.amazonaws.com/public/7e9b6fe0-0b16-4076-8171-a399992d876b1642443008952",
                    id: "service1642440375825",
                    contracts: ["contract1642442940375"],
                    type: "Service",
                    pricing: {
                        addHourly: 10000,
                        baseTime: 4,
                        baseRate: 150000,
                    },
                    forms: [
                        "form1642369072870",
                        "form1642378126707",
                        "form1642378681111",
                        "form1642440310328",
                        "form1642440335065",
                        "form1642435090229",
                    ],
                },
                {
                    serviceIds: ["Wedding DJ"],
                    priceOption: "Hourly",
                    name: "The Big Package",
                    id: "package1642649930027",
                    contracts: ["contract1642442940375"],
                    type: "Package",
                    pricing: {
                        addHourly: 10000,
                        baseTime: 5,
                        baseRate: 140000,
                    },
                    forms: [
                        "form1642369072870",
                        "form1642378126707",
                        "form1642378681111",
                        "form1642440310328",
                        "form1642440335065",
                        "form1642435090229",
                    ],
                },
            ],
        },
        title: "Tony's Birthday",
    },
    {
        toDos: [],
        contactsFetched: true,
        locationsFetched: true,
        locations: [
            {
                role: "location",
                contacts: [
                    {
                        tenantId: "f48f259e-37d9-4003-be97-7181858b98aa",
                        userId: "87da40f6-7074-494f-b04f-b6f779b51c8b",
                    },
                ],
                vendorCategory: "location",
                userId: "location1647368561067",
                tenantId: "f48f259e-37d9-4003-be97-7181858b98aa",
                associatedEvents: [
                    {
                        key: {
                            tenantId: "f48f259e-37d9-4003-be97-7181858b98aa",
                            userId: "event1649788277666",
                        },
                        role: "location",
                    },
                    {
                        key: {
                            tenantId: "f48f259e-37d9-4003-be97-7181858b98aa",
                            userId: "event1649788567110",
                        },
                        role: "location",
                    },
                    {
                        key: {
                            tenantId: "f48f259e-37d9-4003-be97-7181858b98aa",
                            userId: "event1649788723748",
                        },
                        role: "location",
                    },
                    {
                        key: {
                            tenantId: "f48f259e-37d9-4003-be97-7181858b98aa",
                            userId: "event1649788971974",
                        },
                        role: "location",
                    },
                    {
                        key: {
                            tenantId: "f48f259e-37d9-4003-be97-7181858b98aa",
                            userId: "event1649789298650",
                        },
                        role: "location",
                    },
                    {
                        key: {
                            tenantId: "f48f259e-37d9-4003-be97-7181858b98aa",
                            userId: "event1649789298650",
                        },
                        role: "location",
                    },
                    {
                        key: {
                            tenantId: "f48f259e-37d9-4003-be97-7181858b98aa",
                            userId: "event1649789510007",
                        },
                        role: "location",
                    },
                    {
                        key: {
                            tenantId: "f48f259e-37d9-4003-be97-7181858b98aa",
                            userId: "event1649789696173",
                        },
                        role: "location",
                    },
                    {
                        key: {
                            tenantId: "f48f259e-37d9-4003-be97-7181858b98aa",
                            userId: "event1649789901628",
                        },
                        role: "location",
                    },
                    {
                        key: {
                            tenantId: "f48f259e-37d9-4003-be97-7181858b98aa",
                            userId: "event1649863798490",
                        },
                        role: "location",
                    },
                    {
                        key: {
                            tenantId: "f48f259e-37d9-4003-be97-7181858b98aa",
                            userId: "event1649864026900",
                        },
                        role: "location",
                    },
                    {
                        key: {
                            tenantId: "f48f259e-37d9-4003-be97-7181858b98aa",
                            userId: "event1649864140838",
                        },
                        role: "location",
                    },
                    {
                        key: {
                            tenantId: "f48f259e-37d9-4003-be97-7181858b98aa",
                            userId: "event1647368940289",
                        },
                    },
                    {
                        key: {
                            tenantId: "f48f259e-37d9-4003-be97-7181858b98aa",
                            userId: "event1647368940289",
                        },
                    },
                    {
                        key: {
                            tenantId: "f48f259e-37d9-4003-be97-7181858b98aa",
                            userId: "event1647365654337",
                        },
                    },
                    {
                        key: {
                            tenantId: "f48f259e-37d9-4003-be97-7181858b98aa",
                            userId: "event1647365654337",
                        },
                    },
                    {
                        key: {
                            tenantId: "f48f259e-37d9-4003-be97-7181858b98aa",
                            userId: "event1647365654337",
                        },
                    },
                    {
                        key: {
                            tenantId: "f48f259e-37d9-4003-be97-7181858b98aa",
                            userId: "event1656024754673",
                        },
                        role: "location",
                    },
                    {
                        key: {
                            tenantId: "f48f259e-37d9-4003-be97-7181858b98aa",
                            userId: "event1656025310336",
                        },
                        role: "location",
                    },
                    {
                        key: {
                            tenantId: "f48f259e-37d9-4003-be97-7181858b98aa",
                            userId: "event1664556591573",
                        },
                        role: "location",
                    },
                    {
                        key: {
                            userId: "event1664569210019",
                        },
                        role: "location",
                    },
                    {
                        key: {
                            tenantId: "f48f259e-37d9-4003-be97-7181858b98aa",
                            userId: "event1664569326945",
                        },
                        role: "location",
                    },
                ],
                address: {
                    streetAddress1: "891 5th Avenue",
                    streetAddress2: "",
                    cityStateZip: "New York, NY,  10018",
                },
                name: "Avengers Compound",
            },
        ],
        contacts: [
            {
                phoneNumber: "1234567894",
                tenantId: "f48f259e-37d9-4003-be97-7181858b98aa",
                given_name: "Tony",
                createdAt: "2022-03-15T18:22:41.622Z",
                family_name: "Stark",
                email: "tony.stark@simplecitysoftware.com",
                conversations: [
                    {
                        id: "1655489927039",
                        sortKey: "f48f259e-37d9-4003-be97-7181858b98aa",
                    },
                ],
                role: "client",
                pronoun: "Mr.",
                profilePicture:
                    "https://spindjappstorage140016-prod.s3.amazonaws.com/public/f48f259e-37d9-4003-be97-7181858b98aa1656115623113",
                userId: "87da40f6-7074-494f-b04f-b6f779b51c8b",
                associatedEvents: [
                    {
                        key: {
                            tenantId: "f48f259e-37d9-4003-be97-7181858b98aa",
                            userId: "event1648165291492",
                        },
                        role: "client",
                    },
                    {
                        key: {
                            tenantId: "f48f259e-37d9-4003-be97-7181858b98aa",
                            userId: "event1649788567110",
                        },
                        role: "client",
                    },
                    {
                        key: {
                            tenantId: "f48f259e-37d9-4003-be97-7181858b98aa",
                            userId: "event1649788723748",
                        },
                        role: "client",
                    },
                    {
                        key: {
                            tenantId: "f48f259e-37d9-4003-be97-7181858b98aa",
                            userId: "event1649788971974",
                        },
                        role: "client",
                    },
                    {
                        key: {
                            tenantId: "f48f259e-37d9-4003-be97-7181858b98aa",
                            userId: "event1649789298650",
                        },
                        role: "client",
                    },
                    {
                        key: {
                            tenantId: "f48f259e-37d9-4003-be97-7181858b98aa",
                            userId: "event1649789298650",
                        },
                        role: "client",
                    },
                    {
                        key: {
                            tenantId: "f48f259e-37d9-4003-be97-7181858b98aa",
                            userId: "event1649789510007",
                        },
                        role: "client",
                    },
                    {
                        key: {
                            tenantId: "f48f259e-37d9-4003-be97-7181858b98aa",
                            userId: "event1649789696173",
                        },
                        role: "client",
                    },
                    {
                        key: {
                            tenantId: "f48f259e-37d9-4003-be97-7181858b98aa",
                            userId: "event1649789901628",
                        },
                        role: "client",
                    },
                    {
                        key: {
                            tenantId: "f48f259e-37d9-4003-be97-7181858b98aa",
                            userId: "event1649863798490",
                        },
                        role: "client",
                    },
                    {
                        key: {
                            tenantId: "f48f259e-37d9-4003-be97-7181858b98aa",
                            userId: "event1649864026900",
                        },
                        role: "client",
                    },
                    {
                        key: {
                            tenantId: "f48f259e-37d9-4003-be97-7181858b98aa",
                            userId: "event1649864140838",
                        },
                        role: "client",
                    },
                    {
                        key: {
                            tenantId: "f48f259e-37d9-4003-be97-7181858b98aa",
                            userId: "event1647365654337",
                        },
                        role: "client",
                    },
                    {
                        key: {
                            tenantId: "f48f259e-37d9-4003-be97-7181858b98aa",
                            userId: "event1664556591573",
                        },
                        role: "client",
                    },
                    {
                        key: {
                            tenantId: "f48f259e-37d9-4003-be97-7181858b98aa",
                            userId: "event1647369651738",
                        },
                        role: "client",
                    },
                    {
                        key: {
                            tenantId: "f48f259e-37d9-4003-be97-7181858b98aa",
                            userId: "event1649788277666",
                        },
                        role: "client",
                    },
                ],
                username: "tony.stark@simplecitysoftware.com",
            },
        ],
        contracts: [
            {
                contractBody:
                    " WITNESSETH NOW THEREFORE\n\nA {invoice-deposit-amount} non-refundable security deposit is required when booking your event. This deposit is deducted from your total event cost and will show in your invoice statement. In consideration of the payment by {client-list}, (hereafter referred to as the Purchaser(s)) of {invoice-total} as well as the various promises and the agreements set forth below, the Parties agree and intend to be legally bound as follows:<br/><br/>\n\n 1. Lauryn Cole Investments, LLC DBA {business-name}, hereafter referred to as 'The DJ Service' shall provide up to {event-length} for the Purchaser(s) at the agreed upon venue(s) ({location-list}).<br/><br/>\n\n 2. The DJ Service, referenced in Paragraph 1, shall be provided and accepted on the entered date and time of the engagement.\n<br/><br/>\n 3. The DJ Service, referenced in Paragraph 1 shall consist primarily of providing musical entertainment by means of a downloaded MP3 music format.\n<br/><br/>\n 4. The DJ Service shall, at all times, have unmitigated control of its DJ Services.\n<br/><br/>\n 5. In the event that additional hours of DJ Services are requested after the finish time this agreement is executed, and The DJ Service accepts said request, additional DJ Services will be charged at the rate of $100 per hour, payable the day of the engagement.The parties understand and agree that it may not always be possible to provide additional performance time; The DJ Service is under no obligation to accept an offer to purchase additional hours of DJ Services.\n<br/><br/>\n\nADDITIONAL TERMS AND CONDITIONS:<br/><br/>\n\n\nThe agreement of the DJ to perform is subject to proven detention by accidents, transportation issues, riots, strikes, epidemics, any random acts of God, or any other legitimate conditions beyond their control. If such issues arise, all reasonable efforts will be made by The DJ Service to make it to the event or find replacement at the agreed upon fees. Should The DJ Service be unable to procure a replacement, Purchaser shall receive a full refund. Purchaser(s) agree that The DJ Service's liability shall not be liable in any amount of damage which exceeds the performance fee(s) recited above. Further, the Purchaser(s) agree that The DJ Service shall not be liable for indirect or consequential damages arising from any breach of contract. It is understood that, in the unlikely event that The DJ Service subcontracts services for your event and any liability issues or breach of this contract occurs, the subcontractor is the responsible party. The DJ Service is not responsible for the subcontracted services provided, equipment, or performance of services. Any and all issues, court costs, attorney fees and legal damages are the responsibility of the subcontractor, not The DJ Service. The Purchaser(s) and The DJ Service agree that this contract is not subject to cancellation unless both parties have agreed to such cancellation in writing. In the event of cancellation by the Purchaser(s) within 60 days of their event date, the Purchaser(s) shall pay the DJ the amount of $300.00 as liquidated damages, plus a reasonable attorney’s fee. If the Purchaser(s) cancel the event within 30 days of the set event date, the Purchaser(s) shall pay the The DJ Service the total agreed amount set forth on the contract as liquidated damages, lose their security deposit, plus a reasonable attorney’s fee. It is further agreed that the Purchaser shall be liable for any and all injury or damage to the The DJ Service, or property of The DJ Service, while on the premises of said engagement, if damage is caused by Purchaser or guest, members of his organization, engagement invitees, employees, or any other party in attendance, whether invited or not. It is understood that if this is a Rain or Shine event; The DJ Service‘s compensation is in no way affected by inclement weather. For outdoor performances, Purchaser shall provide overhead shelter for setup area. The DJ reserves the right, in good faith, to stop or cancel the performance should the weather pose a potential danger to him, the equipment, or audience. every effort will be made to continue the performance. However, safety is paramount in all decisions. The DJ’s compensation will not be affected by such cancellation.In the event of circumstances deemed to present a threat or implied threat of injury or harm The DJ Service staff or any equipment in  The DJ Service possession, The DJ Service reserves the right to cease performance. If the Purchaser is able to resolve the threatening situation in a reasonable amount of time (maximum of 15 minutes), The DJ Service shall resume performance in accordance with the original terms of this agreement. Purchaser shall be responsible for payment in full, regardless of whether the situation is resolved or whether  The DJ Service resumes performance. In order to prevent equipment damage or liability arising from accidental injury to any individual attending this performance,  The DJ Servicereserves the right to deny any guest access to the sound system, music recordings, or other equipment. Purchaser shall provide  The DJ Service with safe and appropriate working conditions. This includes a 10-foot by 10-foot area for setup, space for setting up speakers and lighting stands. The DJ Service requires a minimum of one 15-20-amp circuit outlet from a reliable power source within 25 feet (along the wall) of the set-up area. This circuit must be free of all other connected loads. Any delay in the performance or damage to DJ’s equipment due to improper power is the responsibility of the purchaser. Two circuits are preferred, where possible. Additional outlets on separate circuits for lighting (if contracted for) are required. Purchaser shall provide crowd control if warranted; and furnishing directions to place of engagement. Purchaser is responsible for paying any charges imposed by the venue. These charges may include, but are not limited to, parking and use of electric power. A written event/music planner or music request list must be received from the Purchaser and forwarded to The DJ Service not less than 1 month prior to the date of the engagement for it to be included in The DJ Service programming outline. The DJ Service will attempt to play Purchaser’s and Purchaser’s guests’ music requests, conditioned upon availability. In the event of non-payment,  The DJ Service retains the right to attempt collection through the courts. Purchaser agrees to be held responsible for all court costs, legal fees, and collection costs incurred by  The DJ Service. Purchaser shall be charged $30 for each returned check. It is agreed that Missouri law shall control all aspects of this Agreement. Purchasers agree to make all necessary arrangements to provide the DJ with access to the event venue not less than 2 hours before the engagement and 1 hour after the engagement for setup and takedown.  The DJ Service also requests ramp or elevator access between the parking/service entrance and the setup area. If Purchaser or venue requires  The DJ Service to complete setup more than 2 hours before the start time, or to postpone takedown more than 1 hour after the end time indicated, the additional time will be charged at the rate of $100.00 per hour.\n\n\nSPECIAL PROVISIONS AND SERVICES REQUESTED\n\n\nBy executing this contract as Purchaser, the person executing said contract, either individually, or as an agent or representative, represents and warrants that he or she is eighteen (18) years of age, and further, if executing said contract as agent or representative, that he or she has the authority to enter into this agreement and should he or she not have such authority, he or she personally accepts and assumes full responsibility and liability under the terms of this contract. This document, together with any attachments initialed by the parties, shall constitute THE ENTIRE AGREEMENT of the parties. If any part of this contract is illegal or unenforceable, the remaining provisions of this contract will remain valid and enforceable as to both parties. Again, this document contains the entire agreement between the parties and no statement, promises, or inducements made by any party hereto, or agent or representative or either party hereto, which are not contained in this written contract, shall be valid or binding. This contract shall not be enlarged, modified, or altered except in writing by both parties and endorsed hereon. The laws of the State of Missouri shall govern this agreement. In the event that legal proceedings are initiated by either party, it is agreed that proper venue shall be in St. Charles County. Purchaser(s) agree to indemnify, defend, assume liability for and hold The DJ Company harmless from any claims, damages, losses and expenses by or to any person, regardless of the basis, which pertains directly or indirectly to The DJ Company’s performance. In the event that a civil action arises in an effort to enforce any provision of this agreement, the losing party shall pay the attorney’s fee and court costs of the prevailing party. Purchaser(s) may not transfer or assign this contract to another party without the prior written consent of The DJ Company . THE PARTIES acknowledge that they have read the above Agreement in its entirety, understand all of its terms and conditions, have had an opportunity to review the same with legal counsel, and agree to abide by the terms of this agreement of his/her own free will and consent.",
                signerUUID: "87da40f6-7074-494f-b04f-b6f779b51c8b",
                admin: {},
                contractName: "Standard DJ Contract",
                id: "contract1642442940375",
                signerDate: "2022-04-22T22:02:06.345Z",
                signerName: "Tony Stark",
                status: "signed",
            },
        ],
        data: {
            date: new Date(today.getFullYear(), today.getMonth() + 7, today.getDate() + 5, 14, 0),
            startTime: new Date(today.getFullYear(), today.getMonth() + 7, today.getDate() + 5, 14, 0),
            endTime: new Date(today.getFullYear(), today.getMonth() + 7, today.getDate() + 5, 21, 15),
        },
        userId: "event1649788723748",
        tenantId: "f48f259e-37d9-4003-be97-7181858b98aa",
        forms: [],
        invoice: {
            adjustments: [],
            payments: [],
            products: [
                {
                    employeesRequired: 1,
                    priceOption: "Hourly",
                    equipmentNeeded: [],
                    name: "Wedding DJ",
                    photo:
                        "https://spindjappstorage140016-prod.s3.amazonaws.com/public/7e9b6fe0-0b16-4076-8171-a399992d876b1642443008952",
                    id: "service1642440375825",
                    contracts: ["contract1642442940375"],
                    type: "Service",
                    pricing: {
                        addHourly: 10000,
                        baseTime: 4,
                        baseRate: 150000,
                    },
                    forms: [
                        "form1642369072870",
                        "form1642378126707",
                        "form1642378681111",
                        "form1642440310328",
                        "form1642440335065",
                        "form1642435090229",
                    ],
                },
            ],
        },
        title: "The Dopest Event",
    },
    {
        toDos: [],
        contactsFetched: true,
        locationsFetched: true,
        locations: [
            {
                role: "location",
                contacts: [
                    {
                        tenantId: "f48f259e-37d9-4003-be97-7181858b98aa",
                        userId: "87da40f6-7074-494f-b04f-b6f779b51c8b",
                    },
                ],
                vendorCategory: "location",
                userId: "location1647368561067",
                tenantId: "f48f259e-37d9-4003-be97-7181858b98aa",
                associatedEvents: [
                    {
                        key: {
                            tenantId: "f48f259e-37d9-4003-be97-7181858b98aa",
                            userId: "event1649788277666",
                        },
                        role: "location",
                    },
                    {
                        key: {
                            tenantId: "f48f259e-37d9-4003-be97-7181858b98aa",
                            userId: "event1649788567110",
                        },
                        role: "location",
                    },
                    {
                        key: {
                            tenantId: "f48f259e-37d9-4003-be97-7181858b98aa",
                            userId: "event1649788723748",
                        },
                        role: "location",
                    },
                    {
                        key: {
                            tenantId: "f48f259e-37d9-4003-be97-7181858b98aa",
                            userId: "event1649788971974",
                        },
                        role: "location",
                    },
                    {
                        key: {
                            tenantId: "f48f259e-37d9-4003-be97-7181858b98aa",
                            userId: "event1649789298650",
                        },
                        role: "location",
                    },
                    {
                        key: {
                            tenantId: "f48f259e-37d9-4003-be97-7181858b98aa",
                            userId: "event1649789298650",
                        },
                        role: "location",
                    },
                    {
                        key: {
                            tenantId: "f48f259e-37d9-4003-be97-7181858b98aa",
                            userId: "event1649789510007",
                        },
                        role: "location",
                    },
                    {
                        key: {
                            tenantId: "f48f259e-37d9-4003-be97-7181858b98aa",
                            userId: "event1649789696173",
                        },
                        role: "location",
                    },
                    {
                        key: {
                            tenantId: "f48f259e-37d9-4003-be97-7181858b98aa",
                            userId: "event1649789901628",
                        },
                        role: "location",
                    },
                    {
                        key: {
                            tenantId: "f48f259e-37d9-4003-be97-7181858b98aa",
                            userId: "event1649863798490",
                        },
                        role: "location",
                    },
                    {
                        key: {
                            tenantId: "f48f259e-37d9-4003-be97-7181858b98aa",
                            userId: "event1649864026900",
                        },
                        role: "location",
                    },
                    {
                        key: {
                            tenantId: "f48f259e-37d9-4003-be97-7181858b98aa",
                            userId: "event1649864140838",
                        },
                        role: "location",
                    },
                    {
                        key: {
                            tenantId: "f48f259e-37d9-4003-be97-7181858b98aa",
                            userId: "event1647368940289",
                        },
                    },
                    {
                        key: {
                            tenantId: "f48f259e-37d9-4003-be97-7181858b98aa",
                            userId: "event1647368940289",
                        },
                    },
                    {
                        key: {
                            tenantId: "f48f259e-37d9-4003-be97-7181858b98aa",
                            userId: "event1647365654337",
                        },
                    },
                    {
                        key: {
                            tenantId: "f48f259e-37d9-4003-be97-7181858b98aa",
                            userId: "event1647365654337",
                        },
                    },
                    {
                        key: {
                            tenantId: "f48f259e-37d9-4003-be97-7181858b98aa",
                            userId: "event1647365654337",
                        },
                    },
                    {
                        key: {
                            tenantId: "f48f259e-37d9-4003-be97-7181858b98aa",
                            userId: "event1656024754673",
                        },
                        role: "location",
                    },
                    {
                        key: {
                            tenantId: "f48f259e-37d9-4003-be97-7181858b98aa",
                            userId: "event1656025310336",
                        },
                        role: "location",
                    },
                    {
                        key: {
                            tenantId: "f48f259e-37d9-4003-be97-7181858b98aa",
                            userId: "event1664556591573",
                        },
                        role: "location",
                    },
                    {
                        key: {
                            userId: "event1664569210019",
                        },
                        role: "location",
                    },
                    {
                        key: {
                            tenantId: "f48f259e-37d9-4003-be97-7181858b98aa",
                            userId: "event1664569326945",
                        },
                        role: "location",
                    },
                ],
                address: {
                    streetAddress1: "891 5th Avenue",
                    streetAddress2: "",
                    cityStateZip: "New York, NY,  10018",
                },
                name: "Avengers Compound",
            },
        ],
        contacts: [
            {
                phoneNumber: "1234567894",
                tenantId: "f48f259e-37d9-4003-be97-7181858b98aa",
                given_name: "Tony",
                createdAt: "2022-03-15T18:22:41.622Z",
                family_name: "Stark",
                email: "tony.stark@simplecitysoftware.com",
                conversations: [
                    {
                        id: "1655489927039",
                        sortKey: "f48f259e-37d9-4003-be97-7181858b98aa",
                    },
                ],
                role: "client",
                pronoun: "Mr.",
                profilePicture:
                    "https://spindjappstorage140016-prod.s3.amazonaws.com/public/f48f259e-37d9-4003-be97-7181858b98aa1656115623113",
                userId: "87da40f6-7074-494f-b04f-b6f779b51c8b",
                associatedEvents: [
                    {
                        key: {
                            tenantId: "f48f259e-37d9-4003-be97-7181858b98aa",
                            userId: "event1648165291492",
                        },
                        role: "client",
                    },
                    {
                        key: {
                            tenantId: "f48f259e-37d9-4003-be97-7181858b98aa",
                            userId: "event1649788567110",
                        },
                        role: "client",
                    },
                    {
                        key: {
                            tenantId: "f48f259e-37d9-4003-be97-7181858b98aa",
                            userId: "event1649788723748",
                        },
                        role: "client",
                    },
                    {
                        key: {
                            tenantId: "f48f259e-37d9-4003-be97-7181858b98aa",
                            userId: "event1649788971974",
                        },
                        role: "client",
                    },
                    {
                        key: {
                            tenantId: "f48f259e-37d9-4003-be97-7181858b98aa",
                            userId: "event1649789298650",
                        },
                        role: "client",
                    },
                    {
                        key: {
                            tenantId: "f48f259e-37d9-4003-be97-7181858b98aa",
                            userId: "event1649789298650",
                        },
                        role: "client",
                    },
                    {
                        key: {
                            tenantId: "f48f259e-37d9-4003-be97-7181858b98aa",
                            userId: "event1649789510007",
                        },
                        role: "client",
                    },
                    {
                        key: {
                            tenantId: "f48f259e-37d9-4003-be97-7181858b98aa",
                            userId: "event1649789696173",
                        },
                        role: "client",
                    },
                    {
                        key: {
                            tenantId: "f48f259e-37d9-4003-be97-7181858b98aa",
                            userId: "event1649789901628",
                        },
                        role: "client",
                    },
                    {
                        key: {
                            tenantId: "f48f259e-37d9-4003-be97-7181858b98aa",
                            userId: "event1649863798490",
                        },
                        role: "client",
                    },
                    {
                        key: {
                            tenantId: "f48f259e-37d9-4003-be97-7181858b98aa",
                            userId: "event1649864026900",
                        },
                        role: "client",
                    },
                    {
                        key: {
                            tenantId: "f48f259e-37d9-4003-be97-7181858b98aa",
                            userId: "event1649864140838",
                        },
                        role: "client",
                    },
                    {
                        key: {
                            tenantId: "f48f259e-37d9-4003-be97-7181858b98aa",
                            userId: "event1647365654337",
                        },
                        role: "client",
                    },
                    {
                        key: {
                            tenantId: "f48f259e-37d9-4003-be97-7181858b98aa",
                            userId: "event1664556591573",
                        },
                        role: "client",
                    },
                    {
                        key: {
                            tenantId: "f48f259e-37d9-4003-be97-7181858b98aa",
                            userId: "event1647369651738",
                        },
                        role: "client",
                    },
                    {
                        key: {
                            tenantId: "f48f259e-37d9-4003-be97-7181858b98aa",
                            userId: "event1649788277666",
                        },
                        role: "client",
                    },
                ],
                username: "tony.stark@simplecitysoftware.com",
            },
        ],
        contracts: [
            {
                contractBody:
                    " WITNESSETH NOW THEREFORE\n\nA {invoice-deposit-amount} non-refundable security deposit is required when booking your event. This deposit is deducted from your total event cost and will show in your invoice statement. In consideration of the payment by {client-list}, (hereafter referred to as the Purchaser(s)) of {invoice-total} as well as the various promises and the agreements set forth below, the Parties agree and intend to be legally bound as follows:<br/><br/>\n\n 1. Lauryn Cole Investments, LLC DBA {business-name}, hereafter referred to as 'The DJ Service' shall provide up to {event-length} for the Purchaser(s) at the agreed upon venue(s) ({location-list}).<br/><br/>\n\n 2. The DJ Service, referenced in Paragraph 1, shall be provided and accepted on the entered date and time of the engagement.\n<br/><br/>\n 3. The DJ Service, referenced in Paragraph 1 shall consist primarily of providing musical entertainment by means of a downloaded MP3 music format.\n<br/><br/>\n 4. The DJ Service shall, at all times, have unmitigated control of its DJ Services.\n<br/><br/>\n 5. In the event that additional hours of DJ Services are requested after the finish time this agreement is executed, and The DJ Service accepts said request, additional DJ Services will be charged at the rate of $100 per hour, payable the day of the engagement.The parties understand and agree that it may not always be possible to provide additional performance time; The DJ Service is under no obligation to accept an offer to purchase additional hours of DJ Services.\n<br/><br/>\n\nADDITIONAL TERMS AND CONDITIONS:<br/><br/>\n\n\nThe agreement of the DJ to perform is subject to proven detention by accidents, transportation issues, riots, strikes, epidemics, any random acts of God, or any other legitimate conditions beyond their control. If such issues arise, all reasonable efforts will be made by The DJ Service to make it to the event or find replacement at the agreed upon fees. Should The DJ Service be unable to procure a replacement, Purchaser shall receive a full refund. Purchaser(s) agree that The DJ Service's liability shall not be liable in any amount of damage which exceeds the performance fee(s) recited above. Further, the Purchaser(s) agree that The DJ Service shall not be liable for indirect or consequential damages arising from any breach of contract. It is understood that, in the unlikely event that The DJ Service subcontracts services for your event and any liability issues or breach of this contract occurs, the subcontractor is the responsible party. The DJ Service is not responsible for the subcontracted services provided, equipment, or performance of services. Any and all issues, court costs, attorney fees and legal damages are the responsibility of the subcontractor, not The DJ Service. The Purchaser(s) and The DJ Service agree that this contract is not subject to cancellation unless both parties have agreed to such cancellation in writing. In the event of cancellation by the Purchaser(s) within 60 days of their event date, the Purchaser(s) shall pay the DJ the amount of $300.00 as liquidated damages, plus a reasonable attorney’s fee. If the Purchaser(s) cancel the event within 30 days of the set event date, the Purchaser(s) shall pay the The DJ Service the total agreed amount set forth on the contract as liquidated damages, lose their security deposit, plus a reasonable attorney’s fee. It is further agreed that the Purchaser shall be liable for any and all injury or damage to the The DJ Service, or property of The DJ Service, while on the premises of said engagement, if damage is caused by Purchaser or guest, members of his organization, engagement invitees, employees, or any other party in attendance, whether invited or not. It is understood that if this is a Rain or Shine event; The DJ Service‘s compensation is in no way affected by inclement weather. For outdoor performances, Purchaser shall provide overhead shelter for setup area. The DJ reserves the right, in good faith, to stop or cancel the performance should the weather pose a potential danger to him, the equipment, or audience. every effort will be made to continue the performance. However, safety is paramount in all decisions. The DJ’s compensation will not be affected by such cancellation.In the event of circumstances deemed to present a threat or implied threat of injury or harm The DJ Service staff or any equipment in  The DJ Service possession, The DJ Service reserves the right to cease performance. If the Purchaser is able to resolve the threatening situation in a reasonable amount of time (maximum of 15 minutes), The DJ Service shall resume performance in accordance with the original terms of this agreement. Purchaser shall be responsible for payment in full, regardless of whether the situation is resolved or whether  The DJ Service resumes performance. In order to prevent equipment damage or liability arising from accidental injury to any individual attending this performance,  The DJ Servicereserves the right to deny any guest access to the sound system, music recordings, or other equipment. Purchaser shall provide  The DJ Service with safe and appropriate working conditions. This includes a 10-foot by 10-foot area for setup, space for setting up speakers and lighting stands. The DJ Service requires a minimum of one 15-20-amp circuit outlet from a reliable power source within 25 feet (along the wall) of the set-up area. This circuit must be free of all other connected loads. Any delay in the performance or damage to DJ’s equipment due to improper power is the responsibility of the purchaser. Two circuits are preferred, where possible. Additional outlets on separate circuits for lighting (if contracted for) are required. Purchaser shall provide crowd control if warranted; and furnishing directions to place of engagement. Purchaser is responsible for paying any charges imposed by the venue. These charges may include, but are not limited to, parking and use of electric power. A written event/music planner or music request list must be received from the Purchaser and forwarded to The DJ Service not less than 1 month prior to the date of the engagement for it to be included in The DJ Service programming outline. The DJ Service will attempt to play Purchaser’s and Purchaser’s guests’ music requests, conditioned upon availability. In the event of non-payment,  The DJ Service retains the right to attempt collection through the courts. Purchaser agrees to be held responsible for all court costs, legal fees, and collection costs incurred by  The DJ Service. Purchaser shall be charged $30 for each returned check. It is agreed that Missouri law shall control all aspects of this Agreement. Purchasers agree to make all necessary arrangements to provide the DJ with access to the event venue not less than 2 hours before the engagement and 1 hour after the engagement for setup and takedown.  The DJ Service also requests ramp or elevator access between the parking/service entrance and the setup area. If Purchaser or venue requires  The DJ Service to complete setup more than 2 hours before the start time, or to postpone takedown more than 1 hour after the end time indicated, the additional time will be charged at the rate of $100.00 per hour.\n\n\nSPECIAL PROVISIONS AND SERVICES REQUESTED\n\n\nBy executing this contract as Purchaser, the person executing said contract, either individually, or as an agent or representative, represents and warrants that he or she is eighteen (18) years of age, and further, if executing said contract as agent or representative, that he or she has the authority to enter into this agreement and should he or she not have such authority, he or she personally accepts and assumes full responsibility and liability under the terms of this contract. This document, together with any attachments initialed by the parties, shall constitute THE ENTIRE AGREEMENT of the parties. If any part of this contract is illegal or unenforceable, the remaining provisions of this contract will remain valid and enforceable as to both parties. Again, this document contains the entire agreement between the parties and no statement, promises, or inducements made by any party hereto, or agent or representative or either party hereto, which are not contained in this written contract, shall be valid or binding. This contract shall not be enlarged, modified, or altered except in writing by both parties and endorsed hereon. The laws of the State of Missouri shall govern this agreement. In the event that legal proceedings are initiated by either party, it is agreed that proper venue shall be in St. Charles County. Purchaser(s) agree to indemnify, defend, assume liability for and hold The DJ Company harmless from any claims, damages, losses and expenses by or to any person, regardless of the basis, which pertains directly or indirectly to The DJ Company’s performance. In the event that a civil action arises in an effort to enforce any provision of this agreement, the losing party shall pay the attorney’s fee and court costs of the prevailing party. Purchaser(s) may not transfer or assign this contract to another party without the prior written consent of The DJ Company . THE PARTIES acknowledge that they have read the above Agreement in its entirety, understand all of its terms and conditions, have had an opportunity to review the same with legal counsel, and agree to abide by the terms of this agreement of his/her own free will and consent.",
                signerUUID: "87da40f6-7074-494f-b04f-b6f779b51c8b",
                admin: {},
                contractName: "Standard DJ Contract",
                id: "contract1642442940375",
                signerDate: "2022-04-22T22:03:38.411Z",
                signerName: "Tony Stark",
                status: "signed",
            },
        ],
        data: {
            date: new Date(today.getFullYear(), today.getMonth() + 6, today.getDate() + 2, 16, 0),
            startTime: new Date(today.getFullYear(), today.getMonth() + 6, today.getDate() + 2, 16, 0),
            endTime: new Date(today.getFullYear(), today.getMonth() + 6, today.getDate() + 2, 20, 0),
        },
        userId: "event1649788971974",
        tenantId: "f48f259e-37d9-4003-be97-7181858b98aa",
        forms: [],
        invoice: {
            adjustments: [],
            payments: [],
            products: [
                {
                    employeesRequired: 1,
                    priceOption: "Hourly",
                    equipmentNeeded: [],
                    name: "Wedding DJ",
                    photo:
                        "https://spindjappstorage140016-prod.s3.amazonaws.com/public/7e9b6fe0-0b16-4076-8171-a399992d876b1642443008952",
                    id: "service1642440375825",
                    contracts: ["contract1642442940375"],
                    type: "Service",
                    pricing: {
                        addHourly: 10000,
                        baseTime: 4,
                        baseRate: 150000,
                    },
                    forms: [
                        "form1642369072870",
                        "form1642378126707",
                        "form1642378681111",
                        "form1642440310328",
                        "form1642440335065",
                        "form1642435090229",
                    ],
                },
            ],
        },
        title: "Amazing Event",
    },
    {
        toDos: [],
        contactsFetched: true,
        locationsFetched: true,
        locations: [
            {
                role: "location",
                contacts: [
                    {
                        tenantId: "f48f259e-37d9-4003-be97-7181858b98aa",
                        userId: "87da40f6-7074-494f-b04f-b6f779b51c8b",
                    },
                ],
                vendorCategory: "location",
                userId: "location1647368561067",
                tenantId: "f48f259e-37d9-4003-be97-7181858b98aa",
                associatedEvents: [
                    {
                        key: {
                            tenantId: "f48f259e-37d9-4003-be97-7181858b98aa",
                            userId: "event1649788277666",
                        },
                        role: "location",
                    },
                    {
                        key: {
                            tenantId: "f48f259e-37d9-4003-be97-7181858b98aa",
                            userId: "event1649788567110",
                        },
                        role: "location",
                    },
                    {
                        key: {
                            tenantId: "f48f259e-37d9-4003-be97-7181858b98aa",
                            userId: "event1649788723748",
                        },
                        role: "location",
                    },
                    {
                        key: {
                            tenantId: "f48f259e-37d9-4003-be97-7181858b98aa",
                            userId: "event1649788971974",
                        },
                        role: "location",
                    },
                    {
                        key: {
                            tenantId: "f48f259e-37d9-4003-be97-7181858b98aa",
                            userId: "event1649789298650",
                        },
                        role: "location",
                    },
                    {
                        key: {
                            tenantId: "f48f259e-37d9-4003-be97-7181858b98aa",
                            userId: "event1649789298650",
                        },
                        role: "location",
                    },
                    {
                        key: {
                            tenantId: "f48f259e-37d9-4003-be97-7181858b98aa",
                            userId: "event1649789510007",
                        },
                        role: "location",
                    },
                    {
                        key: {
                            tenantId: "f48f259e-37d9-4003-be97-7181858b98aa",
                            userId: "event1649789696173",
                        },
                        role: "location",
                    },
                    {
                        key: {
                            tenantId: "f48f259e-37d9-4003-be97-7181858b98aa",
                            userId: "event1649789901628",
                        },
                        role: "location",
                    },
                    {
                        key: {
                            tenantId: "f48f259e-37d9-4003-be97-7181858b98aa",
                            userId: "event1649863798490",
                        },
                        role: "location",
                    },
                    {
                        key: {
                            tenantId: "f48f259e-37d9-4003-be97-7181858b98aa",
                            userId: "event1649864026900",
                        },
                        role: "location",
                    },
                    {
                        key: {
                            tenantId: "f48f259e-37d9-4003-be97-7181858b98aa",
                            userId: "event1649864140838",
                        },
                        role: "location",
                    },
                    {
                        key: {
                            tenantId: "f48f259e-37d9-4003-be97-7181858b98aa",
                            userId: "event1647368940289",
                        },
                    },
                    {
                        key: {
                            tenantId: "f48f259e-37d9-4003-be97-7181858b98aa",
                            userId: "event1647368940289",
                        },
                    },
                    {
                        key: {
                            tenantId: "f48f259e-37d9-4003-be97-7181858b98aa",
                            userId: "event1647365654337",
                        },
                    },
                    {
                        key: {
                            tenantId: "f48f259e-37d9-4003-be97-7181858b98aa",
                            userId: "event1647365654337",
                        },
                    },
                    {
                        key: {
                            tenantId: "f48f259e-37d9-4003-be97-7181858b98aa",
                            userId: "event1647365654337",
                        },
                    },
                    {
                        key: {
                            tenantId: "f48f259e-37d9-4003-be97-7181858b98aa",
                            userId: "event1656024754673",
                        },
                        role: "location",
                    },
                    {
                        key: {
                            tenantId: "f48f259e-37d9-4003-be97-7181858b98aa",
                            userId: "event1656025310336",
                        },
                        role: "location",
                    },
                    {
                        key: {
                            tenantId: "f48f259e-37d9-4003-be97-7181858b98aa",
                            userId: "event1664556591573",
                        },
                        role: "location",
                    },
                    {
                        key: {
                            userId: "event1664569210019",
                        },
                        role: "location",
                    },
                    {
                        key: {
                            tenantId: "f48f259e-37d9-4003-be97-7181858b98aa",
                            userId: "event1664569326945",
                        },
                        role: "location",
                    },
                ],
                address: {
                    streetAddress1: "891 5th Avenue",
                    streetAddress2: "",
                    cityStateZip: "New York, NY,  10018",
                },
                name: "Avengers Compound",
            },
            {
                role: "location",
                contacts: [
                    {
                        tenantId: "f48f259e-37d9-4003-be97-7181858b98aa",
                        userId: "87da40f6-7074-494f-b04f-b6f779b51c8b",
                    },
                ],
                vendorCategory: "location",
                userId: "location1647368561067",
                tenantId: "f48f259e-37d9-4003-be97-7181858b98aa",
                associatedEvents: [
                    {
                        key: {
                            tenantId: "f48f259e-37d9-4003-be97-7181858b98aa",
                            userId: "event1649788277666",
                        },
                        role: "location",
                    },
                    {
                        key: {
                            tenantId: "f48f259e-37d9-4003-be97-7181858b98aa",
                            userId: "event1649788567110",
                        },
                        role: "location",
                    },
                    {
                        key: {
                            tenantId: "f48f259e-37d9-4003-be97-7181858b98aa",
                            userId: "event1649788723748",
                        },
                        role: "location",
                    },
                    {
                        key: {
                            tenantId: "f48f259e-37d9-4003-be97-7181858b98aa",
                            userId: "event1649788971974",
                        },
                        role: "location",
                    },
                    {
                        key: {
                            tenantId: "f48f259e-37d9-4003-be97-7181858b98aa",
                            userId: "event1649789298650",
                        },
                        role: "location",
                    },
                    {
                        key: {
                            tenantId: "f48f259e-37d9-4003-be97-7181858b98aa",
                            userId: "event1649789298650",
                        },
                        role: "location",
                    },
                    {
                        key: {
                            tenantId: "f48f259e-37d9-4003-be97-7181858b98aa",
                            userId: "event1649789510007",
                        },
                        role: "location",
                    },
                    {
                        key: {
                            tenantId: "f48f259e-37d9-4003-be97-7181858b98aa",
                            userId: "event1649789696173",
                        },
                        role: "location",
                    },
                    {
                        key: {
                            tenantId: "f48f259e-37d9-4003-be97-7181858b98aa",
                            userId: "event1649789901628",
                        },
                        role: "location",
                    },
                    {
                        key: {
                            tenantId: "f48f259e-37d9-4003-be97-7181858b98aa",
                            userId: "event1649863798490",
                        },
                        role: "location",
                    },
                    {
                        key: {
                            tenantId: "f48f259e-37d9-4003-be97-7181858b98aa",
                            userId: "event1649864026900",
                        },
                        role: "location",
                    },
                    {
                        key: {
                            tenantId: "f48f259e-37d9-4003-be97-7181858b98aa",
                            userId: "event1649864140838",
                        },
                        role: "location",
                    },
                    {
                        key: {
                            tenantId: "f48f259e-37d9-4003-be97-7181858b98aa",
                            userId: "event1647368940289",
                        },
                    },
                    {
                        key: {
                            tenantId: "f48f259e-37d9-4003-be97-7181858b98aa",
                            userId: "event1647368940289",
                        },
                    },
                    {
                        key: {
                            tenantId: "f48f259e-37d9-4003-be97-7181858b98aa",
                            userId: "event1647365654337",
                        },
                    },
                    {
                        key: {
                            tenantId: "f48f259e-37d9-4003-be97-7181858b98aa",
                            userId: "event1647365654337",
                        },
                    },
                    {
                        key: {
                            tenantId: "f48f259e-37d9-4003-be97-7181858b98aa",
                            userId: "event1647365654337",
                        },
                    },
                    {
                        key: {
                            tenantId: "f48f259e-37d9-4003-be97-7181858b98aa",
                            userId: "event1656024754673",
                        },
                        role: "location",
                    },
                    {
                        key: {
                            tenantId: "f48f259e-37d9-4003-be97-7181858b98aa",
                            userId: "event1656025310336",
                        },
                        role: "location",
                    },
                    {
                        key: {
                            tenantId: "f48f259e-37d9-4003-be97-7181858b98aa",
                            userId: "event1664556591573",
                        },
                        role: "location",
                    },
                    {
                        key: {
                            userId: "event1664569210019",
                        },
                        role: "location",
                    },
                    {
                        key: {
                            tenantId: "f48f259e-37d9-4003-be97-7181858b98aa",
                            userId: "event1664569326945",
                        },
                        role: "location",
                    },
                ],
                address: {
                    streetAddress1: "891 5th Avenue",
                    streetAddress2: "",
                    cityStateZip: "New York, NY,  10018",
                },
                name: "Avengers Compound",
            },
        ],
        contacts: [
            {
                phoneNumber: "1234567894",
                tenantId: "f48f259e-37d9-4003-be97-7181858b98aa",
                given_name: "Tony",
                createdAt: "2022-03-15T18:22:41.622Z",
                family_name: "Stark",
                email: "tony.stark@simplecitysoftware.com",
                conversations: [
                    {
                        id: "1655489927039",
                        sortKey: "f48f259e-37d9-4003-be97-7181858b98aa",
                    },
                ],
                role: "client",
                pronoun: "Mr.",
                profilePicture:
                    "https://spindjappstorage140016-prod.s3.amazonaws.com/public/f48f259e-37d9-4003-be97-7181858b98aa1656115623113",
                userId: "87da40f6-7074-494f-b04f-b6f779b51c8b",
                associatedEvents: [
                    {
                        key: {
                            tenantId: "f48f259e-37d9-4003-be97-7181858b98aa",
                            userId: "event1648165291492",
                        },
                        role: "client",
                    },
                    {
                        key: {
                            tenantId: "f48f259e-37d9-4003-be97-7181858b98aa",
                            userId: "event1649788567110",
                        },
                        role: "client",
                    },
                    {
                        key: {
                            tenantId: "f48f259e-37d9-4003-be97-7181858b98aa",
                            userId: "event1649788723748",
                        },
                        role: "client",
                    },
                    {
                        key: {
                            tenantId: "f48f259e-37d9-4003-be97-7181858b98aa",
                            userId: "event1649788971974",
                        },
                        role: "client",
                    },
                    {
                        key: {
                            tenantId: "f48f259e-37d9-4003-be97-7181858b98aa",
                            userId: "event1649789298650",
                        },
                        role: "client",
                    },
                    {
                        key: {
                            tenantId: "f48f259e-37d9-4003-be97-7181858b98aa",
                            userId: "event1649789298650",
                        },
                        role: "client",
                    },
                    {
                        key: {
                            tenantId: "f48f259e-37d9-4003-be97-7181858b98aa",
                            userId: "event1649789510007",
                        },
                        role: "client",
                    },
                    {
                        key: {
                            tenantId: "f48f259e-37d9-4003-be97-7181858b98aa",
                            userId: "event1649789696173",
                        },
                        role: "client",
                    },
                    {
                        key: {
                            tenantId: "f48f259e-37d9-4003-be97-7181858b98aa",
                            userId: "event1649789901628",
                        },
                        role: "client",
                    },
                    {
                        key: {
                            tenantId: "f48f259e-37d9-4003-be97-7181858b98aa",
                            userId: "event1649863798490",
                        },
                        role: "client",
                    },
                    {
                        key: {
                            tenantId: "f48f259e-37d9-4003-be97-7181858b98aa",
                            userId: "event1649864026900",
                        },
                        role: "client",
                    },
                    {
                        key: {
                            tenantId: "f48f259e-37d9-4003-be97-7181858b98aa",
                            userId: "event1649864140838",
                        },
                        role: "client",
                    },
                    {
                        key: {
                            tenantId: "f48f259e-37d9-4003-be97-7181858b98aa",
                            userId: "event1647365654337",
                        },
                        role: "client",
                    },
                    {
                        key: {
                            tenantId: "f48f259e-37d9-4003-be97-7181858b98aa",
                            userId: "event1664556591573",
                        },
                        role: "client",
                    },
                    {
                        key: {
                            tenantId: "f48f259e-37d9-4003-be97-7181858b98aa",
                            userId: "event1647369651738",
                        },
                        role: "client",
                    },
                    {
                        key: {
                            tenantId: "f48f259e-37d9-4003-be97-7181858b98aa",
                            userId: "event1649788277666",
                        },
                        role: "client",
                    },
                ],
                username: "tony.stark@simplecitysoftware.com",
            },
        ],
        contracts: [
            {
                contractBody:
                    " WITNESSETH NOW THEREFORE\n\nA {invoice-deposit-amount} non-refundable security deposit is required when booking your event. This deposit is deducted from your total event cost and will show in your invoice statement. In consideration of the payment by {client-list}, (hereafter referred to as the Purchaser(s)) of {invoice-total} as well as the various promises and the agreements set forth below, the Parties agree and intend to be legally bound as follows:<br/><br/>\n\n 1. Lauryn Cole Investments, LLC DBA {business-name}, hereafter referred to as 'The DJ Service' shall provide up to {event-length} for the Purchaser(s) at the agreed upon venue(s) ({location-list}).<br/><br/>\n\n 2. The DJ Service, referenced in Paragraph 1, shall be provided and accepted on the entered date and time of the engagement.\n<br/><br/>\n 3. The DJ Service, referenced in Paragraph 1 shall consist primarily of providing musical entertainment by means of a downloaded MP3 music format.\n<br/><br/>\n 4. The DJ Service shall, at all times, have unmitigated control of its DJ Services.\n<br/><br/>\n 5. In the event that additional hours of DJ Services are requested after the finish time this agreement is executed, and The DJ Service accepts said request, additional DJ Services will be charged at the rate of $100 per hour, payable the day of the engagement.The parties understand and agree that it may not always be possible to provide additional performance time; The DJ Service is under no obligation to accept an offer to purchase additional hours of DJ Services.\n<br/><br/>\n\nADDITIONAL TERMS AND CONDITIONS:<br/><br/>\n\n\nThe agreement of the DJ to perform is subject to proven detention by accidents, transportation issues, riots, strikes, epidemics, any random acts of God, or any other legitimate conditions beyond their control. If such issues arise, all reasonable efforts will be made by The DJ Service to make it to the event or find replacement at the agreed upon fees. Should The DJ Service be unable to procure a replacement, Purchaser shall receive a full refund. Purchaser(s) agree that The DJ Service's liability shall not be liable in any amount of damage which exceeds the performance fee(s) recited above. Further, the Purchaser(s) agree that The DJ Service shall not be liable for indirect or consequential damages arising from any breach of contract. It is understood that, in the unlikely event that The DJ Service subcontracts services for your event and any liability issues or breach of this contract occurs, the subcontractor is the responsible party. The DJ Service is not responsible for the subcontracted services provided, equipment, or performance of services. Any and all issues, court costs, attorney fees and legal damages are the responsibility of the subcontractor, not The DJ Service. The Purchaser(s) and The DJ Service agree that this contract is not subject to cancellation unless both parties have agreed to such cancellation in writing. In the event of cancellation by the Purchaser(s) within 60 days of their event date, the Purchaser(s) shall pay the DJ the amount of $300.00 as liquidated damages, plus a reasonable attorney’s fee. If the Purchaser(s) cancel the event within 30 days of the set event date, the Purchaser(s) shall pay the The DJ Service the total agreed amount set forth on the contract as liquidated damages, lose their security deposit, plus a reasonable attorney’s fee. It is further agreed that the Purchaser shall be liable for any and all injury or damage to the The DJ Service, or property of The DJ Service, while on the premises of said engagement, if damage is caused by Purchaser or guest, members of his organization, engagement invitees, employees, or any other party in attendance, whether invited or not. It is understood that if this is a Rain or Shine event; The DJ Service‘s compensation is in no way affected by inclement weather. For outdoor performances, Purchaser shall provide overhead shelter for setup area. The DJ reserves the right, in good faith, to stop or cancel the performance should the weather pose a potential danger to him, the equipment, or audience. every effort will be made to continue the performance. However, safety is paramount in all decisions. The DJ’s compensation will not be affected by such cancellation.In the event of circumstances deemed to present a threat or implied threat of injury or harm The DJ Service staff or any equipment in  The DJ Service possession, The DJ Service reserves the right to cease performance. If the Purchaser is able to resolve the threatening situation in a reasonable amount of time (maximum of 15 minutes), The DJ Service shall resume performance in accordance with the original terms of this agreement. Purchaser shall be responsible for payment in full, regardless of whether the situation is resolved or whether  The DJ Service resumes performance. In order to prevent equipment damage or liability arising from accidental injury to any individual attending this performance,  The DJ Servicereserves the right to deny any guest access to the sound system, music recordings, or other equipment. Purchaser shall provide  The DJ Service with safe and appropriate working conditions. This includes a 10-foot by 10-foot area for setup, space for setting up speakers and lighting stands. The DJ Service requires a minimum of one 15-20-amp circuit outlet from a reliable power source within 25 feet (along the wall) of the set-up area. This circuit must be free of all other connected loads. Any delay in the performance or damage to DJ’s equipment due to improper power is the responsibility of the purchaser. Two circuits are preferred, where possible. Additional outlets on separate circuits for lighting (if contracted for) are required. Purchaser shall provide crowd control if warranted; and furnishing directions to place of engagement. Purchaser is responsible for paying any charges imposed by the venue. These charges may include, but are not limited to, parking and use of electric power. A written event/music planner or music request list must be received from the Purchaser and forwarded to The DJ Service not less than 1 month prior to the date of the engagement for it to be included in The DJ Service programming outline. The DJ Service will attempt to play Purchaser’s and Purchaser’s guests’ music requests, conditioned upon availability. In the event of non-payment,  The DJ Service retains the right to attempt collection through the courts. Purchaser agrees to be held responsible for all court costs, legal fees, and collection costs incurred by  The DJ Service. Purchaser shall be charged $30 for each returned check. It is agreed that Missouri law shall control all aspects of this Agreement. Purchasers agree to make all necessary arrangements to provide the DJ with access to the event venue not less than 2 hours before the engagement and 1 hour after the engagement for setup and takedown.  The DJ Service also requests ramp or elevator access between the parking/service entrance and the setup area. If Purchaser or venue requires  The DJ Service to complete setup more than 2 hours before the start time, or to postpone takedown more than 1 hour after the end time indicated, the additional time will be charged at the rate of $100.00 per hour.\n\n\nSPECIAL PROVISIONS AND SERVICES REQUESTED\n\n\nBy executing this contract as Purchaser, the person executing said contract, either individually, or as an agent or representative, represents and warrants that he or she is eighteen (18) years of age, and further, if executing said contract as agent or representative, that he or she has the authority to enter into this agreement and should he or she not have such authority, he or she personally accepts and assumes full responsibility and liability under the terms of this contract. This document, together with any attachments initialed by the parties, shall constitute THE ENTIRE AGREEMENT of the parties. If any part of this contract is illegal or unenforceable, the remaining provisions of this contract will remain valid and enforceable as to both parties. Again, this document contains the entire agreement between the parties and no statement, promises, or inducements made by any party hereto, or agent or representative or either party hereto, which are not contained in this written contract, shall be valid or binding. This contract shall not be enlarged, modified, or altered except in writing by both parties and endorsed hereon. The laws of the State of Missouri shall govern this agreement. In the event that legal proceedings are initiated by either party, it is agreed that proper venue shall be in St. Charles County. Purchaser(s) agree to indemnify, defend, assume liability for and hold The DJ Company harmless from any claims, damages, losses and expenses by or to any person, regardless of the basis, which pertains directly or indirectly to The DJ Company’s performance. In the event that a civil action arises in an effort to enforce any provision of this agreement, the losing party shall pay the attorney’s fee and court costs of the prevailing party. Purchaser(s) may not transfer or assign this contract to another party without the prior written consent of The DJ Company . THE PARTIES acknowledge that they have read the above Agreement in its entirety, understand all of its terms and conditions, have had an opportunity to review the same with legal counsel, and agree to abide by the terms of this agreement of his/her own free will and consent.",
                signerUUID: "87da40f6-7074-494f-b04f-b6f779b51c8b",
                admin: {},
                contractName: "Standard DJ Contract",
                id: "contract1642442940375",
                signerDate: "2022-04-22T21:47:30.363Z",
                signerName: "Tony Stark",
                status: "signed",
            },
        ],
        data: {
            date: new Date(today.getFullYear(), today.getMonth() + 9, today.getDate() + 4, 12, 0),
            startTime: new Date(today.getFullYear(), today.getMonth() + 9, today.getDate() + 4, 12, 0),
            endTime: new Date(today.getFullYear(), today.getMonth() + 9, today.getDate() + 4, 16, 45),
        },
        userId: "event1649789298650",
        tenantId: "f48f259e-37d9-4003-be97-7181858b98aa",
        forms: [],
        invoice: {
            adjustments: [],
            payments: [
                {
                    name: "ch_3LFVmAQwaGPb3gXM1PtB7vS6",
                    amount: 25000,
                },
                {
                    name: "ch_3LFVnKQwaGPb3gXM1gzByUiW",
                    amount: 41667,
                },
            ],
            products: [
                {
                    employeesRequired: 1,
                    priceOption: "Hourly",
                    equipmentNeeded: [],
                    name: "Wedding DJ",
                    photo:
                        "https://spindjappstorage140016-prod.s3.amazonaws.com/public/7e9b6fe0-0b16-4076-8171-a399992d876b1642443008952",
                    id: "service1642440375825",
                    contracts: ["contract1642442940375"],
                    type: "Service",
                    pricing: {
                        addHourly: 10000,
                        baseTime: 4,
                        baseRate: 150000,
                    },
                    forms: [
                        "form1642369072870",
                        "form1642378126707",
                        "form1642378681111",
                        "form1642440310328",
                        "form1642440335065",
                        "form1642435090229",
                    ],
                },
            ],
        },
        title: "Super Fun Event",
    },
];
